var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiteBuilt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1486,
    height: 1059,
    viewBox: "0 0 1486 1059",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_1627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.64 244.26C518.04 244.55 517.44 244.84 516.84 245.13",
    stroke: "#424EE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.64 248.599C431.95 286.049 353.84 324.729 288.43 380.819C259.62 405.529 233.11 434.069 217.33 468.589C193.38 520.989 196.86 583.819 221.2 636.039C245.54 688.259 289.29 730.089 339.86 757.699C376.73 777.829 417.11 790.819 454.2 810.549C509.66 840.049 557.9 884.629 618.3 901.909C716.36 929.969 821.93 877.569 891.9 803.359C942.37 749.839 981.87 683.609 1044.99 645.819C1094.4 616.239 1153.34 607.278 1205.79 583.478C1289.26 545.598 1356.14 461.139 1351.64 369.589C1348.23 300.319 1305.52 237.749 1251.41 194.359C1198.86 152.219 1136.05 125.379 1073.8 99.4785",
    stroke: "#424EE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.11 97.9594C1069.49 97.6994 1068.88 97.4495 1068.26 97.1895",
    stroke: "#424EE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.45 77.7C593.66 149.58 368.56 256.37 163.73 393.52C136.54 411.73 108.7 431.57 93.44 460.52C81.16 483.81 78.26 510.84 77.37 537.16C74.73 614.88 90.47 698.32 145.17 753.6C222.92 832.19 349.47 829.03 449.91 875.21C520.46 907.65 579.26 965.31 654.26 985.42C717.11 1002.27 785.85 990.04 842.86 958.67C899.87 927.3 945.68 877.93 979.38 822.26C1002.63 783.85 1021.03 741.57 1052.79 709.84C1094.55 668.11 1153.63 650.1 1209.22 630.21C1261.64 611.46 1313.66 589.44 1357.93 555.69C1402.2 521.93 1438.49 475.16 1450.46 420.79C1464.27 358.05 1444.48 291.96 1412.05 236.51C1326.27 89.89 1146.28 4.72005 978.52 31.3701",
    stroke: "#424EE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.66 390.989C378.97 415.299 326.04 422.189 302.33 461.249C294.53 474.099 291.02 489.059 288.25 503.839C279.07 552.879 277.83 607.139 305.4 648.719C332.88 690.169 382.44 709.869 428.15 729.459C474.5 749.319 519.89 771.429 564.11 795.679C605.07 818.139 650.61 843.329 695.87 831.729C738.36 820.839 765.83 781.189 792.43 746.299C865.57 650.349 960.1 570.799 1067.13 515.129C1110.06 492.799 1155.67 473.789 1191.68 441.479C1227.7 409.169 1252.86 359.129 1240.06 312.469C1232.06 283.319 1210.83 259.949 1190.28 237.779",
    stroke: "#424EE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.99 476.579V355.639L980.18 363.639L980.19 484.589L990.99 476.579Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.06 507.639V386.689L938.26 394.689V515.639L949.06 507.639Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.03 492.11V371.17L959.22 379.17V500.11L970.03 492.11Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.15 152.909L739.93 169.759L958.96 7.53906L1197.67 199.799V202.099L1190.13 207.689V328.629L1197.67 334.699V337.009L1196.39 337.959V364.659L571.45 827.519L333.99 636.279V462.169L511.61 330.609L517.58 335.419L556.36 306.699L511.61 270.659V261.429L689.23 129.879L719.15 152.909Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.23 130.34L926.68 321.58V330.81L749.07 462.36L511.61 271.11V261.89L689.23 130.34Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.66 228.3V107.35L832.86 115.35V236.3L843.66 228.3Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.7 237.489V122.479L811.9 130.479V228.789L822.7 237.489Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.74 220.6V139.25L790.94 147.25V211.9L801.74 220.6Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.78 203.718V154.318L769.97 162.318V195.018L780.78 203.718Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.81 185.719V169.809L749.01 177.819L759.81 185.719Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.63 212.768V91.8281L853.82 99.8281V220.768L864.63 212.768Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.59 197.249V76.2988L874.78 84.2988V205.249L885.59 197.249Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.55 181.719V60.7793L895.75 68.7793V189.719L906.55 181.719Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.51 45.25L916.71 53.25V174.2L927.51 166.19V45.25Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.47 150.669V29.7188L937.67 37.7288V158.669L948.47 150.669Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.01 150.999L978.74 158.839V38.3888L969.01 30.5488V150.999Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.11 167.188L998.84 175.028V54.5783L989.11 46.7383V167.188Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.21 183.38L1018.94 191.22V70.7697L1009.21 62.9297V183.38Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.31 199.569L1039.04 207.409V86.9591L1029.31 79.1191V199.569Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.42 215.759L1059.14 223.599V103.149L1049.42 95.3086V215.759Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.25 119.34L1069.52 111.5V231.95L1079.25 239.79V119.34Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.62 248.139L1099.35 255.979V135.529L1089.62 127.689V248.139Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.76 200.289L1170.03 192.449V209.069L1179.76 201.869V200.289Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.65 216.76V184.1L1149.93 176.26V223.96L1159.65 216.76Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.55 231.648V167.908L1129.82 160.068V238.848L1139.55 231.648Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.45 151.719L1109.72 143.879V253.739L1119.45 246.529V151.719Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.76 269.998V262.488L1111.9 266.088L1116.76 269.998Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.82 280.519L1137.72 286.879V246.959L1129.82 252.809V280.519Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.93 296.71L1158.69 303.77V231.43L1149.93 237.92V296.71Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.03 312.898L1179.65 320.648V215.908L1170.03 223.028V312.898Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.65 336.848V328.768L1168.85 320.068V344.858L1179.65 336.848Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.69 352.38V311.88L1147.88 303.18V360.38L1158.69 352.38Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.72 367.899V294.999L1126.92 286.299V375.909L1137.72 367.899Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.76 383.429V278.119L1106.65 269.969L1105.96 270.489V391.429L1116.76 383.429Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.8 398.96V278.01L1085 286.01V406.96L1095.8 398.96Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.84 414.479V293.539L1064.03 301.539V422.479L1074.84 414.479Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.88 430.009V309.059L1043.07 317.059V438.009L1053.88 430.009Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.91 445.53V324.59L1022.11 332.59V453.53L1032.91 445.53Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.15 348.119V469.059L1011.95 461.059V340.109L1001.15 348.119Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.49 210.81C1221.68 210.68 1221.85 210.59 1222.05 210.5C1222.28 210.39 1222.56 210.28 1222.82 210.2C1223.08 210.12 1223.33 210.07 1223.57 210.04C1223.81 210.01 1224.03 210.01 1224.27 210.01C1224.51 210.01 1224.76 210.03 1225.02 210.06C1225.28 210.09 1225.54 210.13 1225.75 210.17C1225.96 210.21 1226.12 210.25 1226.26 210.29C1226.4 210.33 1226.54 210.38 1226.65 210.43C1226.76 210.48 1226.85 210.52 1226.95 210.57C1226.99 210.59 1227.03 210.62 1227.07 210.65C1227.13 210.7 1227.19 210.75 1227.25 210.83C1227.27 210.83 1227.29 210.84 1227.31 210.85C1227.43 210.89 1227.58 210.97 1227.75 211.07C1227.92 211.17 1228.09 211.31 1228.35 211.62C1228.52 211.73 1228.66 211.83 1228.88 212.04C1229.11 212.26 1229.42 212.59 1229.67 212.94C1229.92 213.29 1230.11 213.65 1230.27 214.04C1230.43 214.43 1230.55 214.83 1230.64 215.19C1230.72 215.54 1230.77 215.84 1230.81 216.09C1230.85 216.34 1230.89 216.54 1230.94 216.86C1230.97 217.08 1231.01 217.37 1231.02 217.89C1231.03 217.89 1231.04 217.9 1231.05 217.91C1231.36 218.11 1231.46 218.22 1231.53 218.3C1231.6 218.38 1231.62 218.43 1231.64 218.49C1231.66 218.55 1231.67 218.61 1231.66 218.72C1231.66 218.83 1231.62 218.98 1231.59 219.09C1231.56 219.21 1231.53 219.29 1231.48 219.37C1231.43 219.45 1231.38 219.51 1231.31 219.58C1231.24 219.65 1231.17 219.72 1230.63 219.98C1230.43 220.08 1230.16 220.2 1229.79 220.34C1229.05 220.63 1227.9 221.03 1226.88 221.39C1225.86 221.74 1224.99 222.05 1224.31 222.26C1223.63 222.48 1223.16 222.6 1222.75 222.67C1222.34 222.74 1222 222.76 1221.66 222.75C1221.33 222.75 1221 222.71 1220.71 222.67C1220.42 222.63 1220.15 222.58 1219.53 222.43C1218.91 222.28 1217.93 222.02 1217.24 221.81C1216.55 221.6 1216.14 221.44 1215.84 221.29C1215.54 221.14 1215.36 220.99 1215.24 220.86C1215.12 220.73 1215.06 220.61 1215.02 220.47C1214.98 220.33 1214.96 220.16 1214.98 219.99C1215 219.82 1215.06 219.63 1215.17 219.39C1215.28 219.15 1215.42 218.85 1215.57 218.61C1215.72 218.37 1215.86 218.2 1216.1 217.94C1216.34 217.68 1216.68 217.33 1217.06 217.06C1217.08 217.05 1217.1 217.03 1217.12 217.02C1217.25 216.41 1217.45 215.78 1217.69 215.28C1217.72 215.16 1217.75 215.03 1217.79 214.89C1217.9 214.49 1218.09 213.99 1218.29 213.59C1218.49 213.19 1218.7 212.89 1218.97 212.59C1219.24 212.29 1219.55 211.99 1219.93 211.69C1220.31 211.39 1220.73 211.11 1221.5 210.84L1221.49 210.81Z",
    fill: "white",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.2 317.561L1261.12 317.681",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.92 221.16C1226.92 221.16 1226.83 221.19 1226.79 221.21C1226.45 221.33 1226.11 221.45 1225.76 221.57C1225.46 221.67 1225.16 221.78 1224.86 221.88C1224.61 221.96 1224.36 222.05 1224.1 222.13C1223.9 222.19 1223.69 222.25 1223.49 222.31C1223.32 222.36 1223.16 222.4 1222.99 222.43C1222.85 222.46 1222.7 222.49 1222.56 222.51C1222.43 222.53 1222.3 222.54 1222.17 222.55C1222.05 222.55 1221.93 222.56 1221.81 222.55C1221.69 222.55 1221.58 222.55 1221.46 222.54C1221.35 222.54 1221.23 222.52 1221.12 222.51C1221.01 222.5 1220.9 222.49 1220.8 222.47C1220.74 222.47 1220.68 222.45 1220.62 222.44C1220.57 222.44 1220.51 222.42 1220.46 222.41C1220.4 222.4 1220.34 222.39 1220.28 222.38C1220.12 222.35 1219.97 222.31 1219.81 222.28C1219.67 222.25 1219.54 222.21 1219.41 222.18C1219.14 222.11 1218.87 222.04 1218.6 221.97C1218.31 221.89 1218.02 221.81 1217.73 221.73C1217.48 221.66 1217.23 221.59 1216.99 221.51C1216.8 221.45 1216.62 221.39 1216.44 221.32C1216.3 221.27 1216.17 221.21 1216.04 221.15C1215.97 221.12 1215.9 221.08 1215.83 221.04C1215.79 221.02 1215.74 220.99 1215.7 220.96C1215.63 220.92 1215.56 220.87 1215.5 220.81C1215.45 220.77 1215.4 220.72 1215.36 220.67C1215.33 220.63 1215.29 220.59 1215.26 220.55C1215.24 220.51 1215.21 220.47 1215.2 220.43C1215.2 220.41 1215.18 220.39 1215.18 220.37C1215.17 220.34 1215.16 220.3 1215.15 220.27C1215.13 220.17 1215.12 220.06 1215.13 219.96C1215.13 219.92 1215.13 219.88 1215.14 219.84C1215.14 219.81 1215.15 219.78 1215.16 219.75C1215.18 219.68 1215.2 219.62 1215.22 219.55C1215.23 219.51 1215.25 219.48 1215.26 219.44C1215.28 219.4 1215.29 219.36 1215.31 219.32C1215.35 219.23 1215.39 219.14 1215.44 219.05C1215.49 218.96 1215.53 218.86 1215.58 218.77C1215.62 218.69 1215.67 218.61 1215.71 218.54C1215.73 218.5 1215.76 218.46 1215.79 218.42C1215.82 218.38 1215.84 218.35 1215.87 218.31C1215.9 218.27 1215.93 218.24 1215.96 218.2C1216.03 218.12 1216.1 218.04 1216.17 217.96C1216.21 217.91 1216.26 217.87 1216.3 217.82C1216.35 217.77 1216.4 217.72 1216.45 217.67C1216.56 217.56 1216.67 217.45 1216.78 217.35C1216.84 217.3 1216.9 217.24 1216.96 217.19C1217.01 217.15 1217.07 217.11 1217.12 217.07",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.92 221.16C1226.92 221.16 1226.83 221.19 1226.79 221.21C1226.45 221.33 1226.11 221.45 1225.76 221.57C1225.46 221.67 1225.16 221.78 1224.86 221.88C1224.61 221.96 1224.36 222.05 1224.1 222.13C1223.9 222.19 1223.69 222.25 1223.49 222.31C1223.32 222.36 1223.16 222.4 1222.99 222.43C1222.85 222.46 1222.7 222.49 1222.56 222.51C1222.43 222.53 1222.3 222.54 1222.17 222.55C1222.05 222.55 1221.93 222.56 1221.81 222.55C1221.69 222.55 1221.58 222.55 1221.46 222.54C1221.35 222.54 1221.23 222.52 1221.12 222.51C1221.01 222.5 1220.9 222.49 1220.8 222.47C1220.74 222.47 1220.68 222.45 1220.62 222.44C1220.57 222.44 1220.51 222.42 1220.46 222.41C1220.4 222.4 1220.34 222.39 1220.28 222.38C1220.12 222.35 1219.97 222.31 1219.81 222.28C1219.67 222.25 1219.54 222.21 1219.41 222.18C1219.14 222.11 1218.87 222.04 1218.6 221.97C1218.31 221.89 1218.02 221.81 1217.73 221.73C1217.48 221.66 1217.23 221.59 1216.99 221.51C1216.8 221.45 1216.62 221.39 1216.44 221.32C1216.3 221.27 1216.17 221.21 1216.04 221.15C1215.97 221.12 1215.9 221.08 1215.83 221.04C1215.79 221.02 1215.74 220.99 1215.7 220.96C1215.63 220.92 1215.56 220.87 1215.5 220.81C1215.45 220.77 1215.4 220.72 1215.36 220.67C1215.33 220.63 1215.29 220.59 1215.26 220.55C1215.24 220.51 1215.21 220.47 1215.2 220.43C1215.2 220.41 1215.18 220.39 1215.18 220.37C1215.17 220.34 1215.16 220.3 1215.15 220.27C1215.13 220.17 1215.12 220.06 1215.13 219.96C1215.13 219.92 1215.13 219.88 1215.14 219.84C1215.14 219.81 1215.15 219.78 1215.16 219.75C1215.18 219.68 1215.2 219.62 1215.22 219.55C1215.23 219.51 1215.25 219.48 1215.26 219.44C1215.28 219.4 1215.29 219.36 1215.31 219.32C1215.35 219.23 1215.39 219.14 1215.44 219.05C1215.49 218.96 1215.53 218.86 1215.58 218.77C1215.62 218.69 1215.67 218.61 1215.71 218.54C1215.73 218.5 1215.76 218.46 1215.79 218.42C1215.82 218.38 1215.84 218.35 1215.87 218.31C1215.9 218.27 1215.93 218.24 1215.96 218.2C1216.03 218.12 1216.1 218.04 1216.17 217.96C1216.21 217.91 1216.26 217.87 1216.3 217.82C1216.35 217.77 1216.4 217.72 1216.45 217.67C1216.56 217.56 1216.67 217.45 1216.78 217.35C1216.84 217.3 1216.9 217.24 1216.96 217.19C1217.01 217.15 1217.07 217.11 1217.12 217.07",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.92 221.159C1228.75 220.429 1229.79 219.949 1230.38 219.659C1230.97 219.369 1231.11 219.269 1231.22 219.169C1231.33 219.069 1231.41 218.969 1231.46 218.849C1231.51 218.739 1231.52 218.609 1231.51 218.519C1231.51 218.429 1231.47 218.369 1231.4 218.289C1231.34 218.209 1231.24 218.109 1231.02 217.949",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.92 221.159C1228.75 220.429 1229.79 219.949 1230.38 219.659C1230.97 219.369 1231.11 219.269 1231.22 219.169C1231.33 219.069 1231.41 218.969 1231.46 218.849C1231.51 218.739 1231.52 218.609 1231.51 218.519C1231.51 218.429 1231.47 218.369 1231.4 218.289C1231.34 218.209 1231.24 218.109 1231.02 217.949",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.64 219.97C1230.44 220.07 1230.17 220.19 1229.8 220.33C1229.06 220.62 1227.91 221.02 1226.89 221.38C1225.87 221.73 1225 222.04 1224.32 222.25C1223.64 222.47 1223.17 222.59 1222.76 222.66C1222.35 222.73 1222.01 222.75 1221.67 222.74C1221.34 222.74 1221.01 222.7 1220.72 222.66C1220.43 222.62 1220.16 222.57 1219.54 222.42C1218.92 222.27 1217.94 222.01 1217.25 221.8C1216.56 221.59 1216.15 221.43 1215.85 221.28C1215.55 221.13 1215.37 220.98 1215.25 220.85C1215.13 220.72 1215.07 220.6 1215.03 220.46C1214.99 220.32 1214.97 220.15 1214.99 219.98C1215.01 219.81 1215.07 219.62 1215.18 219.38C1215.29 219.14 1215.43 218.84 1215.58 218.6C1215.73 218.36 1215.87 218.19 1216.11 217.93C1216.35 217.67 1216.69 217.32 1217.07 217.05C1217.09 217.04 1217.11 217.02 1217.13 217.01",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.64 219.97C1230.44 220.07 1230.17 220.19 1229.8 220.33C1229.06 220.62 1227.91 221.02 1226.89 221.38C1225.87 221.73 1225 222.04 1224.32 222.25C1223.64 222.47 1223.17 222.59 1222.76 222.66C1222.35 222.73 1222.01 222.75 1221.67 222.74C1221.34 222.74 1221.01 222.7 1220.72 222.66C1220.43 222.62 1220.16 222.57 1219.54 222.42C1218.92 222.27 1217.94 222.01 1217.25 221.8C1216.56 221.59 1216.15 221.43 1215.85 221.28C1215.55 221.13 1215.37 220.98 1215.25 220.85C1215.13 220.72 1215.07 220.6 1215.03 220.46C1214.99 220.32 1214.97 220.15 1214.99 219.98C1215.01 219.81 1215.07 219.62 1215.18 219.38C1215.29 219.14 1215.43 218.84 1215.58 218.6C1215.73 218.36 1215.87 218.19 1216.11 217.93C1216.35 217.67 1216.69 217.32 1217.07 217.05C1217.09 217.04 1217.11 217.02 1217.13 217.01",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.02 217.869C1231.02 217.869 1231.04 217.879 1231.05 217.889C1231.36 218.089 1231.46 218.199 1231.53 218.279C1231.6 218.359 1231.62 218.409 1231.64 218.469C1231.66 218.529 1231.67 218.589 1231.66 218.699C1231.66 218.809 1231.62 218.959 1231.59 219.069C1231.56 219.189 1231.53 219.269 1231.48 219.349C1231.43 219.429 1231.38 219.489 1231.31 219.559C1231.24 219.629 1231.17 219.699 1230.63 219.959",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.02 217.869C1231.02 217.869 1231.04 217.879 1231.05 217.889C1231.36 218.089 1231.46 218.199 1231.53 218.279C1231.6 218.359 1231.62 218.409 1231.64 218.469C1231.66 218.529 1231.67 218.589 1231.66 218.699C1231.66 218.809 1231.62 218.959 1231.59 219.069C1231.56 219.189 1231.53 219.269 1231.48 219.349C1231.43 219.429 1231.38 219.489 1231.31 219.559C1231.24 219.629 1231.17 219.699 1230.63 219.959",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.43 218.75L1229.21 219.12",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.43 218.75C1230.71 218.82 1230.75 218.84 1230.77 218.89C1230.79 218.94 1230.78 219.02 1230.73 219.43",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.43 218.75C1230.71 218.82 1230.75 218.84 1230.77 218.89C1230.79 218.94 1230.78 219.02 1230.73 219.43",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.21 219.119C1229.16 219.839 1229.19 219.919 1229.25 219.989C1229.31 220.059 1229.41 220.129 1230.72 219.439",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.21 219.119C1229.16 219.839 1229.19 219.919 1229.25 219.989C1229.31 220.059 1229.41 220.129 1230.72 219.439",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.41 220.569C1224.58 219.919 1224.83 219.109 1225.16 218.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.41 220.569C1224.58 219.919 1224.83 219.109 1225.16 218.129",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.21 220.471C1226.48 220.601 1226.12 220.611 1225.77 220.601C1225.42 220.601 1225.1 220.571 1224.42 220.571",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.21 220.471C1226.48 220.601 1226.12 220.611 1225.77 220.601C1225.42 220.601 1225.1 220.571 1224.42 220.571",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.28 217.65C1225.06 217.94 1224.84 218.45 1224.69 218.83C1224.54 219.21 1224.46 219.46 1224.4 219.66C1224.34 219.86 1224.3 220 1224.28 220.14C1224.26 220.28 1224.26 220.42 1224.41 220.57",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.28 217.65C1225.06 217.94 1224.84 218.45 1224.69 218.83C1224.54 219.21 1224.46 219.46 1224.4 219.66C1224.34 219.86 1224.3 220 1224.28 220.14C1224.26 220.28 1224.26 220.42 1224.41 220.57",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.47 217.619C1226.66 217.899 1226.85 218.599 1226.99 219.169C1227.13 219.739 1227.21 220.189 1227.21 220.469",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.47 217.619C1226.66 217.899 1226.85 218.599 1226.99 219.169C1227.13 219.739 1227.21 220.189 1227.21 220.469",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.36 211.61C1228.1 211.3 1227.92 211.16 1227.76 211.06C1227.59 210.96 1227.44 210.88 1227.32 210.84C1227.3 210.84 1227.28 210.83 1227.26 210.82",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.36 211.61C1228.1 211.3 1227.92 211.16 1227.76 211.06C1227.59 210.96 1227.44 210.88 1227.32 210.84C1227.3 210.84 1227.28 210.83 1227.26 210.82",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.07 210.65C1226.51 210.46 1226.22 210.45 1225.94 210.49C1225.65 210.53 1225.37 210.63 1225.08 210.84C1224.79 211.04 1224.5 211.35 1224.3 211.57C1224.1 211.8 1223.99 211.94 1223.85 212.19C1223.7 212.44 1223.51 212.78 1223.32 213.22C1223.12 213.66 1222.92 214.19 1222.76 214.79C1222.6 215.39 1222.48 216.06 1222.31 217.12C1222.14 218.18 1221.93 219.64 1221.79 220.67",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.07 210.65C1226.51 210.46 1226.22 210.45 1225.94 210.49C1225.65 210.53 1225.37 210.63 1225.08 210.84C1224.79 211.04 1224.5 211.35 1224.3 211.57C1224.1 211.8 1223.99 211.94 1223.85 212.19C1223.7 212.44 1223.51 212.78 1223.32 213.22C1223.12 213.66 1222.92 214.19 1222.76 214.79C1222.6 215.39 1222.48 216.06 1222.31 217.12C1222.14 218.18 1221.93 219.64 1221.79 220.67",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.99 217.85C1217.07 217.04 1217.33 216.01 1217.69 215.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.99 217.85C1217.07 217.04 1217.33 216.01 1217.69 215.26",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.49 210.811C1220.73 211.081 1220.3 211.361 1219.92 211.661C1219.54 211.961 1219.23 212.261 1218.96 212.561C1218.69 212.861 1218.48 213.161 1218.28 213.561C1218.08 213.961 1217.9 214.471 1217.78 214.861C1217.67 215.261 1217.62 215.541 1217.58 215.921C1217.54 216.301 1217.49 216.761 1217.41 217.271C1217.33 217.781 1217.2 218.331 1217 218.661",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.49 210.811C1220.73 211.081 1220.3 211.361 1219.92 211.661C1219.54 211.961 1219.23 212.261 1218.96 212.561C1218.69 212.861 1218.48 213.161 1218.28 213.561C1218.08 213.961 1217.9 214.471 1217.78 214.861C1217.67 215.261 1217.62 215.541 1217.58 215.921C1217.54 216.301 1217.49 216.761 1217.41 217.271C1217.33 217.781 1217.2 218.331 1217 218.661",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.25 210.83C1227.14 210.7 1227.04 210.63 1226.95 210.57C1226.85 210.51 1226.76 210.47 1226.65 210.43C1226.54 210.38 1226.4 210.33 1226.26 210.29C1226.12 210.25 1225.96 210.21 1225.75 210.17C1225.54 210.13 1225.28 210.09 1225.02 210.06C1224.76 210.03 1224.51 210.02 1224.27 210.01C1224.03 210.01 1223.81 210.01 1223.57 210.04C1223.33 210.07 1223.08 210.12 1222.82 210.2C1222.56 210.28 1222.29 210.39 1222.05 210.5C1221.82 210.61 1221.62 210.72 1221.38 210.89C1221.14 211.07 1220.86 211.31 1220.56 211.66C1220.27 212.01 1219.96 212.46 1219.71 212.87C1219.46 213.28 1219.27 213.66 1219.03 214.34C1218.79 215.02 1218.51 216.01 1218.35 216.7C1218.19 217.39 1218.15 217.77 1218.07 218.16C1217.99 218.55 1217.89 218.95 1217.46 219.61",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.25 210.83C1227.14 210.7 1227.04 210.63 1226.95 210.57C1226.85 210.51 1226.76 210.47 1226.65 210.43C1226.54 210.38 1226.4 210.33 1226.26 210.29C1226.12 210.25 1225.96 210.21 1225.75 210.17C1225.54 210.13 1225.28 210.09 1225.02 210.06C1224.76 210.03 1224.51 210.02 1224.27 210.01C1224.03 210.01 1223.81 210.01 1223.57 210.04C1223.33 210.07 1223.08 210.12 1222.82 210.2C1222.56 210.28 1222.29 210.39 1222.05 210.5C1221.82 210.61 1221.62 210.72 1221.38 210.89C1221.14 211.07 1220.86 211.31 1220.56 211.66C1220.27 212.01 1219.96 212.46 1219.71 212.87C1219.46 213.28 1219.27 213.66 1219.03 214.34C1218.79 215.02 1218.51 216.01 1218.35 216.7C1218.19 217.39 1218.15 217.77 1218.07 218.16C1217.99 218.55 1217.89 218.95 1217.46 219.61",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.01 218.699C1231.05 217.609 1230.99 217.169 1230.94 216.839C1230.89 216.519 1230.85 216.319 1230.81 216.069C1230.77 215.819 1230.73 215.519 1230.64 215.169C1230.56 214.819 1230.43 214.409 1230.27 214.019C1230.11 213.629 1229.92 213.269 1229.67 212.919C1229.42 212.569 1229.11 212.239 1228.88 212.019C1228.65 211.799 1228.5 211.699 1228.33 211.579C1228.15 211.459 1227.95 211.329 1227.75 211.259C1227.55 211.189 1227.37 211.169 1227.14 211.189C1226.92 211.209 1226.66 211.259 1226.46 211.319C1226.26 211.379 1226.1 211.459 1225.82 211.649C1225.54 211.839 1225.15 212.139 1224 213.289",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.01 218.699C1231.05 217.609 1230.99 217.169 1230.94 216.839C1230.89 216.519 1230.85 216.319 1230.81 216.069C1230.77 215.819 1230.73 215.519 1230.64 215.169C1230.56 214.819 1230.43 214.409 1230.27 214.019C1230.11 213.629 1229.92 213.269 1229.67 212.919C1229.42 212.569 1229.11 212.239 1228.88 212.019C1228.65 211.799 1228.5 211.699 1228.33 211.579C1228.15 211.459 1227.95 211.329 1227.75 211.259C1227.55 211.189 1227.37 211.169 1227.14 211.189C1226.92 211.209 1226.66 211.259 1226.46 211.319C1226.26 211.379 1226.1 211.459 1225.82 211.649C1225.54 211.839 1225.15 212.139 1224 213.289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.15 222.74C1222.15 223.22 1222.02 223.75 1222.33 223.98C1222.55 224.15 1223 224.15 1223.24 223.98C1223.5 223.79 1223.51 223.37 1223.66 223.07C1223.81 222.74 1224.11 222.54 1224.49 222.41C1224.91 222.27 1225.42 222.21 1225.65 222.41C1225.94 222.65 1225.82 223.28 1225.82 223.82C1225.82 224.55 1226.05 225.15 1225.9 225.73C1225.81 226.1 1225.56 226.47 1225.23 226.77C1224.99 226.99 1224.71 227.18 1224.65 227.48",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.15 222.74C1222.15 223.22 1222.02 223.75 1222.33 223.98C1222.55 224.15 1223 224.15 1223.24 223.98C1223.5 223.79 1223.51 223.37 1223.66 223.07C1223.81 222.74 1224.11 222.54 1224.49 222.41C1224.91 222.27 1225.42 222.21 1225.65 222.41C1225.94 222.65 1225.82 223.28 1225.82 223.82C1225.82 224.55 1226.05 225.15 1225.9 225.73C1225.81 226.1 1225.56 226.47 1225.23 226.77C1224.99 226.99 1224.71 227.18 1224.65 227.48",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.5 239.279C1198.44 239.259 1198.39 239.239 1198.33 239.219C1197.68 238.989 1196.99 238.929 1196.44 238.409C1196.2 238.179 1195.99 237.869 1195.72 237.869C1195.53 237.869 1195.3 238.039 1195.18 238.229C1194.77 238.859 1195.51 239.699 1195.36 240.389C1195.27 240.799 1194.87 241.149 1194.46 241.289C1194.02 241.439 1193.57 241.339 1193.11 241.379C1192.91 241.399 1192.7 241.439 1192.5 241.459",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.5 239.279C1198.44 239.259 1198.39 239.239 1198.33 239.219C1197.68 238.989 1196.99 238.929 1196.44 238.409C1196.2 238.179 1195.99 237.869 1195.72 237.869C1195.53 237.869 1195.3 238.039 1195.18 238.229C1194.77 238.859 1195.51 239.699 1195.36 240.389C1195.27 240.799 1194.87 241.149 1194.46 241.289C1194.02 241.439 1193.57 241.339 1193.11 241.379C1192.91 241.399 1192.7 241.439 1192.5 241.459",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.41 239.889C1210.41 239.889 1210.33 239.879 1210.3 239.869C1209.12 239.639 1207.88 239.849 1206.71 240.229C1205.66 240.569 1204.67 241.039 1203.6 241.189C1203.32 241.229 1203.04 241.239 1202.76 241.309",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.41 239.889C1210.41 239.889 1210.33 239.879 1210.3 239.869C1209.12 239.639 1207.88 239.849 1206.71 240.229C1205.66 240.569 1204.67 241.039 1203.6 241.189C1203.32 241.229 1203.04 241.239 1202.76 241.309",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.42 237.18C1215.31 237.2 1215.2 237.22 1215.09 237.24C1213.98 237.43 1212.75 237.57 1211.86 238.2C1211.09 238.74 1210.57 239.65 1210.07 240.47",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.42 237.18C1215.31 237.2 1215.2 237.22 1215.09 237.24C1213.98 237.43 1212.75 237.57 1211.86 238.2C1211.09 238.74 1210.57 239.65 1210.07 240.47",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.5 279.25C1227.5 279.25 1227.46 279.28 1227.44 279.29C1225.63 280.53 1223.41 281.15 1221.77 282.62C1219.94 284.26 1218.82 286.95 1216.6 287.79C1215.88 288.06 1215.05 288.13 1214.26 288.12C1214.13 288.12 1213.99 288.12 1213.86 288.12",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.5 279.25C1227.5 279.25 1227.46 279.28 1227.44 279.29C1225.63 280.53 1223.41 281.15 1221.77 282.62C1219.94 284.26 1218.82 286.95 1216.6 287.79C1215.88 288.06 1215.05 288.13 1214.26 288.12C1214.13 288.12 1213.99 288.12 1213.86 288.12",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.06 310.34C1218.11 310.43 1218.16 310.51 1218.21 310.6C1218.53 311.14 1218.55 312 1218.28 312.47C1217.74 313.38 1216.02 312.75 1214.61 312.61C1212.92 312.44 1211.68 312.97 1210.25 313.16C1208.97 313.33 1207.55 313.23 1206.31 313.23C1205.41 313.23 1204.61 313.28 1203.47 313.02C1203.06 312.93 1202.61 312.8 1202.57 312.54C1202.54 312.33 1202.75 312.05 1202.98 311.85C1203.33 311.55 1203.72 311.46 1204.09 311.3C1204.56 311.09 1205.01 310.75 1205.54 310.68C1205.8 310.65 1206.08 310.68 1206.3 310.54C1206.31 310.54 1206.33 310.52 1206.34 310.51",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.06 310.34C1218.11 310.43 1218.16 310.51 1218.21 310.6C1218.53 311.14 1218.55 312 1218.28 312.47C1217.74 313.38 1216.02 312.75 1214.61 312.61C1212.92 312.44 1211.68 312.97 1210.25 313.16C1208.97 313.33 1207.55 313.23 1206.31 313.23C1205.41 313.23 1204.61 313.28 1203.47 313.02C1203.06 312.93 1202.61 312.8 1202.57 312.54C1202.54 312.33 1202.75 312.05 1202.98 311.85C1203.33 311.55 1203.72 311.46 1204.09 311.3C1204.56 311.09 1205.01 310.75 1205.54 310.68C1205.8 310.65 1206.08 310.68 1206.3 310.54C1206.31 310.54 1206.33 310.52 1206.34 310.51",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.98 229.879C1226.12 230.779 1225.07 231.449 1224.07 232.209C1223.27 232.819 1222.51 233.469 1221.91 234.289C1221.74 234.519 1221.58 234.769 1221.49 235.039C1221.31 235.589 1221.42 236.229 1221.49 236.779C1221.56 237.279 1221.6 237.719 1221.57 238.359C1221.55 238.729 1221.52 239.169 1221.57 239.269C1221.67 239.449 1222.06 238.529 1222.4 237.859C1222.88 236.909 1223.25 236.449 1223.73 235.949C1224.3 235.349 1225.02 234.679 1225.73 234.039C1226.41 233.429 1227.07 232.849 1227.81 232.379C1228.15 232.159 1228.5 231.969 1228.89 231.799C1229.31 231.609 1229.78 231.439 1230.18 231.449C1231.39 231.479 1232.12 233.099 1232.79 234.459C1233.63 236.139 1234.39 237.439 1234.96 238.889C1235.82 241.099 1236.24 243.679 1236.54 246.199C1236.9 249.229 1237.11 252.169 1237.87 255.089C1238.17 256.249 1238.57 257.409 1238.5 258.609C1238.48 259.049 1238.39 259.499 1238.5 259.919C1238.6 260.439 1238.69 260.969 1238.79 261.489",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.98 229.879C1226.12 230.779 1225.07 231.449 1224.07 232.209C1223.27 232.819 1222.51 233.469 1221.91 234.289C1221.74 234.519 1221.58 234.769 1221.49 235.039C1221.31 235.589 1221.42 236.229 1221.49 236.779C1221.56 237.279 1221.6 237.719 1221.57 238.359C1221.55 238.729 1221.52 239.169 1221.57 239.269C1221.67 239.449 1222.06 238.529 1222.4 237.859C1222.88 236.909 1223.25 236.449 1223.73 235.949C1224.3 235.349 1225.02 234.679 1225.73 234.039C1226.41 233.429 1227.07 232.849 1227.81 232.379C1228.15 232.159 1228.5 231.969 1228.89 231.799C1229.31 231.609 1229.78 231.439 1230.18 231.449C1231.39 231.479 1232.12 233.099 1232.79 234.459C1233.63 236.139 1234.39 237.439 1234.96 238.889C1235.82 241.099 1236.24 243.679 1236.54 246.199C1236.9 249.229 1237.11 252.169 1237.87 255.089C1238.17 256.249 1238.57 257.409 1238.5 258.609C1238.48 259.049 1238.39 259.499 1238.5 259.919C1238.6 260.439 1238.69 260.969 1238.79 261.489",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.99 231.619C1220.11 231.659 1220.23 231.709 1220.35 231.749C1220.76 231.899 1220.9 232.399 1221.07 232.829C1221.22 233.209 1221.38 233.529 1221.43 233.909",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.99 231.619C1220.11 231.659 1220.23 231.709 1220.35 231.749C1220.76 231.899 1220.9 232.399 1221.07 232.829C1221.22 233.209 1221.38 233.529 1221.43 233.909",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.52 231.84C1220.46 231.93 1220.4 232.02 1220.35 232.11C1219.94 232.73 1219.24 233.28 1219.03 233.9C1218.76 234.74 1219.41 235.74 1218.79 236.89C1218.47 237.49 1217.81 238.13 1217.95 238.2C1218.07 238.26 1218.69 237.96 1219.03 237.6C1219.58 237.02 1219.39 236.28 1219.63 235.69C1219.83 235.19 1220.33 234.8 1220.83 234.49C1221.06 234.35 1221.3 234.22 1221.55 234.13",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.52 231.84C1220.46 231.93 1220.4 232.02 1220.35 232.11C1219.94 232.73 1219.24 233.28 1219.03 233.9C1218.76 234.74 1219.41 235.74 1218.79 236.89C1218.47 237.49 1217.81 238.13 1217.95 238.2C1218.07 238.26 1218.69 237.96 1219.03 237.6C1219.58 237.02 1219.39 236.28 1219.63 235.69C1219.83 235.19 1220.33 234.8 1220.83 234.49C1221.06 234.35 1221.3 234.22 1221.55 234.13",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.98 234.119C1218.98 234.119 1218.93 234.129 1218.91 234.139C1217.57 234.519 1216.48 235.589 1215.68 236.769C1215.18 237.519 1214.8 238.309 1214.6 239.159",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.98 234.119C1218.98 234.119 1218.93 234.129 1218.91 234.139C1217.57 234.519 1216.48 235.589 1215.68 236.769C1215.18 237.519 1214.8 238.309 1214.6 239.159",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.73 233.93C1192.82 233.89 1192.92 233.86 1193.01 233.82C1193.32 233.7 1193.78 233.49 1194 233.64C1194.22 233.78 1194.21 234.27 1194.09 234.63C1193.87 235.3 1193.3 235.55 1192.74 235.89C1192.28 236.17 1191.82 236.51 1191.66 236.97C1191.54 237.3 1191.58 237.7 1191.48 238.05",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.73 233.93C1192.82 233.89 1192.92 233.86 1193.01 233.82C1193.32 233.7 1193.78 233.49 1194 233.64C1194.22 233.78 1194.21 234.27 1194.09 234.63C1193.87 235.3 1193.3 235.55 1192.74 235.89C1192.28 236.17 1191.82 236.51 1191.66 236.97C1191.54 237.3 1191.58 237.7 1191.48 238.05",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.63 237.88C1195.63 237.88 1195.63 237.88 1195.63 237.87C1195.4 237.18 1195.41 236.59 1195.36 235.71C1195.32 235.03 1195.25 234.17 1194.64 234.18C1194.33 234.18 1193.89 234.4 1193.92 234.63C1193.94 234.82 1194.31 235.02 1194.28 235.26",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.63 237.88C1195.63 237.88 1195.63 237.88 1195.63 237.87C1195.4 237.18 1195.41 236.59 1195.36 235.71C1195.32 235.03 1195.25 234.17 1194.64 234.18C1194.33 234.18 1193.89 234.4 1193.92 234.63C1193.94 234.82 1194.31 235.02 1194.28 235.26",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.74 248.32C1198.74 248.32 1198.71 248.32 1198.7 248.31C1197.67 248.01 1196.61 247.49 1195.91 246.69C1195.25 245.94 1194.89 244.96 1194.38 244.08C1194.11 243.61 1193.79 243.17 1193.48 242.73C1193.22 242.36 1192.95 242 1192.67 241.65C1192.36 241.27 1192.02 240.9 1191.77 240.48C1191.44 239.93 1191.24 239.3 1191.05 238.68C1190.85 238.02 1190.66 237.37 1190.51 236.7C1190.38 236.14 1190.28 235.57 1190.33 234.99C1190.39 234.31 1190.65 233.61 1191.05 233.1C1191.39 232.67 1191.83 232.38 1192.49 232.2C1192.87 232.09 1193.33 232.03 1193.48 232.2C1193.65 232.4 1193.43 232.9 1193.21 233.28C1192.93 233.77 1192.65 234.06 1192.31 234.36C1191.97 234.66 1191.58 234.95 1191.32 235.35C1191.14 235.62 1191.02 235.94 1191.05 236.25",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.74 248.32C1198.74 248.32 1198.71 248.32 1198.7 248.31C1197.67 248.01 1196.61 247.49 1195.91 246.69C1195.25 245.94 1194.89 244.96 1194.38 244.08C1194.11 243.61 1193.79 243.17 1193.48 242.73C1193.22 242.36 1192.95 242 1192.67 241.65C1192.36 241.27 1192.02 240.9 1191.77 240.48C1191.44 239.93 1191.24 239.3 1191.05 238.68C1190.85 238.02 1190.66 237.37 1190.51 236.7C1190.38 236.14 1190.28 235.57 1190.33 234.99C1190.39 234.31 1190.65 233.61 1191.05 233.1C1191.39 232.67 1191.83 232.38 1192.49 232.2C1192.87 232.09 1193.33 232.03 1193.48 232.2C1193.65 232.4 1193.43 232.9 1193.21 233.28C1192.93 233.77 1192.65 234.06 1192.31 234.36C1191.97 234.66 1191.58 234.95 1191.32 235.35C1191.14 235.62 1191.02 235.94 1191.05 236.25",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.17 245.571C1201.93 244.681 1202.49 243.791 1202.74 242.851C1202.99 241.931 1202.95 240.951 1202.65 240.121C1202.44 239.541 1202.11 239.041 1201.71 238.461C1201.43 238.061 1201.13 237.621 1200.77 237.521C1200.26 237.391 1199.64 237.961 1199.14 238.491C1198.71 238.941 1198.36 239.361 1198.23 239.851C1198.05 240.571 1198.36 241.441 1198.44 242.251C1198.51 242.921 1198.43 243.551 1198.2 244.221C1197.98 244.881 1197.61 245.581 1197.78 246.151C1197.89 246.531 1198.25 246.861 1198.41 247.321C1198.57 247.771 1198.54 248.351 1198.95 248.491C1199 248.511 1199.05 248.531 1199.1 248.541",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.17 245.571C1201.93 244.681 1202.49 243.791 1202.74 242.851C1202.99 241.931 1202.95 240.951 1202.65 240.121C1202.44 239.541 1202.11 239.041 1201.71 238.461C1201.43 238.061 1201.13 237.621 1200.77 237.521C1200.26 237.391 1199.64 237.961 1199.14 238.491C1198.71 238.941 1198.36 239.361 1198.23 239.851C1198.05 240.571 1198.36 241.441 1198.44 242.251C1198.51 242.921 1198.43 243.551 1198.2 244.221C1197.98 244.881 1197.61 245.581 1197.78 246.151C1197.89 246.531 1198.25 246.861 1198.41 247.321C1198.57 247.771 1198.54 248.351 1198.95 248.491C1199 248.511 1199.05 248.531 1199.1 248.541",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.84 258.759C1237.77 259.609 1238.68 260.469 1238.89 261.589C1239.05 262.439 1238.8 263.439 1238.33 264.199C1237.18 266.059 1234.73 266.509 1232.54 267.189C1230.02 267.969 1227.84 269.059 1225.44 269.619C1223.64 270.039 1221.72 270.149 1219.83 269.619C1218.47 269.229 1217.13 268.509 1216.47 267.379C1216.05 266.669 1215.91 265.799 1215.72 264.949C1215.31 263.039 1214.72 261.239 1214.6 259.349C1214.5 257.679 1214.76 255.949 1214.41 254.309C1214.41 254.279 1214.4 254.249 1214.39 254.209",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.84 258.759C1237.77 259.609 1238.68 260.469 1238.89 261.589C1239.05 262.439 1238.8 263.439 1238.33 264.199C1237.18 266.059 1234.73 266.509 1232.54 267.189C1230.02 267.969 1227.84 269.059 1225.44 269.619C1223.64 270.039 1221.72 270.149 1219.83 269.619C1218.47 269.229 1217.13 268.509 1216.47 267.379C1216.05 266.669 1215.91 265.799 1215.72 264.949C1215.31 263.039 1214.72 261.239 1214.6 259.349C1214.5 257.679 1214.76 255.949 1214.41 254.309C1214.41 254.279 1214.4 254.249 1214.39 254.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.41 268.449C1217.2 268.399 1216.98 268.339 1216.77 268.289C1216.19 268.139 1216.65 269.259 1217.44 269.959C1219.02 271.349 1221.95 271.039 1220.78 271.289",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.41 268.449C1217.2 268.399 1216.98 268.339 1216.77 268.289C1216.19 268.139 1216.65 269.259 1217.44 269.959C1219.02 271.349 1221.95 271.039 1220.78 271.289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.88 269.32C1216.79 269.36 1216.7 269.41 1216.61 269.45C1213.92 270.73 1211.79 272.43 1209.1 274.28C1206.47 276.09 1203.3 278.03 1203.26 280.78C1203.26 281.52 1203.47 282.32 1203.59 283.11C1203.78 284.29 1203.76 285.45 1203.76 286.61C1203.76 292.04 1204.23 297.37 1205.43 302.94C1205.65 303.96 1205.89 305 1205.76 305.94C1205.65 306.7 1205.31 307.4 1205.09 308.27C1204.93 308.93 1204.84 309.7 1205.09 310.1C1205.56 310.87 1207.24 310.33 1208.59 310.1C1209.75 309.91 1210.68 309.95 1211.59 310.1C1212.77 310.3 1213.93 310.68 1215.43 310.77C1216.55 310.83 1217.86 310.73 1218.27 310.1C1218.7 309.44 1218.14 308.2 1217.77 307.1C1217.28 305.65 1217.12 304.42 1216.6 303.27C1216.33 302.67 1215.96 302.08 1215.55 301.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.88 269.32C1216.79 269.36 1216.7 269.41 1216.61 269.45C1213.92 270.73 1211.79 272.43 1209.1 274.28C1206.47 276.09 1203.3 278.03 1203.26 280.78C1203.26 281.52 1203.47 282.32 1203.59 283.11C1203.78 284.29 1203.76 285.45 1203.76 286.61C1203.76 292.04 1204.23 297.37 1205.43 302.94C1205.65 303.96 1205.89 305 1205.76 305.94C1205.65 306.7 1205.31 307.4 1205.09 308.27C1204.93 308.93 1204.84 309.7 1205.09 310.1C1205.56 310.87 1207.24 310.33 1208.59 310.1C1209.75 309.91 1210.68 309.95 1211.59 310.1C1212.77 310.3 1213.93 310.68 1215.43 310.77C1216.55 310.83 1217.86 310.73 1218.27 310.1C1218.7 309.44 1218.14 308.2 1217.77 307.1C1217.28 305.65 1217.12 304.42 1216.6 303.27C1216.33 302.67 1215.96 302.08 1215.55 301.5",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.97 287.279C1248.94 287.739 1249.83 288.329 1250.81 288.779C1252.17 289.409 1253.69 289.739 1254.98 290.449C1256.58 291.319 1257.85 292.759 1259.15 294.119C1260.17 295.179 1261.22 296.189 1262.15 297.289C1264 299.459 1265.41 301.989 1266.99 304.459C1267.54 305.309 1268.1 306.159 1268.32 307.129C1268.35 307.259 1268.38 307.389 1268.41 307.529",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.97 287.279C1248.94 287.739 1249.83 288.329 1250.81 288.779C1252.17 289.409 1253.69 289.739 1254.98 290.449C1256.58 291.319 1257.85 292.759 1259.15 294.119C1260.17 295.179 1261.22 296.189 1262.15 297.289C1264 299.459 1265.41 301.989 1266.99 304.459C1267.54 305.309 1268.1 306.159 1268.32 307.129C1268.35 307.259 1268.38 307.389 1268.41 307.529",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.98 314.379C1272.12 314.409 1272.25 314.439 1272.39 314.469C1273.32 314.679 1273.47 316.549 1272.88 317.269C1272.41 317.849 1271.45 317.699 1270.68 317.879C1269.92 318.049 1269.35 318.539 1268.73 318.979C1267.83 319.609 1266.84 320.129 1265.8 320.439C1264.47 320.839 1263.05 320.909 1261.65 321.169C1260.63 321.359 1259.62 321.649 1258.6 321.289C1258.51 321.259 1258.42 321.219 1258.36 321.169C1258.11 320.949 1258.38 320.459 1258.6 320.069C1258.87 319.609 1259.07 319.299 1259.33 318.969C1259.57 318.669 1259.85 318.359 1260.18 318.119C1260.51 317.879 1260.88 317.719 1261.28 317.629C1261.85 317.509 1262.47 317.559 1262.99 317.389C1263.47 317.229 1263.86 316.889 1264.33 316.539C1264.56 316.369 1264.81 316.189 1264.82 315.929",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.98 314.379C1272.12 314.409 1272.25 314.439 1272.39 314.469C1273.32 314.679 1273.47 316.549 1272.88 317.269C1272.41 317.849 1271.45 317.699 1270.68 317.879C1269.92 318.049 1269.35 318.539 1268.73 318.979C1267.83 319.609 1266.84 320.129 1265.8 320.439C1264.47 320.839 1263.05 320.909 1261.65 321.169C1260.63 321.359 1259.62 321.649 1258.6 321.289C1258.51 321.259 1258.42 321.219 1258.36 321.169C1258.11 320.949 1258.38 320.459 1258.6 320.069C1258.87 319.609 1259.07 319.299 1259.33 318.969C1259.57 318.669 1259.85 318.359 1260.18 318.119C1260.51 317.879 1260.88 317.719 1261.28 317.629C1261.85 317.509 1262.47 317.559 1262.99 317.389C1263.47 317.229 1263.86 316.889 1264.33 316.539C1264.56 316.369 1264.81 316.189 1264.82 315.929",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.13 264.49C1238.24 264.59 1238.35 264.69 1238.45 264.79C1239.28 265.55 1239.79 266.58 1240.28 267.62C1241.07 269.29 1241.79 270.98 1241.95 272.79C1241.96 272.93 1241.97 273.06 1241.99 273.2",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.13 264.49C1238.24 264.59 1238.35 264.69 1238.45 264.79C1239.28 265.55 1239.79 266.58 1240.28 267.62C1241.07 269.29 1241.79 270.98 1241.95 272.79C1241.96 272.93 1241.97 273.06 1241.99 273.2",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.13 281.949C1246.24 282.389 1246.91 283.449 1247.97 284.119C1249.23 284.909 1251.04 285.129 1251.64 286.289C1251.95 286.879 1251.93 287.729 1251.97 288.459C1251.98 288.729 1252 289.009 1252.01 289.279",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.13 281.949C1246.24 282.389 1246.91 283.449 1247.97 284.119C1249.23 284.909 1251.04 285.129 1251.64 286.289C1251.95 286.879 1251.93 287.729 1251.97 288.459C1251.98 288.729 1252 289.009 1252.01 289.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.29 236.17C1225.32 236.95 1223.29 237.99 1221.91 239.52C1220.99 240.54 1220.36 241.79 1219.16 242.75C1218.9 242.96 1218.61 243.16 1218.56 243.47",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.29 236.17C1225.32 236.95 1223.29 237.99 1221.91 239.52C1220.99 240.54 1220.36 241.79 1219.16 242.75C1218.9 242.96 1218.61 243.16 1218.56 243.47",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.98 243.339C1220.98 243.269 1218.81 243.119 1217 243.939C1216.45 244.189 1215.93 244.529 1215.44 244.899",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.98 243.339C1220.98 243.269 1218.81 243.119 1217 243.939C1216.45 244.189 1215.93 244.529 1215.44 244.899",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.73 245.379C1215.47 245.289 1215.22 245.239 1214.97 245.249C1214.16 245.289 1213.41 245.999 1212.34 246.329C1211.59 246.559 1210.69 246.609 1210.55 247.169C1210.42 247.679 1210.92 248.609 1210.43 248.959",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.73 245.379C1215.47 245.289 1215.22 245.239 1214.97 245.249C1214.16 245.289 1213.41 245.999 1212.34 246.329C1211.59 246.559 1210.69 246.609 1210.55 247.169C1210.42 247.679 1210.92 248.609 1210.43 248.959",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.3 246.449C1209.5 246.489 1208.62 246.359 1207.91 246.689C1207.42 246.919 1207.01 247.369 1206.47 247.529C1206.19 247.609 1205.88 247.609 1205.63 247.769",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.3 246.449C1209.5 246.489 1208.62 246.359 1207.91 246.689C1207.42 246.919 1207.01 247.369 1206.47 247.529C1206.19 247.609 1205.88 247.609 1205.63 247.769",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.27 246.45C1207.1 246.47 1206.05 245.94 1204.8 245.85C1203.86 245.78 1202.8 245.96 1202.29 246.69C1201.84 247.34 1201.82 248.42 1201.09 248.72",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.27 246.45C1207.1 246.47 1206.05 245.94 1204.8 245.85C1203.86 245.78 1202.8 245.96 1202.29 246.69C1201.84 247.34 1201.82 248.42 1201.09 248.72",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.88 247.28C1231.28 247.12 1231.55 246.54 1231.6 246.2C1231.77 245.01 1229.27 246.72 1227.41 247.87C1224.7 249.56 1223.36 250.09 1221.67 251.1C1219.92 252.14 1217.79 253.68 1215.57 254.09C1213.84 254.41 1212.07 254.03 1210.31 253.61C1208.65 253.22 1207.01 252.78 1205.52 252.3C1203.99 251.8 1202.63 251.24 1200.73 250.51C1199.93 250.2 1199.04 249.87 1198.94 249.31C1198.86 248.86 1199.31 248.26 1199.54 247.64C1199.72 247.15 1199.76 246.65 1200.02 246.33C1200.37 245.89 1201.13 245.76 1201.81 245.73C1202.67 245.7 1203.41 245.82 1204.2 245.73",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.88 247.28C1231.28 247.12 1231.55 246.54 1231.6 246.2C1231.77 245.01 1229.27 246.72 1227.41 247.87C1224.7 249.56 1223.36 250.09 1221.67 251.1C1219.92 252.14 1217.79 253.68 1215.57 254.09C1213.84 254.41 1212.07 254.03 1210.31 253.61C1208.65 253.22 1207.01 252.78 1205.52 252.3C1203.99 251.8 1202.63 251.24 1200.73 250.51C1199.93 250.2 1199.04 249.87 1198.94 249.31C1198.86 248.86 1199.31 248.26 1199.54 247.64C1199.72 247.15 1199.76 246.65 1200.02 246.33C1200.37 245.89 1201.13 245.76 1201.81 245.73C1202.67 245.7 1203.41 245.82 1204.2 245.73",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.29 235.71C1193.54 235.54 1193.98 235.399 1194.19 235.529C1194.46 235.699 1194.35 236.319 1194.1 236.699C1193.78 237.179 1193.23 237.3 1193.02 237.69C1192.88 237.94 1192.89 238.309 1192.75 238.589",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.29 235.71C1193.54 235.54 1193.98 235.399 1194.19 235.529C1194.46 235.699 1194.35 236.319 1194.1 236.699C1193.78 237.179 1193.23 237.3 1193.02 237.69C1192.88 237.94 1192.89 238.309 1192.75 238.589",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.92 236.971C1194.01 237.141 1194.14 237.331 1194.1 237.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.92 236.971C1194.01 237.141 1194.14 237.331 1194.1 237.511",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.79 271.779C1240.14 272.529 1241.8 272.879 1242.96 273.779C1244.5 274.969 1245.15 277.129 1245.96 279.109C1246.69 280.899 1247.55 282.549 1248.96 283.779C1249.5 284.249 1250.12 284.659 1250.46 285.279",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.79 271.779C1240.14 272.529 1241.8 272.879 1242.96 273.779C1244.5 274.969 1245.15 277.129 1245.96 279.109C1246.69 280.899 1247.55 282.549 1248.96 283.779C1249.5 284.249 1250.12 284.659 1250.46 285.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.15 304.949C1264.25 305.719 1265.33 306.459 1266.65 306.949C1267.9 307.409 1269.36 307.639 1270.15 308.449C1270.91 309.229 1271.07 310.549 1271.65 311.779C1271.99 312.489 1272.46 313.169 1272.32 313.779C1272.21 314.229 1271.78 314.639 1271.32 314.949C1270.15 315.739 1268.86 315.879 1267.48 315.779C1266.08 315.679 1264.6 315.329 1263.48 315.949C1262.64 316.409 1262.01 317.409 1260.98 317.619C1260.33 317.749 1259.52 317.559 1259.15 317.119C1258.65 316.529 1258.91 315.499 1258.82 314.619C1258.72 313.659 1258.2 312.869 1257.65 312.119C1256.82 310.979 1255.94 309.919 1255.15 308.789C1254.35 307.639 1253.65 306.419 1252.81 305.289C1252.49 304.859 1252.16 304.449 1251.82 304.029",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.15 304.949C1264.25 305.719 1265.33 306.459 1266.65 306.949C1267.9 307.409 1269.36 307.639 1270.15 308.449C1270.91 309.229 1271.07 310.549 1271.65 311.779C1271.99 312.489 1272.46 313.169 1272.32 313.779C1272.21 314.229 1271.78 314.639 1271.32 314.949C1270.15 315.739 1268.86 315.879 1267.48 315.779C1266.08 315.679 1264.6 315.329 1263.48 315.949C1262.64 316.409 1262.01 317.409 1260.98 317.619C1260.33 317.749 1259.52 317.559 1259.15 317.119C1258.65 316.529 1258.91 315.499 1258.82 314.619C1258.72 313.659 1258.2 312.869 1257.65 312.119C1256.82 310.979 1255.94 309.919 1255.15 308.789C1254.35 307.639 1253.65 306.419 1252.81 305.289C1252.49 304.859 1252.16 304.449 1251.82 304.029",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.11 270.119C1224.37 273.339 1226.08 276.909 1228.12 280.289C1229.68 282.889 1231.44 285.369 1233.46 287.619C1235.56 289.959 1237.95 292.039 1240.13 294.289C1242.15 296.369 1244.01 298.589 1245.97 300.789C1247.51 302.519 1249.12 304.239 1251.14 305.289C1252.13 305.799 1253.22 306.159 1254.14 306.789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.11 270.119C1224.37 273.339 1226.08 276.909 1228.12 280.289C1229.68 282.889 1231.44 285.369 1233.46 287.619C1235.56 289.959 1237.95 292.039 1240.13 294.289C1242.15 296.369 1244.01 298.589 1245.97 300.789C1247.51 302.519 1249.12 304.239 1251.14 305.289C1252.13 305.799 1253.22 306.159 1254.14 306.789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.77 286.459C1213.12 286.939 1213.46 287.439 1213.77 287.949C1214.95 289.879 1215.77 292.059 1216.11 294.279C1216.46 296.579 1216.28 298.929 1216.28 301.279C1216.28 301.949 1216.29 302.629 1216.45 303.279",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.77 286.459C1213.12 286.939 1213.46 287.439 1213.77 287.949C1214.95 289.879 1215.77 292.059 1216.11 294.279C1216.46 296.579 1216.28 298.929 1216.28 301.279C1216.28 301.949 1216.29 302.629 1216.45 303.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.41 227.22C1224.28 227.76 1224.35 228.4 1224.16 228.88C1223.84 229.72 1222.75 230.1 1221.83 230.62C1220.87 231.16 1220.09 231.84 1219 231.7C1218.52 231.64 1217.98 231.41 1217.84 231.04C1217.66 230.58 1218.09 229.88 1217.92 229.38C1217.8 229.02 1217.36 228.75 1217.25 228.38C1217.13 227.97 1217.4 227.43 1217.25 227.05C1217.15 226.82 1216.89 226.65 1216.58 226.55C1216.32 226.47 1216.03 226.44 1215.91 226.3C1215.72 226.07 1216 225.55 1216.33 225.22C1216.66 224.89 1217.03 224.76 1217.24 224.47C1217.49 224.14 1217.54 223.61 1217.49 223.14C1217.45 222.76 1217.34 222.42 1217.24 222.06C1217.21 221.96 1217.19 221.86 1217.16 221.77",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.41 227.22C1224.28 227.76 1224.35 228.4 1224.16 228.88C1223.84 229.72 1222.75 230.1 1221.83 230.62C1220.87 231.16 1220.09 231.84 1219 231.7C1218.52 231.64 1217.98 231.41 1217.84 231.04C1217.66 230.58 1218.09 229.88 1217.92 229.38C1217.8 229.02 1217.36 228.75 1217.25 228.38C1217.13 227.97 1217.4 227.43 1217.25 227.05C1217.15 226.82 1216.89 226.65 1216.58 226.55C1216.32 226.47 1216.03 226.44 1215.91 226.3C1215.72 226.07 1216 225.55 1216.33 225.22C1216.66 224.89 1217.03 224.76 1217.24 224.47C1217.49 224.14 1217.54 223.61 1217.49 223.14C1217.45 222.76 1217.34 222.42 1217.24 222.06C1217.21 221.96 1217.19 221.86 1217.16 221.77",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.26 220.15C1230.29 221.07 1230.02 222.04 1229.65 222.9C1229.32 223.68 1228.9 224.36 1228.57 225.14C1228.29 225.8 1228.08 226.53 1228.15 227.22C1228.22 227.82 1228.51 228.39 1228.73 228.96C1228.92 229.46 1229.07 229.98 1229.31 230.46C1229.43 230.7 1229.58 230.93 1229.65 231.2C1229.68 231.3 1229.7 231.4 1229.73 231.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.26 220.15C1230.29 221.07 1230.02 222.04 1229.65 222.9C1229.32 223.68 1228.9 224.36 1228.57 225.14C1228.29 225.8 1228.08 226.53 1228.15 227.22C1228.22 227.82 1228.51 228.39 1228.73 228.96C1228.92 229.46 1229.07 229.98 1229.31 230.46C1229.43 230.7 1229.58 230.93 1229.65 231.2C1229.68 231.3 1229.7 231.4 1229.73 231.5",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.06 310.339C1218.11 310.429 1218.16 310.509 1218.21 310.599C1218.53 311.139 1218.55 311.999 1218.28 312.469C1217.74 313.379 1216.02 312.749 1214.61 312.609C1212.92 312.439 1211.68 312.969 1210.25 313.159C1208.97 313.329 1207.55 313.229 1206.31 313.229C1205.41 313.229 1204.61 313.279 1203.47 313.019C1203.06 312.929 1202.61 312.799 1202.57 312.539C1202.54 312.329 1202.75 312.049 1202.98 311.849C1203.33 311.549 1203.72 311.459 1204.09 311.299C1204.56 311.089 1205.01 310.749 1205.54 310.679C1205.8 310.649 1206.08 310.679 1206.3 310.539C1206.31 310.539 1206.33 310.519 1206.34 310.509C1205.76 310.549 1205.29 310.479 1205.08 310.119C1204.83 309.719 1204.92 308.949 1205.08 308.289C1205.29 307.409 1205.64 306.709 1205.75 305.959C1205.88 305.019 1205.64 303.989 1205.42 302.959C1204.22 297.389 1203.76 292.059 1203.75 286.629C1203.75 285.469 1203.77 284.309 1203.58 283.129C1203.45 282.339 1203.24 281.539 1203.25 280.799C1203.29 278.049 1206.46 276.109 1209.09 274.299C1211.78 272.449 1213.91 270.749 1216.6 269.469C1216.69 269.429 1216.78 269.379 1216.87 269.339C1216.47 268.759 1216.34 268.199 1216.76 268.299C1216.97 268.349 1217.19 268.409 1217.4 268.459C1217.01 268.149 1216.69 267.799 1216.45 267.389C1216.03 266.679 1215.89 265.809 1215.7 264.959C1215.29 263.049 1214.7 261.249 1214.58 259.359C1214.48 257.689 1214.74 255.959 1214.39 254.319C1214.39 254.289 1214.38 254.259 1214.37 254.219C1213.02 254.249 1211.65 253.949 1210.28 253.629C1208.62 253.239 1206.98 252.799 1205.49 252.319C1203.96 251.819 1202.6 251.259 1200.7 250.529C1199.9 250.219 1199.01 249.889 1198.91 249.329C1198.87 249.099 1198.96 248.839 1199.09 248.559L1198.94 248.509C1198.84 248.479 1198.77 248.429 1198.71 248.339C1198.7 248.339 1198.68 248.339 1198.67 248.329C1197.64 248.029 1196.58 247.509 1195.88 246.709C1195.22 245.959 1194.86 244.979 1194.35 244.099C1194.08 243.629 1193.76 243.189 1193.45 242.749C1193.19 242.379 1192.92 242.019 1192.64 241.669C1192.59 241.599 1192.53 241.539 1192.48 241.479C1192.22 241.159 1191.95 240.849 1191.74 240.499C1191.4 239.949 1191.21 239.319 1191.02 238.699C1190.82 238.039 1190.63 237.389 1190.48 236.719C1190.35 236.159 1190.25 235.589 1190.3 235.009C1190.36 234.329 1190.62 233.629 1191.02 233.119C1191.36 232.689 1191.8 232.399 1192.46 232.219C1192.84 232.109 1193.3 232.049 1193.45 232.219C1193.62 232.419 1193.4 232.919 1193.18 233.299C1193.03 233.559 1192.88 233.769 1192.72 233.949C1192.81 233.909 1192.91 233.879 1193 233.839C1193.31 233.719 1193.77 233.509 1193.99 233.659C1194.15 233.759 1194.19 234.049 1194.15 234.329C1194.29 234.249 1194.47 234.199 1194.62 234.199C1195.23 234.199 1195.3 235.049 1195.34 235.729C1195.39 236.609 1195.38 237.199 1195.61 237.889C1195.61 237.889 1195.61 237.889 1195.61 237.899C1195.64 237.899 1195.67 237.889 1195.7 237.889C1195.97 237.889 1196.18 238.199 1196.42 238.429C1196.97 238.949 1197.67 239.009 1198.31 239.239C1198.37 239.259 1198.42 239.279 1198.48 239.299C1198.65 239.039 1198.87 238.779 1199.13 238.509C1199.63 237.979 1200.25 237.409 1200.76 237.539C1201.12 237.629 1201.42 238.069 1201.7 238.479C1202.1 239.059 1202.43 239.559 1202.64 240.139C1202.77 240.499 1202.85 240.889 1202.88 241.299C1203.11 241.259 1203.35 241.239 1203.58 241.209C1204.65 241.069 1205.64 240.589 1206.69 240.249C1207.85 239.869 1209.1 239.659 1210.28 239.889C1210.32 239.889 1210.36 239.899 1210.39 239.909C1210.79 239.259 1211.24 238.629 1211.83 238.209C1212.72 237.579 1213.95 237.449 1215.06 237.249C1215.17 237.229 1215.28 237.209 1215.39 237.189C1215.47 237.049 1215.56 236.909 1215.66 236.769C1216.46 235.589 1217.56 234.519 1218.89 234.139C1218.91 234.139 1218.94 234.129 1218.96 234.119C1218.97 234.049 1218.99 233.969 1219.01 233.899C1219.21 233.269 1219.92 232.729 1220.33 232.109C1220.39 232.019 1220.45 231.929 1220.5 231.839C1220.45 231.799 1220.39 231.769 1220.33 231.749C1220.21 231.709 1220.09 231.659 1219.97 231.619C1219.66 231.719 1219.34 231.759 1218.98 231.709C1218.5 231.649 1217.96 231.419 1217.82 231.049C1217.64 230.589 1218.07 229.889 1217.9 229.389C1217.78 229.029 1217.34 228.759 1217.23 228.389C1217.11 227.979 1217.38 227.439 1217.23 227.059C1217.13 226.829 1216.87 226.659 1216.56 226.559C1216.3 226.479 1216.01 226.449 1215.89 226.309C1215.7 226.079 1215.98 225.559 1216.31 225.229C1216.64 224.899 1217.01 224.769 1217.22 224.479C1217.47 224.149 1217.52 223.619 1217.47 223.149C1217.43 222.769 1217.32 222.429 1217.22 222.069C1217.19 221.969 1217.17 221.869 1217.14 221.779C1216.49 221.579 1216.1 221.429 1215.81 221.279C1215.51 221.129 1215.33 220.979 1215.21 220.849C1215.09 220.719 1215.03 220.599 1214.99 220.459C1214.95 220.319 1214.93 220.149 1214.95 219.979C1214.97 219.809 1215.03 219.619 1215.14 219.379C1215.25 219.139 1215.39 218.839 1215.54 218.599C1215.69 218.359 1215.83 218.189 1216.07 217.929C1216.31 217.669 1216.65 217.319 1217.03 217.049C1217.05 217.039 1217.07 217.019 1217.08 217.009C1217.21 216.399 1217.41 215.769 1217.65 215.269C1217.68 215.149 1217.71 215.019 1217.75 214.879C1217.86 214.479 1218.05 213.979 1218.25 213.579C1218.45 213.179 1218.66 212.879 1218.93 212.579C1219.2 212.279 1219.51 211.979 1219.89 211.679C1220.26 211.379 1220.69 211.099 1221.46 210.829C1221.65 210.699 1221.82 210.609 1222.02 210.519C1222.25 210.409 1222.53 210.299 1222.79 210.219C1223.05 210.139 1223.3 210.089 1223.54 210.059C1223.78 210.029 1224 210.029 1224.24 210.029C1224.48 210.029 1224.73 210.049 1224.99 210.079C1225.25 210.109 1225.51 210.149 1225.72 210.189C1225.93 210.229 1226.09 210.269 1226.23 210.309C1226.37 210.349 1226.51 210.399 1226.62 210.449C1226.73 210.499 1226.82 210.539 1226.92 210.589C1226.96 210.609 1227 210.639 1227.04 210.669C1227.1 210.719 1227.16 210.769 1227.22 210.849C1227.24 210.849 1227.26 210.859 1227.28 210.869C1227.4 210.909 1227.55 210.989 1227.72 211.089C1227.89 211.189 1228.06 211.329 1228.32 211.639C1228.49 211.749 1228.63 211.849 1228.85 212.059C1229.08 212.279 1229.39 212.609 1229.64 212.959C1229.89 213.309 1230.08 213.669 1230.24 214.059C1230.4 214.449 1230.52 214.849 1230.61 215.209C1230.69 215.559 1230.74 215.859 1230.78 216.109C1230.82 216.359 1230.86 216.559 1230.91 216.879C1230.94 217.099 1230.98 217.389 1230.99 217.909C1231 217.909 1231.01 217.919 1231.02 217.929C1231.33 218.129 1231.43 218.239 1231.5 218.319C1231.57 218.399 1231.59 218.449 1231.61 218.509C1231.63 218.569 1231.64 218.629 1231.63 218.739C1231.63 218.849 1231.59 218.999 1231.56 219.109C1231.53 219.229 1231.5 219.309 1231.45 219.389C1231.4 219.469 1231.35 219.529 1231.28 219.599C1231.21 219.669 1231.14 219.739 1230.6 219.999C1230.47 220.059 1230.34 220.119 1230.21 220.179C1230.24 221.099 1229.97 222.069 1229.6 222.929C1229.27 223.709 1228.85 224.389 1228.52 225.169C1228.24 225.829 1228.03 226.559 1228.1 227.249C1228.17 227.849 1228.46 228.419 1228.68 228.989C1228.87 229.489 1229.02 230.009 1229.26 230.489C1229.38 230.729 1229.53 230.959 1229.6 231.229C1229.63 231.329 1229.65 231.429 1229.68 231.529C1229.84 231.489 1230 231.469 1230.14 231.479C1231.35 231.509 1232.08 233.129 1232.75 234.489C1233.59 236.169 1234.35 237.469 1234.92 238.919C1235.78 241.129 1236.2 243.709 1236.5 246.229C1236.86 249.259 1237.07 252.199 1237.83 255.119C1238.13 256.279 1238.53 257.439 1238.46 258.639C1238.44 259.079 1238.35 259.529 1238.46 259.949C1238.53 260.319 1238.59 260.689 1238.66 261.059C1238.74 261.239 1238.79 261.429 1238.83 261.629C1238.99 262.479 1238.74 263.479 1238.27 264.239C1238.21 264.339 1238.15 264.429 1238.08 264.519C1238.19 264.619 1238.3 264.719 1238.4 264.819C1239.23 265.579 1239.74 266.609 1240.23 267.649C1241.02 269.319 1241.74 271.009 1241.9 272.819C1241.91 272.959 1241.92 273.089 1241.94 273.229C1242.28 273.399 1242.61 273.599 1242.9 273.819C1244.44 275.009 1245.09 277.169 1245.9 279.149C1246.63 280.939 1247.49 282.589 1248.9 283.819C1249.43 284.279 1250.04 284.689 1250.38 285.289C1250.89 285.549 1251.33 285.859 1251.57 286.319C1251.88 286.909 1251.86 287.759 1251.9 288.489C1251.91 288.759 1251.93 289.039 1251.94 289.309C1252.95 289.669 1253.98 289.989 1254.9 290.489C1256.5 291.359 1257.77 292.799 1259.07 294.159C1260.09 295.219 1261.14 296.229 1262.07 297.329C1263.92 299.499 1265.33 302.029 1266.91 304.499C1267.46 305.349 1268.02 306.199 1268.24 307.169C1268.27 307.299 1268.3 307.429 1268.33 307.569C1269.01 307.799 1269.64 308.069 1270.07 308.509C1270.83 309.289 1270.99 310.609 1271.57 311.839C1271.91 312.549 1272.38 313.229 1272.24 313.839C1272.19 314.049 1272.07 314.249 1271.9 314.439C1272.04 314.469 1272.17 314.499 1272.31 314.529C1273.24 314.739 1273.39 316.609 1272.8 317.329C1272.33 317.909 1271.37 317.759 1270.6 317.939C1269.84 318.109 1269.27 318.599 1268.65 319.039C1267.75 319.669 1266.76 320.189 1265.72 320.499C1264.39 320.899 1262.97 320.969 1261.57 321.229C1260.55 321.419 1259.54 321.709 1258.52 321.349C1258.43 321.319 1258.34 321.279 1258.28 321.229C1258.03 321.009 1258.3 320.519 1258.52 320.129C1258.79 319.669 1258.99 319.359 1259.25 319.029C1259.49 318.729 1259.77 318.419 1260.1 318.179C1260.38 317.979 1260.69 317.829 1261.02 317.739C1261.05 317.699 1261.07 317.659 1261.1 317.609C1261.03 317.629 1260.95 317.649 1260.88 317.669C1260.23 317.799 1259.42 317.609 1259.05 317.169C1258.55 316.579 1258.81 315.549 1258.72 314.669C1258.62 313.709 1258.1 312.919 1257.55 312.169C1256.72 311.029 1255.84 309.969 1255.05 308.839C1254.52 308.079 1254.04 307.299 1253.53 306.519C1252.73 306.069 1251.86 305.759 1251.04 305.339C1249.02 304.289 1247.41 302.569 1245.87 300.839C1243.91 298.639 1242.06 296.419 1240.03 294.339C1237.84 292.099 1235.46 290.009 1233.36 287.669C1231.34 285.419 1229.58 282.929 1228.02 280.339C1227.81 279.999 1227.61 279.649 1227.41 279.299C1227.39 279.309 1227.37 279.329 1227.35 279.339C1225.54 280.579 1223.32 281.199 1221.68 282.669C1219.85 284.309 1218.73 286.999 1216.51 287.839C1215.79 288.109 1214.96 288.179 1214.17 288.169C1214.04 288.169 1213.9 288.169 1213.77 288.169C1214.9 290.059 1215.68 292.179 1216.01 294.339C1216.36 296.639 1216.18 298.989 1216.18 301.339C1216.18 301.829 1216.18 302.329 1216.25 302.809C1216.35 302.989 1216.43 303.159 1216.51 303.339C1217.03 304.489 1217.19 305.719 1217.68 307.169C1218.05 308.269 1218.61 309.509 1218.18 310.169C1218.12 310.259 1218.05 310.329 1217.97 310.399L1218.06 310.339Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.14 528.949C1055.84 528.949 1055.5 528.949 1055.1 528.959C1052.21 528.969 1046.35 528.939 1042.98 528.959C1041.23 528.959 1040.15 528.989 1039.78 528.329C1039.49 527.809 1039.63 526.869 1039.92 526.329C1040.16 525.879 1040.5 525.699 1041.08 525.539C1042.1 525.259 1043.85 525.039 1045.4 524.599C1047.03 524.129 1048.44 523.419 1049.84 522.589C1049.62 522.389 1049.5 522.179 1049.52 521.949C1049.57 521.439 1050.28 520.809 1050.51 520.069C1050.76 519.289 1050.46 518.399 1050.62 517.679C1050.76 517.019 1051.28 516.499 1051.54 515.909C1051.79 515.339 1051.8 514.699 1051.76 514.029C1051.71 513.269 1051.6 512.469 1051.49 511.549C1051.34 510.349 1051.18 508.929 1051.09 507.379C1050.99 505.699 1050.98 503.869 1050.68 502.499C1050.47 501.529 1050.11 500.779 1050.06 500.149C1050.02 499.689 1050.15 499.289 1050 498.859C1049.83 498.389 1049.3 497.879 1049.09 497.519C1048.97 497.299 1048.96 497.139 1048.87 496.979C1048.74 496.759 1048.44 496.539 1048.17 496.169C1047.73 495.539 1047.38 494.469 1047.07 493.389C1046.74 492.219 1046.44 491.029 1046.35 490.019C1046.27 489.099 1046.38 488.339 1046.56 487.189C1046.82 485.489 1047.25 482.949 1047.24 481.019C1047.24 479.539 1046.97 478.409 1047.03 477.379C1047.09 476.469 1047.4 475.649 1047.6 474.609C1047.86 473.289 1047.95 471.619 1048.14 470.009C1048.34 468.339 1048.67 466.729 1049 465.099C1048.56 465.289 1048.23 465.399 1048.11 465.339C1047.93 465.249 1048.16 464.809 1048.32 464.259C1048.59 463.279 1048.6 461.959 1048.8 460.859C1048.97 459.889 1049.28 459.099 1049.29 458.249C1049.31 457.319 1048.98 456.339 1048.84 455.099C1048.66 453.479 1048.81 451.429 1049.12 449.629C1048.6 450.429 1047.97 451.169 1047.05 451.579C1046.1 451.999 1044.85 452.069 1043.98 451.829C1042.72 452.479 1041.69 453.129 1040.69 453.999C1039.83 454.739 1038.99 455.659 1038.23 456.379C1037.73 456.859 1037.26 457.249 1036.86 457.709C1036.39 458.249 1036.03 458.879 1035.8 459.499C1035.59 460.069 1035.51 460.639 1035.24 460.999C1035.19 461.059 1035.14 461.119 1035.08 461.169H1042.31V463.729H1022.34V461.169H1028.75C1028.39 460.349 1029.34 459.039 1029.79 458.199C1030.11 457.599 1030.18 457.249 1030.52 456.859C1030.93 456.399 1031.73 455.909 1032.17 455.569C1032.45 455.349 1032.59 455.189 1032.78 455.049C1033.08 454.829 1033.53 454.639 1033.98 454.369C1034.52 454.039 1035.07 453.599 1035.82 452.759C1036.65 451.829 1037.74 450.409 1038.53 449.479C1038.9 449.049 1039.21 448.729 1039.5 448.419C1039.3 447.929 1039.52 447.479 1039.87 446.969C1040.29 446.339 1040.9 445.629 1041.63 445.109C1042.35 444.599 1043.18 444.279 1043.36 443.789C1043.5 443.399 1043.25 442.899 1043.39 442.529C1043.54 442.149 1044.12 441.909 1044.38 441.599C1044.59 441.349 1044.58 441.049 1044.61 440.739C1044.64 440.379 1044.72 439.989 1044.91 439.549C1045.16 438.959 1045.6 438.259 1045.67 437.559C1045.74 436.899 1045.47 436.259 1045.54 435.669C1045.61 435.119 1045.98 434.629 1046.1 434.129C1046.2 433.709 1046.13 433.289 1046.21 432.979C1046.27 432.729 1046.43 432.559 1046.5 432.299C1046.59 431.909 1046.47 431.309 1046.44 430.629C1046.4 429.759 1046.52 428.739 1046.61 427.889C1046.69 427.149 1046.76 426.529 1047.15 425.889C1047.58 425.179 1048.41 424.429 1049.16 423.729C1049.25 423.469 1049.35 423.209 1049.46 422.959C1049.02 423.119 1048.43 423.139 1047.97 423.049C1047.51 422.959 1047.16 422.769 1047.01 422.509C1046.9 422.319 1046.9 422.089 1046.78 421.939C1046.66 421.779 1046.42 421.699 1046.3 421.539C1046.2 421.409 1046.17 421.239 1046.08 421.209C1045.97 421.169 1045.79 421.289 1045.61 421.319C1045.41 421.349 1045.22 421.279 1045.03 421.119C1044.82 420.949 1044.6 420.689 1044.61 420.509C1044.21 420.729 1043.58 420.979 1043.28 420.779C1042.96 420.569 1043.04 419.829 1043.06 419.209C1043.08 418.639 1043.05 418.179 1042.89 417.909C1042.78 417.729 1042.62 417.629 1042.42 417.509C1042.13 417.329 1041.77 417.089 1041.42 416.609C1040.9 415.909 1040.38 414.689 1040.28 413.549C1040.08 413.519 1039.88 413.499 1039.71 413.469C1038.99 413.359 1038.56 413.269 1038.25 413.159C1037.94 413.049 1037.74 412.929 1037.6 412.819C1037.46 412.709 1037.38 412.599 1037.32 412.459C1037.26 412.329 1037.22 412.169 1037.21 411.989C1037.21 411.809 1037.24 411.619 1037.31 411.369C1037.38 411.119 1037.48 410.799 1037.59 410.539C1037.7 410.279 1037.81 410.089 1038.01 409.799C1038.21 409.509 1038.49 409.109 1038.83 408.789C1038.85 408.769 1038.86 408.759 1038.88 408.739C1038.92 408.119 1039.02 407.469 1039.19 406.929C1039.19 406.799 1039.21 406.669 1039.23 406.529C1039.29 406.119 1039.4 405.599 1039.54 405.169C1039.68 404.739 1039.84 404.419 1040.06 404.079C1040.28 403.739 1040.55 403.399 1040.88 403.049C1041.21 402.699 1041.59 402.359 1042.31 401.979C1042.48 401.819 1042.63 401.709 1042.82 401.589C1043.04 401.449 1043.29 401.299 1043.54 401.189C1043.79 401.069 1044.03 400.979 1044.26 400.919C1044.49 400.859 1044.71 400.819 1044.95 400.789C1045.19 400.759 1045.44 400.739 1045.7 400.729C1045.96 400.719 1046.23 400.729 1046.44 400.729C1046.65 400.729 1046.82 400.749 1046.97 400.769C1047.12 400.789 1047.26 400.819 1047.38 400.849C1047.5 400.879 1047.59 400.909 1047.7 400.949C1047.74 400.969 1047.78 400.989 1047.83 401.009C1047.9 401.049 1047.96 401.089 1048.04 401.159C1048.06 401.159 1048.08 401.159 1048.1 401.169C1048.23 401.199 1048.39 401.239 1048.57 401.319C1048.75 401.399 1048.95 401.509 1049.25 401.779C1049.43 401.869 1049.59 401.949 1049.84 402.119C1050.1 402.299 1050.45 402.579 1050.75 402.889C1051.05 403.199 1051.29 403.529 1051.51 403.889C1051.72 404.249 1051.91 404.629 1052.04 404.969C1052.17 405.309 1052.26 405.599 1052.34 405.839C1052.42 406.079 1052.48 406.269 1052.58 406.579C1052.65 406.799 1052.73 407.069 1052.81 407.579C1052.82 407.579 1052.83 407.589 1052.85 407.599C1053.18 407.759 1053.3 407.849 1053.38 407.919C1053.46 407.989 1053.49 408.039 1053.52 408.099C1053.55 408.159 1053.56 408.219 1053.57 408.329C1053.57 408.439 1053.57 408.589 1053.56 408.709C1053.55 408.829 1053.53 408.919 1053.49 408.999C1053.46 409.079 1053.41 409.149 1053.35 409.229C1053.31 409.289 1053.26 409.349 1053.02 409.529C1053.28 410.289 1053.41 411.009 1053.67 411.719C1053.91 412.379 1054.28 413.029 1054.22 413.309C1054.21 413.369 1054.18 413.409 1054.14 413.439C1054.8 414.299 1055.49 415.129 1056.21 415.929C1056.53 415.849 1056.82 415.839 1057.06 415.909C1057.52 416.049 1057.8 416.509 1058.07 416.909C1058.33 417.299 1058.58 417.629 1058.76 418.029C1059.32 418.289 1059.87 418.819 1060.62 419.439C1061.99 420.559 1064.04 421.979 1065.36 423.499C1066.65 424.989 1067.24 426.579 1067.81 429.009C1068.66 432.589 1069.48 437.999 1069.83 441.929C1070.08 444.709 1070.08 446.759 1070 448.489C1069.94 449.979 1069.81 451.239 1070 453.359C1070.27 456.429 1071.19 461.299 1071.75 463.419C1071.97 464.259 1072.14 464.669 1071.88 465.029C1071.59 465.419 1070.8 465.749 1069.85 465.919C1069.44 467.159 1068.99 468.299 1068.19 469.479C1067.27 470.839 1065.87 472.239 1064.75 473.459C1064.48 474.059 1064.23 474.549 1064.03 475.999C1063.75 478.059 1063.56 482.039 1063.13 484.349C1062.76 486.319 1062.21 487.079 1061.73 487.759C1061.33 488.309 1060.97 488.809 1060.97 489.459C1060.97 490.249 1061.47 491.259 1061.5 492.099C1061.52 492.809 1061.21 493.389 1061.16 493.969C1061.11 494.549 1061.33 495.119 1061.52 495.849C1061.81 496.959 1062.03 498.449 1062.28 500.179C1062.63 502.589 1063.05 505.459 1063.19 508.629C1063.34 511.979 1063.19 515.669 1063.24 518.089C1063.27 519.489 1063.36 520.469 1063.14 521.259C1062.97 521.859 1062.62 522.349 1062.59 522.989C1062.56 523.619 1062.84 524.389 1062.6 524.779C1062.58 524.809 1062.57 524.829 1062.54 524.859C1062.72 525.529 1062.72 526.229 1062.71 526.919C1062.71 527.529 1062.69 528.129 1062.3 528.479C1061.8 528.929 1060.67 528.939 1059.62 528.959C1058.54 528.979 1057.53 529.009 1056.18 528.979L1056.14 528.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.69 409.719C1052.5 409.849 1052.25 410.009 1051.91 410.199C1051.22 410.599 1050.14 411.159 1049.18 411.649C1048.23 412.149 1047.4 412.579 1046.76 412.889C1046.12 413.199 1045.67 413.399 1045.28 413.529C1044.89 413.659 1044.55 413.729 1044.21 413.759C1043.87 413.789 1043.55 413.809 1043.26 413.809C1042.96 413.809 1042.69 413.809 1042.06 413.739C1041.43 413.669 1040.42 413.559 1039.7 413.449C1038.98 413.339 1038.55 413.249 1038.24 413.139C1037.93 413.029 1037.73 412.909 1037.59 412.799C1037.45 412.689 1037.37 412.579 1037.31 412.439C1037.25 412.309 1037.21 412.149 1037.2 411.969C1037.2 411.789 1037.23 411.599 1037.3 411.349C1037.37 411.099 1037.47 410.779 1037.58 410.519C1037.69 410.259 1037.8 410.069 1038 409.779C1038.2 409.489 1038.48 409.089 1038.82 408.769C1038.84 408.749 1038.85 408.739 1038.87 408.719",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.69 409.719C1052.5 409.849 1052.25 410.009 1051.91 410.199C1051.22 410.599 1050.14 411.159 1049.18 411.649C1048.23 412.149 1047.4 412.579 1046.76 412.889C1046.12 413.199 1045.67 413.399 1045.28 413.529C1044.89 413.659 1044.55 413.729 1044.21 413.759C1043.87 413.789 1043.55 413.809 1043.26 413.809C1042.96 413.809 1042.69 413.809 1042.06 413.739C1041.43 413.669 1040.42 413.559 1039.7 413.449C1038.98 413.339 1038.55 413.249 1038.24 413.139C1037.93 413.029 1037.73 412.909 1037.59 412.799C1037.45 412.689 1037.37 412.579 1037.31 412.439C1037.25 412.309 1037.21 412.149 1037.2 411.969C1037.2 411.789 1037.23 411.599 1037.3 411.349C1037.37 411.099 1037.47 410.779 1037.58 410.519C1037.69 410.259 1037.8 410.069 1038 409.779C1038.2 409.489 1038.48 409.089 1038.82 408.769C1038.84 408.749 1038.85 408.739 1038.87 408.719",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.18 411.43C1050.88 410.44 1051.85 409.82 1052.39 409.45C1052.93 409.08 1053.06 408.96 1053.15 408.84C1053.24 408.72 1053.31 408.61 1053.34 408.49C1053.37 408.37 1053.36 408.25 1053.34 408.16C1053.32 408.07 1053.28 408.02 1053.2 407.95C1053.13 407.88 1053.02 407.8 1052.77 407.67",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.18 411.43C1050.88 410.44 1051.85 409.82 1052.39 409.45C1052.93 409.08 1053.06 408.96 1053.15 408.84C1053.24 408.72 1053.31 408.61 1053.34 408.49C1053.37 408.37 1053.36 408.25 1053.34 408.16C1053.32 408.07 1053.28 408.02 1053.2 407.95C1053.13 407.88 1053.02 407.8 1052.77 407.67",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.18 411.43C1049.18 411.43 1049.1 411.47 1049.06 411.49C1048.74 411.66 1048.42 411.82 1048.1 411.99C1047.82 412.14 1047.54 412.28 1047.25 412.42C1047.01 412.54 1046.78 412.66 1046.54 412.77C1046.35 412.86 1046.16 412.95 1045.96 413.04C1045.8 413.11 1045.64 413.17 1045.48 413.24C1045.34 413.29 1045.2 413.34 1045.06 413.38C1044.93 413.42 1044.81 413.45 1044.68 413.47C1044.56 413.49 1044.44 413.51 1044.32 413.53C1044.2 413.55 1044.09 413.56 1043.97 413.57C1043.86 413.57 1043.74 413.59 1043.63 413.59C1043.52 413.59 1043.41 413.59 1043.3 413.59C1043.24 413.59 1043.18 413.59 1043.12 413.59C1043.07 413.59 1043.01 413.59 1042.96 413.59C1042.9 413.59 1042.84 413.59 1042.78 413.59C1042.62 413.59 1042.46 413.57 1042.3 413.55C1042.16 413.54 1042.02 413.52 1041.88 413.51C1041.6 413.48 1041.32 413.45 1041.05 413.42C1040.75 413.39 1040.46 413.35 1040.16 413.31C1039.9 413.28 1039.65 413.24 1039.39 413.2C1039.2 413.17 1039.01 413.13 1038.82 413.09C1038.68 413.06 1038.54 413.02 1038.4 412.98C1038.33 412.96 1038.25 412.93 1038.18 412.9C1038.13 412.88 1038.09 412.86 1038.04 412.84C1037.96 412.81 1037.89 412.77 1037.82 412.72C1037.76 412.69 1037.71 412.65 1037.66 412.61C1037.62 412.58 1037.58 412.54 1037.55 412.5C1037.52 412.47 1037.49 412.43 1037.47 412.39C1037.46 412.37 1037.45 412.35 1037.44 412.33C1037.42 412.3 1037.41 412.27 1037.4 412.24C1037.36 412.14 1037.34 412.04 1037.33 411.93C1037.33 411.89 1037.33 411.85 1037.33 411.81C1037.33 411.78 1037.33 411.75 1037.33 411.72C1037.33 411.65 1037.35 411.58 1037.36 411.52C1037.36 411.48 1037.38 411.44 1037.39 411.4C1037.4 411.36 1037.41 411.31 1037.42 411.27C1037.45 411.17 1037.47 411.08 1037.51 410.98C1037.54 410.88 1037.58 410.78 1037.61 410.68C1037.64 410.6 1037.67 410.51 1037.71 410.43C1037.73 410.39 1037.75 410.35 1037.77 410.3C1037.79 410.26 1037.81 410.22 1037.83 410.18C1037.85 410.14 1037.88 410.1 1037.9 410.06C1037.95 409.97 1038.01 409.88 1038.07 409.79C1038.11 409.74 1038.14 409.68 1038.18 409.63C1038.22 409.57 1038.26 409.51 1038.3 409.46C1038.39 409.33 1038.48 409.21 1038.58 409.09C1038.63 409.03 1038.69 408.97 1038.74 408.91C1038.79 408.86 1038.83 408.81 1038.88 408.77",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.18 411.43C1049.18 411.43 1049.1 411.47 1049.06 411.49C1048.74 411.66 1048.42 411.82 1048.1 411.99C1047.82 412.14 1047.54 412.28 1047.25 412.42C1047.01 412.54 1046.78 412.66 1046.54 412.77C1046.35 412.86 1046.16 412.95 1045.96 413.04C1045.8 413.11 1045.64 413.17 1045.48 413.24C1045.34 413.29 1045.2 413.34 1045.06 413.38C1044.93 413.42 1044.81 413.45 1044.68 413.47C1044.56 413.49 1044.44 413.51 1044.32 413.53C1044.2 413.55 1044.09 413.56 1043.97 413.57C1043.86 413.57 1043.74 413.59 1043.63 413.59C1043.52 413.59 1043.41 413.59 1043.3 413.59C1043.24 413.59 1043.18 413.59 1043.12 413.59C1043.07 413.59 1043.01 413.59 1042.96 413.59C1042.9 413.59 1042.84 413.59 1042.78 413.59C1042.62 413.59 1042.46 413.57 1042.3 413.55C1042.16 413.54 1042.02 413.52 1041.88 413.51C1041.6 413.48 1041.32 413.45 1041.05 413.42C1040.75 413.39 1040.46 413.35 1040.16 413.31C1039.9 413.28 1039.65 413.24 1039.39 413.2C1039.2 413.17 1039.01 413.13 1038.82 413.09C1038.68 413.06 1038.54 413.02 1038.4 412.98C1038.33 412.96 1038.25 412.93 1038.18 412.9C1038.13 412.88 1038.09 412.86 1038.04 412.84C1037.96 412.81 1037.89 412.77 1037.82 412.72C1037.76 412.69 1037.71 412.65 1037.66 412.61C1037.62 412.58 1037.58 412.54 1037.55 412.5C1037.52 412.47 1037.49 412.43 1037.47 412.39C1037.46 412.37 1037.45 412.35 1037.44 412.33C1037.42 412.3 1037.41 412.27 1037.4 412.24C1037.36 412.14 1037.34 412.04 1037.33 411.93C1037.33 411.89 1037.33 411.85 1037.33 411.81C1037.33 411.78 1037.33 411.75 1037.33 411.72C1037.33 411.65 1037.35 411.58 1037.36 411.52C1037.36 411.48 1037.38 411.44 1037.39 411.4C1037.4 411.36 1037.41 411.31 1037.42 411.27C1037.45 411.17 1037.47 411.08 1037.51 410.98C1037.54 410.88 1037.58 410.78 1037.61 410.68C1037.64 410.6 1037.67 410.51 1037.71 410.43C1037.73 410.39 1037.75 410.35 1037.77 410.3C1037.79 410.26 1037.81 410.22 1037.83 410.18C1037.85 410.14 1037.88 410.1 1037.9 410.06C1037.95 409.97 1038.01 409.88 1038.07 409.79C1038.11 409.74 1038.14 409.68 1038.18 409.63C1038.22 409.57 1038.26 409.51 1038.3 409.46C1038.39 409.33 1038.48 409.21 1038.58 409.09C1038.63 409.03 1038.69 408.97 1038.74 408.91C1038.79 408.86 1038.83 408.81 1038.88 408.77",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.32 461.158H1022.35V463.718H1042.32V461.158Z",
    fill: "white",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.89 408.729C1038.89 408.729 1038.86 408.759 1038.84 408.779C1038.5 409.099 1038.22 409.489 1038.02 409.789C1037.82 410.089 1037.71 410.279 1037.6 410.529C1037.49 410.779 1037.39 411.099 1037.32 411.359C1037.25 411.609 1037.22 411.809 1037.22 411.979C1037.22 412.159 1037.27 412.319 1037.33 412.449C1037.39 412.579 1037.47 412.689 1037.61 412.809C1037.75 412.919 1037.95 413.049 1038.26 413.149C1038.57 413.259 1039 413.359 1039.72 413.459C1040.44 413.569 1041.44 413.679 1042.08 413.749C1042.72 413.819 1042.99 413.819 1043.28 413.819C1043.58 413.819 1043.9 413.809 1044.23 413.769C1044.56 413.729 1044.9 413.669 1045.3 413.539C1045.69 413.409 1046.15 413.219 1046.78 412.899C1047.41 412.579 1048.24 412.159 1049.2 411.659C1050.15 411.159 1051.23 410.599 1051.93 410.209C1052.27 410.009 1052.52 409.859 1052.71 409.729C1053.2 409.389 1053.27 409.309 1053.32 409.229C1053.37 409.149 1053.42 409.079 1053.46 408.999C1053.49 408.919 1053.51 408.829 1053.53 408.709C1053.54 408.589 1053.55 408.439 1053.54 408.329C1053.54 408.219 1053.52 408.159 1053.49 408.099C1053.46 408.039 1053.43 407.989 1053.35 407.919C1053.27 407.849 1053.15 407.759 1052.82 407.599C1052.81 407.599 1052.8 407.589 1052.78 407.579C1052.7 407.069 1052.62 406.789 1052.55 406.579C1052.46 406.269 1052.39 406.079 1052.31 405.839C1052.23 405.599 1052.15 405.309 1052.01 404.969C1051.88 404.629 1051.69 404.249 1051.48 403.889C1051.27 403.529 1051.02 403.199 1050.72 402.889C1050.42 402.579 1050.07 402.299 1049.81 402.119C1049.56 401.949 1049.4 401.869 1049.22 401.779C1048.92 401.509 1048.72 401.399 1048.54 401.319C1048.36 401.239 1048.2 401.189 1048.07 401.169C1048.05 401.169 1048.03 401.169 1048.01 401.159C1047.94 401.089 1047.87 401.049 1047.8 401.009C1047.76 400.979 1047.71 400.959 1047.67 400.949C1047.57 400.909 1047.47 400.879 1047.35 400.849C1047.23 400.819 1047.09 400.789 1046.94 400.769C1046.79 400.749 1046.63 400.729 1046.41 400.729C1046.19 400.729 1045.93 400.719 1045.67 400.729C1045.41 400.739 1045.16 400.759 1044.92 400.789C1044.68 400.819 1044.46 400.859 1044.23 400.919C1044 400.979 1043.76 401.069 1043.51 401.189C1043.26 401.309 1043.01 401.449 1042.79 401.589C1042.61 401.709 1042.45 401.819 1042.28 401.979C1041.57 402.349 1041.18 402.699 1040.85 403.049C1040.52 403.399 1040.25 403.739 1040.03 404.079C1039.81 404.419 1039.65 404.739 1039.51 405.169C1039.37 405.599 1039.26 406.119 1039.2 406.529C1039.18 406.679 1039.17 406.809 1039.16 406.929C1038.99 407.459 1038.89 408.119 1038.85 408.739L1038.89 408.729Z",
    fill: "white",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.87 408.409C1052.75 407.329 1052.63 406.889 1052.54 406.579C1052.45 406.269 1052.38 406.079 1052.3 405.839C1052.22 405.599 1052.14 405.309 1052 404.969C1051.87 404.629 1051.68 404.249 1051.47 403.889C1051.26 403.529 1051.01 403.199 1050.71 402.889C1050.41 402.579 1050.06 402.299 1049.8 402.119C1049.54 401.939 1049.38 401.859 1049.19 401.769C1049 401.679 1048.78 401.579 1048.57 401.529C1048.37 401.489 1048.18 401.499 1047.96 401.549C1047.74 401.599 1047.5 401.689 1047.3 401.779C1047.1 401.869 1046.96 401.969 1046.71 402.189C1046.46 402.419 1046.11 402.779 1045.15 404.069",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.87 408.409C1052.75 407.329 1052.63 406.889 1052.54 406.579C1052.45 406.269 1052.38 406.079 1052.3 405.839C1052.22 405.599 1052.14 405.309 1052 404.969C1051.87 404.629 1051.68 404.249 1051.47 403.889C1051.26 403.529 1051.01 403.199 1050.71 402.889C1050.41 402.579 1050.06 402.299 1049.8 402.119C1049.54 401.939 1049.38 401.859 1049.19 401.769C1049 401.679 1048.78 401.579 1048.57 401.529C1048.37 401.489 1048.18 401.499 1047.96 401.549C1047.74 401.599 1047.5 401.689 1047.3 401.779C1047.1 401.869 1046.96 401.969 1046.71 402.189C1046.46 402.419 1046.11 402.779 1045.15 404.069",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.02 401.159C1047.9 401.049 1047.79 400.989 1047.68 400.949C1047.58 400.909 1047.48 400.879 1047.36 400.849C1047.24 400.819 1047.1 400.789 1046.95 400.769C1046.8 400.749 1046.64 400.729 1046.42 400.729C1046.2 400.729 1045.94 400.719 1045.68 400.729C1045.42 400.739 1045.17 400.759 1044.93 400.789C1044.69 400.819 1044.47 400.859 1044.24 400.919C1044.01 400.979 1043.77 401.069 1043.52 401.189C1043.27 401.309 1043.02 401.449 1042.8 401.589C1042.58 401.729 1042.4 401.869 1042.19 402.069C1041.98 402.269 1041.73 402.559 1041.49 402.949C1041.25 403.339 1041.01 403.829 1040.83 404.269C1040.64 404.709 1040.5 405.109 1040.37 405.819C1040.23 406.529 1040.1 407.549 1040.04 408.249C1039.98 408.949 1039.99 409.339 1039.98 409.729C1039.96 410.129 1039.92 410.529 1039.59 411.249",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.02 401.159C1047.9 401.049 1047.79 400.989 1047.68 400.949C1047.58 400.909 1047.48 400.879 1047.36 400.849C1047.24 400.819 1047.1 400.789 1046.95 400.769C1046.8 400.749 1046.64 400.729 1046.42 400.729C1046.2 400.729 1045.94 400.719 1045.68 400.729C1045.42 400.739 1045.17 400.759 1044.93 400.789C1044.69 400.819 1044.47 400.859 1044.24 400.919C1044.01 400.979 1043.77 401.069 1043.52 401.189C1043.27 401.309 1043.02 401.449 1042.8 401.589C1042.58 401.729 1042.4 401.869 1042.19 402.069C1041.98 402.269 1041.73 402.559 1041.49 402.949C1041.25 403.339 1041.01 403.829 1040.83 404.269C1040.64 404.709 1040.5 405.109 1040.37 405.819C1040.23 406.529 1040.1 407.549 1040.04 408.249C1039.98 408.949 1039.99 409.339 1039.98 409.729C1039.96 410.129 1039.92 410.529 1039.59 411.249",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.31 401.969C1041.6 402.339 1041.21 402.689 1040.88 403.039C1040.55 403.389 1040.28 403.729 1040.06 404.069C1039.84 404.409 1039.68 404.729 1039.54 405.159C1039.4 405.589 1039.29 406.109 1039.23 406.519C1039.17 406.929 1039.17 407.219 1039.19 407.589C1039.2 407.969 1039.23 408.429 1039.22 408.949C1039.21 409.459 1039.16 410.029 1039.02 410.389",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.31 401.969C1041.6 402.339 1041.21 402.689 1040.88 403.039C1040.55 403.389 1040.28 403.729 1040.06 404.069C1039.84 404.409 1039.68 404.729 1039.54 405.159C1039.4 405.589 1039.29 406.109 1039.23 406.519C1039.17 406.929 1039.17 407.219 1039.19 407.589C1039.2 407.969 1039.23 408.429 1039.22 408.949C1039.21 409.459 1039.16 410.029 1039.02 410.389",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.88 409.59C1038.84 408.77 1038.95 407.72 1039.2 406.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.88 409.59C1038.84 408.77 1038.95 407.72 1039.2 406.92",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.81 401.009C1047.23 400.909 1046.94 400.929 1046.67 401.009C1046.39 401.089 1046.12 401.239 1045.86 401.479C1045.6 401.719 1045.36 402.069 1045.19 402.319C1045.03 402.569 1044.94 402.729 1044.83 402.999C1044.72 403.269 1044.58 403.629 1044.45 404.099C1044.32 404.559 1044.2 405.119 1044.13 405.729C1044.06 406.339 1044.03 407.029 1044.02 408.099C1044.01 409.169 1044.02 410.639 1044.02 411.689",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.81 401.009C1047.23 400.909 1046.94 400.929 1046.67 401.009C1046.39 401.089 1046.12 401.239 1045.86 401.479C1045.6 401.719 1045.36 402.069 1045.19 402.319C1045.03 402.569 1044.94 402.729 1044.83 402.999C1044.72 403.269 1044.58 403.629 1044.45 404.099C1044.32 404.559 1044.2 405.119 1044.13 405.729C1044.06 406.339 1044.03 407.029 1044.02 408.099C1044.01 409.169 1044.02 410.639 1044.02 411.689",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.22 401.778C1048.92 401.508 1048.72 401.398 1048.54 401.318C1048.36 401.238 1048.2 401.188 1048.07 401.168C1048.05 401.168 1048.03 401.168 1048.01 401.158",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.22 401.778C1048.92 401.508 1048.72 401.398 1048.54 401.318C1048.36 401.238 1048.2 401.188 1048.07 401.168C1048.05 401.168 1048.03 401.168 1048.01 401.158",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.22 408C1048.44 408.25 1048.74 408.91 1048.96 409.46C1049.18 410.01 1049.33 410.44 1049.36 410.71",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.22 408C1048.44 408.25 1048.74 408.91 1048.96 409.46C1049.18 410.01 1049.33 410.44 1049.36 410.71",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.05 408.199C1046.88 408.509 1046.73 409.049 1046.64 409.449C1046.55 409.849 1046.51 410.109 1046.48 410.309C1046.45 410.509 1046.43 410.659 1046.43 410.799C1046.43 410.939 1046.45 411.079 1046.62 411.209",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.05 408.199C1046.88 408.509 1046.73 409.049 1046.64 409.449C1046.55 409.849 1046.51 410.109 1046.48 410.309C1046.45 410.509 1046.43 410.659 1046.43 410.799C1046.43 410.939 1046.45 411.079 1046.62 411.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.36 410.709C1048.66 410.949 1048.3 411.009 1047.95 411.049C1047.61 411.089 1047.28 411.119 1046.61 411.209",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.36 410.709C1048.66 410.949 1048.3 411.009 1047.95 411.049C1047.61 411.089 1047.28 411.119 1046.61 411.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.62 411.209C1046.7 410.539 1046.83 409.699 1047.01 408.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.62 411.209C1046.7 410.539 1046.83 409.699 1047.01 408.689",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.15 409.078C1051.21 409.798 1051.25 409.868 1051.32 409.938C1051.39 409.998 1051.5 410.048 1052.7 409.178",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.15 409.078C1051.21 409.798 1051.25 409.868 1051.32 409.938C1051.39 409.998 1051.5 410.048 1052.7 409.178",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 408.549C1052.59 408.579 1052.63 408.589 1052.65 408.639C1052.68 408.689 1052.68 408.769 1052.69 409.179",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 408.549C1052.59 408.579 1052.63 408.589 1052.65 408.639C1052.68 408.689 1052.68 408.769 1052.69 409.179",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 408.549L1051.15 409.079",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.76 407.59C1052.76 407.59 1052.78 407.6 1052.8 407.61C1053.13 407.77 1053.25 407.86 1053.33 407.93C1053.41 408 1053.44 408.05 1053.47 408.11C1053.5 408.17 1053.51 408.23 1053.52 408.34C1053.52 408.45 1053.52 408.6 1053.51 408.72C1053.5 408.84 1053.48 408.93 1053.44 409.01C1053.41 409.09 1053.36 409.16 1053.3 409.24C1053.24 409.32 1053.18 409.4 1052.69 409.74",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.76 407.59C1052.76 407.59 1052.78 407.6 1052.8 407.61C1053.13 407.77 1053.25 407.86 1053.33 407.93C1053.41 408 1053.44 408.05 1053.47 408.11C1053.5 408.17 1053.51 408.23 1053.52 408.34C1053.52 408.45 1053.52 408.6 1053.51 408.72C1053.5 408.84 1053.48 408.93 1053.44 409.01C1053.41 409.09 1053.36 409.16 1053.3 409.24C1053.24 409.32 1053.18 409.4 1052.69 409.74",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.46 422.939C1049.02 423.099 1048.43 423.119 1047.97 423.029C1047.51 422.939 1047.16 422.749 1047.01 422.489C1046.9 422.299 1046.9 422.069 1046.78 421.919C1046.66 421.759 1046.42 421.679 1046.3 421.519C1046.2 421.389 1046.17 421.219 1046.08 421.189C1045.97 421.149 1045.79 421.269 1045.61 421.299C1045.41 421.329 1045.22 421.259 1045.03 421.099C1044.82 420.929 1044.6 420.669 1044.61 420.489C1044.61 420.349 1044.75 420.269 1044.87 420.109C1045.05 419.859 1045.16 419.419 1045.26 418.959C1045.38 418.389 1045.49 417.789 1045.43 417.109C1045.36 416.319 1045.06 415.439 1044.61 414.849C1044.35 414.519 1044.12 414.039 1043.83 413.779",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.46 422.939C1049.02 423.099 1048.43 423.119 1047.97 423.029C1047.51 422.939 1047.16 422.749 1047.01 422.489C1046.9 422.299 1046.9 422.069 1046.78 421.919C1046.66 421.759 1046.42 421.679 1046.3 421.519C1046.2 421.389 1046.17 421.219 1046.08 421.189C1045.97 421.149 1045.79 421.269 1045.61 421.299C1045.41 421.329 1045.22 421.259 1045.03 421.099C1044.82 420.929 1044.6 420.669 1044.61 420.489C1044.61 420.349 1044.75 420.269 1044.87 420.109C1045.05 419.859 1045.16 419.419 1045.26 418.959C1045.38 418.389 1045.49 417.789 1045.43 417.109C1045.36 416.319 1045.06 415.439 1044.61 414.849C1044.35 414.519 1044.12 414.039 1043.83 413.779",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.86 413.309C1046.07 413.919 1046.27 414.409 1046.46 414.819C1046.61 415.139 1046.74 415.419 1046.98 415.669C1047.25 415.949 1047.65 416.199 1048.1 416.409C1048.61 416.649 1049.18 416.839 1049.57 417.439C1050.15 418.319 1050.34 420.099 1050.32 421.259",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.86 413.309C1046.07 413.919 1046.27 414.409 1046.46 414.819C1046.61 415.139 1046.74 415.419 1046.98 415.669C1047.25 415.949 1047.65 416.199 1048.1 416.409C1048.61 416.649 1049.18 416.839 1049.57 417.439C1050.15 418.319 1050.34 420.099 1050.32 421.259",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.72 418.039C1058.53 417.639 1058.29 417.309 1058.03 416.919C1057.76 416.519 1057.47 416.059 1057.02 415.919C1056.44 415.739 1055.59 416.069 1054.82 416.499C1053.86 417.029 1053.02 417.709 1052.15 418.719C1051.02 420.029 1049.82 421.889 1049.17 423.719",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.72 418.039C1058.53 417.639 1058.29 417.309 1058.03 416.919C1057.76 416.519 1057.47 416.059 1057.02 415.919C1056.44 415.739 1055.59 416.069 1054.82 416.499C1053.86 417.029 1053.02 417.709 1052.15 418.719C1051.02 420.029 1049.82 421.889 1049.17 423.719",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.16 415.929C1055.74 415.459 1055.3 414.939 1054.93 414.499C1054.62 414.119 1054.36 413.799 1054.09 413.439",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.16 415.929C1055.74 415.459 1055.3 414.939 1054.93 414.499C1054.62 414.119 1054.36 413.799 1054.09 413.439",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.81 465.9C1069.4 467.14 1068.95 468.28 1068.15 469.46C1067.22 470.83 1065.81 472.24 1064.68 473.46C1063.81 474.41 1063.11 475.24 1062.84 476.05C1062.63 476.68 1062.69 477.3 1062.43 477.94C1062.09 478.79 1061.2 479.7 1060.51 480.75C1059.77 481.89 1059.27 483.21 1058.84 484.34C1058.45 485.37 1058.11 486.24 1057.89 487.47C1057.64 488.88 1057.54 490.75 1057.62 491.71C1057.66 492.17 1057.74 492.42 1057.67 492.68C1057.6 492.91 1057.41 493.16 1057.4 493.39C1057.39 493.64 1057.59 493.88 1057.72 494.19C1057.92 494.67 1057.98 495.31 1058.12 496.15C1058.39 497.81 1058.98 500.23 1059.29 503.79C1059.72 508.74 1059.62 515.88 1058.93 518.68C1058.65 519.81 1058.28 520.23 1058.13 520.97C1057.98 521.76 1058.09 522.9 1058.15 523.71C1058.19 524.22 1058.2 524.6 1057.96 524.81C1057.61 525.11 1056.71 525.05 1055.62 524.83C1053.98 524.49 1051.92 523.77 1050.64 523.11C1049.93 522.74 1049.47 522.39 1049.51 521.95C1049.56 521.44 1050.27 520.81 1050.5 520.07C1050.75 519.29 1050.45 518.4 1050.61 517.68C1050.75 517.02 1051.27 516.5 1051.53 515.91C1051.78 515.34 1051.79 514.7 1051.75 514.03C1051.7 513.27 1051.59 512.47 1051.48 511.55C1051.33 510.35 1051.17 508.93 1051.08 507.38C1050.98 505.7 1050.97 503.87 1050.67 502.5C1050.46 501.53 1050.1 500.78 1050.05 500.15C1050.01 499.69 1050.14 499.29 1049.99 498.86C1049.82 498.39 1049.29 497.88 1049.08 497.52C1048.96 497.3 1048.95 497.14 1048.86 496.98C1048.73 496.76 1048.43 496.54 1048.16 496.17C1047.72 495.54 1047.37 494.47 1047.06 493.39C1046.73 492.22 1046.43 491.03 1046.34 490.02C1046.26 489.1 1046.37 488.34 1046.55 487.19C1046.81 485.49 1047.24 482.95 1047.23 481.02C1047.23 479.54 1046.96 478.41 1047.02 477.38C1047.08 476.47 1047.39 475.65 1047.59 474.61C1047.85 473.29 1047.93 471.62 1048.13 470.01C1048.33 468.34 1048.66 466.73 1048.99 465.1",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.81 465.9C1069.4 467.14 1068.95 468.28 1068.15 469.46C1067.22 470.83 1065.81 472.24 1064.68 473.46C1063.81 474.41 1063.11 475.24 1062.84 476.05C1062.63 476.68 1062.69 477.3 1062.43 477.94C1062.09 478.79 1061.2 479.7 1060.51 480.75C1059.77 481.89 1059.27 483.21 1058.84 484.34C1058.45 485.37 1058.11 486.24 1057.89 487.47C1057.64 488.88 1057.54 490.75 1057.62 491.71C1057.66 492.17 1057.74 492.42 1057.67 492.68C1057.6 492.91 1057.41 493.16 1057.4 493.39C1057.39 493.64 1057.59 493.88 1057.72 494.19C1057.92 494.67 1057.98 495.31 1058.12 496.15C1058.39 497.81 1058.98 500.23 1059.29 503.79C1059.72 508.74 1059.62 515.88 1058.93 518.68C1058.65 519.81 1058.28 520.23 1058.13 520.97C1057.98 521.76 1058.09 522.9 1058.15 523.71C1058.19 524.22 1058.2 524.6 1057.96 524.81C1057.61 525.11 1056.71 525.05 1055.62 524.83C1053.98 524.49 1051.92 523.77 1050.64 523.11C1049.93 522.74 1049.47 522.39 1049.51 521.95C1049.56 521.44 1050.27 520.81 1050.5 520.07C1050.75 519.29 1050.45 518.4 1050.61 517.68C1050.75 517.02 1051.27 516.5 1051.53 515.91C1051.78 515.34 1051.79 514.7 1051.75 514.03C1051.7 513.27 1051.59 512.47 1051.48 511.55C1051.33 510.35 1051.17 508.93 1051.08 507.38C1050.98 505.7 1050.97 503.87 1050.67 502.5C1050.46 501.53 1050.1 500.78 1050.05 500.15C1050.01 499.69 1050.14 499.29 1049.99 498.86C1049.82 498.39 1049.29 497.88 1049.08 497.52C1048.96 497.3 1048.95 497.14 1048.86 496.98C1048.73 496.76 1048.43 496.54 1048.16 496.17C1047.72 495.54 1047.37 494.47 1047.06 493.39C1046.73 492.22 1046.43 491.03 1046.34 490.02C1046.26 489.1 1046.37 488.34 1046.55 487.19C1046.81 485.49 1047.24 482.95 1047.23 481.02C1047.23 479.54 1046.96 478.41 1047.02 477.38C1047.08 476.47 1047.39 475.65 1047.59 474.61C1047.85 473.29 1047.93 471.62 1048.13 470.01C1048.33 468.34 1048.66 466.73 1048.99 465.1",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.81 524.91C1057.95 525.36 1058.03 525.73 1058.11 526.29C1058.2 526.98 1058.29 527.96 1058.11 528.41C1058.01 528.66 1057.83 528.75 1057.59 528.82C1057.12 528.94 1056.42 528.96 1055.1 528.96C1052.21 528.97 1046.35 528.94 1042.98 528.96C1041.23 528.96 1040.15 528.99 1039.78 528.33C1039.49 527.81 1039.63 526.87 1039.92 526.33C1040.16 525.88 1040.5 525.7 1041.08 525.54C1042.1 525.26 1043.85 525.04 1045.4 524.6C1047.03 524.13 1048.44 523.42 1049.84 522.59",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.81 524.91C1057.95 525.36 1058.03 525.73 1058.11 526.29C1058.2 526.98 1058.29 527.96 1058.11 528.41C1058.01 528.66 1057.83 528.75 1057.59 528.82C1057.12 528.94 1056.42 528.96 1055.1 528.96C1052.21 528.97 1046.35 528.94 1042.98 528.96C1041.23 528.96 1040.15 528.99 1039.78 528.33C1039.49 527.81 1039.63 526.87 1039.92 526.33C1040.16 525.88 1040.5 525.7 1041.08 525.54C1042.1 525.26 1043.85 525.04 1045.4 524.6C1047.03 524.13 1048.44 523.42 1049.84 522.59",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.71 473.43C1064.44 474.03 1064.19 474.52 1063.99 475.97C1063.71 478.03 1063.52 482.01 1063.09 484.32C1062.72 486.29 1062.17 487.05 1061.69 487.73C1061.29 488.28 1060.93 488.78 1060.93 489.43C1060.93 490.22 1061.43 491.23 1061.46 492.07C1061.48 492.78 1061.17 493.36 1061.12 493.94C1061.07 494.52 1061.29 495.09 1061.48 495.82C1061.77 496.93 1061.99 498.42 1062.24 500.15C1062.59 502.56 1063.01 505.43 1063.15 508.6C1063.3 511.95 1063.15 515.64 1063.2 518.06C1063.23 519.46 1063.32 520.44 1063.1 521.23C1062.93 521.83 1062.58 522.32 1062.55 522.96C1062.52 523.59 1062.8 524.36 1062.56 524.75C1062.33 525.13 1061.62 525.17 1060.96 525.19C1060.23 525.21 1059.56 525.21 1058.01 524.76",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.71 473.43C1064.44 474.03 1064.19 474.52 1063.99 475.97C1063.71 478.03 1063.52 482.01 1063.09 484.32C1062.72 486.29 1062.17 487.05 1061.69 487.73C1061.29 488.28 1060.93 488.78 1060.93 489.43C1060.93 490.22 1061.43 491.23 1061.46 492.07C1061.48 492.78 1061.17 493.36 1061.12 493.94C1061.07 494.52 1061.29 495.09 1061.48 495.82C1061.77 496.93 1061.99 498.42 1062.24 500.15C1062.59 502.56 1063.01 505.43 1063.15 508.6C1063.3 511.95 1063.15 515.64 1063.2 518.06C1063.23 519.46 1063.32 520.44 1063.1 521.23C1062.93 521.83 1062.58 522.32 1062.55 522.96C1062.52 523.59 1062.8 524.36 1062.56 524.75C1062.33 525.13 1061.62 525.17 1060.96 525.19C1060.23 525.21 1059.56 525.21 1058.01 524.76",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.51 524.828C1062.69 525.498 1062.69 526.198 1062.68 526.888C1062.68 527.498 1062.66 528.098 1062.27 528.448C1061.77 528.898 1060.64 528.908 1059.59 528.928C1058.51 528.948 1057.5 528.978 1056.15 528.948",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.51 524.828C1062.69 525.498 1062.69 526.198 1062.68 526.888C1062.68 527.498 1062.66 528.098 1062.27 528.448C1061.77 528.898 1060.64 528.908 1059.59 528.928C1058.51 528.948 1057.5 528.978 1056.15 528.948",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 451.809C1042.74 452.459 1041.72 453.109 1040.71 453.979C1039.85 454.719 1039.01 455.639 1038.25 456.359C1037.75 456.839 1037.28 457.229 1036.88 457.689C1036.41 458.229 1036.05 458.859 1035.82 459.479C1035.61 460.049 1035.53 460.619 1035.26 460.979C1035.21 461.039 1035.16 461.099 1035.1 461.149",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 451.809C1042.74 452.459 1041.72 453.109 1040.71 453.979C1039.85 454.719 1039.01 455.639 1038.25 456.359C1037.75 456.839 1037.28 457.229 1036.88 457.689C1036.41 458.229 1036.05 458.859 1035.82 459.479C1035.61 460.049 1035.53 460.619 1035.26 460.979C1035.21 461.039 1035.16 461.099 1035.1 461.149",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.04 432.639C1056.56 433.389 1056.03 434.349 1055.75 434.979C1055.55 435.439 1055.48 435.719 1055.21 436.269C1054.71 437.269 1053.53 439.169 1053.14 440.429C1052.89 441.239 1052.96 441.789 1052.84 442.319C1052.72 442.839 1052.41 443.329 1052.06 443.969C1051.58 444.829 1051.03 445.949 1050.53 446.959C1050.06 447.919 1049.65 448.799 1049.12 449.619C1048.6 450.419 1047.97 451.159 1047.05 451.569C1046.09 451.999 1044.81 452.059 1043.94 451.809C1043.21 451.599 1042.75 451.159 1042.01 450.619C1041.13 449.979 1039.85 449.189 1039.51 448.469C1039.27 447.959 1039.5 447.499 1039.85 446.969C1040.27 446.339 1040.88 445.629 1041.61 445.109C1042.33 444.599 1043.16 444.279 1043.34 443.789C1043.48 443.399 1043.23 442.899 1043.37 442.529C1043.52 442.149 1044.1 441.909 1044.36 441.599C1044.57 441.349 1044.56 441.049 1044.59 440.739C1044.62 440.379 1044.7 439.989 1044.89 439.549C1045.14 438.959 1045.58 438.259 1045.65 437.559C1045.72 436.899 1045.45 436.259 1045.52 435.669C1045.59 435.119 1045.96 434.629 1046.08 434.129C1046.18 433.709 1046.11 433.289 1046.19 432.979C1046.25 432.729 1046.41 432.559 1046.48 432.299C1046.57 431.909 1046.45 431.309 1046.42 430.629C1046.38 429.759 1046.5 428.739 1046.6 427.889C1046.68 427.149 1046.75 426.529 1047.14 425.889C1047.65 425.049 1048.7 424.159 1049.53 423.379C1050.32 422.619 1050.89 421.959 1051.84 421.179C1053.04 420.189 1054.85 418.999 1056.2 418.359C1057.08 417.939 1057.77 417.759 1058.4 417.929C1059.08 418.119 1059.68 418.719 1060.58 419.459C1061.95 420.579 1064 421.999 1065.32 423.519C1066.61 425.009 1067.2 426.599 1067.77 429.029C1068.62 432.609 1069.44 438.019 1069.79 441.949C1070.04 444.729 1070.04 446.779 1069.97 448.509C1069.91 449.999 1069.78 451.259 1069.97 453.379C1070.24 456.449 1071.16 461.319 1071.72 463.439C1071.94 464.279 1072.11 464.689 1071.85 465.049C1071.5 465.519 1070.39 465.909 1069.18 466.019C1067.42 466.179 1065.43 465.769 1063.26 465.099C1060.87 464.359 1058.27 463.309 1056.28 463.019C1054.73 462.789 1053.54 463.019 1051.95 463.719C1050.4 464.409 1048.48 465.549 1048.13 465.369C1047.95 465.279 1048.18 464.839 1048.34 464.289C1048.61 463.309 1048.62 461.989 1048.82 460.889C1048.99 459.919 1049.3 459.129 1049.31 458.279C1049.33 457.349 1049 456.369 1048.86 455.129C1048.68 453.509 1048.83 451.459 1049.14 449.659",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.04 432.639C1056.56 433.389 1056.03 434.349 1055.75 434.979C1055.55 435.439 1055.48 435.719 1055.21 436.269C1054.71 437.269 1053.53 439.169 1053.14 440.429C1052.89 441.239 1052.96 441.789 1052.84 442.319C1052.72 442.839 1052.41 443.329 1052.06 443.969C1051.58 444.829 1051.03 445.949 1050.53 446.959C1050.06 447.919 1049.65 448.799 1049.12 449.619C1048.6 450.419 1047.97 451.159 1047.05 451.569C1046.09 451.999 1044.81 452.059 1043.94 451.809C1043.21 451.599 1042.75 451.159 1042.01 450.619C1041.13 449.979 1039.85 449.189 1039.51 448.469C1039.27 447.959 1039.5 447.499 1039.85 446.969C1040.27 446.339 1040.88 445.629 1041.61 445.109C1042.33 444.599 1043.16 444.279 1043.34 443.789C1043.48 443.399 1043.23 442.899 1043.37 442.529C1043.52 442.149 1044.1 441.909 1044.36 441.599C1044.57 441.349 1044.56 441.049 1044.59 440.739C1044.62 440.379 1044.7 439.989 1044.89 439.549C1045.14 438.959 1045.58 438.259 1045.65 437.559C1045.72 436.899 1045.45 436.259 1045.52 435.669C1045.59 435.119 1045.96 434.629 1046.08 434.129C1046.18 433.709 1046.11 433.289 1046.19 432.979C1046.25 432.729 1046.41 432.559 1046.48 432.299C1046.57 431.909 1046.45 431.309 1046.42 430.629C1046.38 429.759 1046.5 428.739 1046.6 427.889C1046.68 427.149 1046.75 426.529 1047.14 425.889C1047.65 425.049 1048.7 424.159 1049.53 423.379C1050.32 422.619 1050.89 421.959 1051.84 421.179C1053.04 420.189 1054.85 418.999 1056.2 418.359C1057.08 417.939 1057.77 417.759 1058.4 417.929C1059.08 418.119 1059.68 418.719 1060.58 419.459C1061.95 420.579 1064 421.999 1065.32 423.519C1066.61 425.009 1067.2 426.599 1067.77 429.029C1068.62 432.609 1069.44 438.019 1069.79 441.949C1070.04 444.729 1070.04 446.779 1069.97 448.509C1069.91 449.999 1069.78 451.259 1069.97 453.379C1070.24 456.449 1071.16 461.319 1071.72 463.439C1071.94 464.279 1072.11 464.689 1071.85 465.049C1071.5 465.519 1070.39 465.909 1069.18 466.019C1067.42 466.179 1065.43 465.769 1063.26 465.099C1060.87 464.359 1058.27 463.309 1056.28 463.019C1054.73 462.789 1053.54 463.019 1051.95 463.719C1050.4 464.409 1048.48 465.549 1048.13 465.369C1047.95 465.279 1048.18 464.839 1048.34 464.289C1048.61 463.309 1048.62 461.989 1048.82 460.889C1048.99 459.919 1049.3 459.129 1049.31 458.279C1049.33 457.349 1049 456.369 1048.86 455.129C1048.68 453.509 1048.83 451.459 1049.14 449.659",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.76 461.158C1028.4 460.338 1029.35 459.028 1029.8 458.188C1030.12 457.588 1030.19 457.238 1030.53 456.848C1030.94 456.388 1031.74 455.898 1032.18 455.558C1032.46 455.338 1032.6 455.178 1032.79 455.038C1033.09 454.818 1033.54 454.628 1033.99 454.358C1034.53 454.028 1035.08 453.588 1035.83 452.748C1036.66 451.818 1037.75 450.398 1038.54 449.468C1038.91 449.038 1039.22 448.718 1039.51 448.408",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.76 461.158C1028.4 460.338 1029.35 459.028 1029.8 458.188C1030.12 457.588 1030.19 457.238 1030.53 456.848C1030.94 456.388 1031.74 455.898 1032.18 455.558C1032.46 455.338 1032.6 455.178 1032.79 455.038C1033.09 454.818 1033.54 454.628 1033.99 454.358C1034.53 454.028 1035.08 453.588 1035.83 452.748C1036.66 451.818 1037.75 450.398 1038.54 449.468C1038.91 449.038 1039.22 448.718 1039.51 448.408",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.72 415.62C1048.07 415.57 1048.47 415.56 1048.72 415.24C1049.13 414.72 1049.14 413.34 1048.83 412.35C1048.78 412.2 1048.73 412.05 1048.67 411.92",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.72 415.62C1048.07 415.57 1048.47 415.56 1048.72 415.24C1049.13 414.72 1049.14 413.34 1048.83 412.35C1048.78 412.2 1048.73 412.05 1048.67 411.92",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.06 411.72C1049.06 411.72 1049.11 411.75 1049.14 411.76C1049.7 412.08 1050.72 413.06 1051.46 413.6C1051.95 413.97 1052.31 414.13 1052.71 414.07C1053.09 414 1053.5 413.73 1053.8 413.58C1053.99 413.49 1054.14 413.45 1054.17 413.3C1054.23 413.02 1053.86 412.37 1053.62 411.71C1053.36 411 1053.23 410.28 1052.97 409.52",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.06 411.72C1049.06 411.72 1049.11 411.75 1049.14 411.76C1049.7 412.08 1050.72 413.06 1051.46 413.6C1051.95 413.97 1052.31 414.13 1052.71 414.07C1053.09 414 1053.5 413.73 1053.8 413.58C1053.99 413.49 1054.14 413.45 1054.17 413.3C1054.23 413.02 1053.86 412.37 1053.62 411.71C1053.36 411 1053.23 410.28 1052.97 409.52",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.28 413.539C1040.38 414.679 1040.9 415.889 1041.42 416.599C1041.77 417.079 1042.13 417.319 1042.42 417.499C1042.62 417.619 1042.78 417.709 1042.89 417.899C1043.05 418.169 1043.08 418.639 1043.06 419.199C1043.04 419.819 1042.96 420.549 1043.28 420.769C1043.57 420.969 1044.21 420.719 1044.61 420.499",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.28 413.539C1040.38 414.679 1040.9 415.889 1041.42 416.599C1041.77 417.079 1042.13 417.319 1042.42 417.499C1042.62 417.619 1042.78 417.709 1042.89 417.899C1043.05 418.169 1043.08 418.639 1043.06 419.199C1043.04 419.819 1042.96 420.549 1043.28 420.769C1043.57 420.969 1044.21 420.719 1044.61 420.499",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.14 528.949C1055.84 528.949 1055.5 528.949 1055.1 528.959C1052.21 528.969 1046.35 528.939 1042.98 528.959C1041.23 528.959 1040.15 528.989 1039.78 528.329C1039.49 527.809 1039.63 526.869 1039.92 526.329C1040.16 525.879 1040.5 525.699 1041.08 525.539C1042.1 525.259 1043.85 525.039 1045.4 524.599C1047.03 524.129 1048.44 523.419 1049.84 522.589C1049.62 522.389 1049.5 522.179 1049.52 521.949C1049.57 521.439 1050.28 520.809 1050.51 520.069C1050.76 519.289 1050.46 518.399 1050.62 517.679C1050.76 517.019 1051.28 516.499 1051.54 515.909C1051.79 515.339 1051.8 514.699 1051.76 514.029C1051.71 513.269 1051.6 512.469 1051.49 511.549C1051.34 510.349 1051.18 508.929 1051.09 507.379C1050.99 505.699 1050.98 503.869 1050.68 502.499C1050.47 501.529 1050.11 500.779 1050.06 500.149C1050.02 499.689 1050.15 499.289 1050 498.859C1049.83 498.389 1049.3 497.879 1049.09 497.519C1048.97 497.299 1048.96 497.139 1048.87 496.979C1048.74 496.759 1048.44 496.539 1048.17 496.169C1047.73 495.539 1047.38 494.469 1047.07 493.389C1046.74 492.219 1046.44 491.029 1046.35 490.019C1046.27 489.099 1046.38 488.339 1046.56 487.189C1046.82 485.489 1047.25 482.949 1047.24 481.019C1047.24 479.539 1046.97 478.409 1047.03 477.379C1047.09 476.469 1047.4 475.649 1047.6 474.609C1047.86 473.289 1047.95 471.619 1048.14 470.009C1048.34 468.339 1048.67 466.729 1049 465.099C1048.56 465.289 1048.23 465.399 1048.11 465.339C1047.93 465.249 1048.16 464.809 1048.32 464.259C1048.59 463.279 1048.6 461.959 1048.8 460.859C1048.97 459.889 1049.28 459.099 1049.29 458.249C1049.31 457.319 1048.98 456.339 1048.84 455.099C1048.66 453.479 1048.81 451.429 1049.12 449.629C1048.6 450.429 1047.97 451.169 1047.05 451.579C1046.1 451.999 1044.85 452.069 1043.98 451.829C1042.72 452.479 1041.69 453.129 1040.69 453.999C1039.83 454.739 1038.99 455.659 1038.23 456.379C1037.73 456.859 1037.26 457.249 1036.86 457.709C1036.39 458.249 1036.03 458.879 1035.8 459.499C1035.59 460.069 1035.51 460.639 1035.24 460.999C1035.19 461.059 1035.14 461.119 1035.08 461.169H1042.31V463.729H1022.34V461.169H1028.75C1028.39 460.349 1029.34 459.039 1029.79 458.199C1030.11 457.599 1030.18 457.249 1030.52 456.859C1030.93 456.399 1031.73 455.909 1032.17 455.569C1032.45 455.349 1032.59 455.189 1032.78 455.049C1033.08 454.829 1033.53 454.639 1033.98 454.369C1034.52 454.039 1035.07 453.599 1035.82 452.759C1036.65 451.829 1037.74 450.409 1038.53 449.479C1038.9 449.049 1039.21 448.729 1039.5 448.419C1039.3 447.929 1039.52 447.479 1039.87 446.969C1040.29 446.339 1040.9 445.629 1041.63 445.109C1042.35 444.599 1043.18 444.279 1043.36 443.789C1043.5 443.399 1043.25 442.899 1043.39 442.529C1043.54 442.149 1044.12 441.909 1044.38 441.599C1044.59 441.349 1044.58 441.049 1044.61 440.739C1044.64 440.379 1044.72 439.989 1044.91 439.549C1045.16 438.959 1045.6 438.259 1045.67 437.559C1045.74 436.899 1045.47 436.259 1045.54 435.669C1045.61 435.119 1045.98 434.629 1046.1 434.129C1046.2 433.709 1046.13 433.289 1046.21 432.979C1046.27 432.729 1046.43 432.559 1046.5 432.299C1046.59 431.909 1046.47 431.309 1046.44 430.629C1046.4 429.759 1046.52 428.739 1046.61 427.889C1046.69 427.149 1046.76 426.529 1047.15 425.889C1047.58 425.179 1048.41 424.429 1049.16 423.729C1049.25 423.469 1049.35 423.209 1049.46 422.959C1049.02 423.119 1048.43 423.139 1047.97 423.049C1047.51 422.959 1047.16 422.769 1047.01 422.509C1046.9 422.319 1046.9 422.089 1046.78 421.939C1046.66 421.779 1046.42 421.699 1046.3 421.539C1046.2 421.409 1046.17 421.239 1046.08 421.209C1045.97 421.169 1045.79 421.289 1045.61 421.319C1045.41 421.349 1045.22 421.279 1045.03 421.119C1044.82 420.949 1044.6 420.689 1044.61 420.509C1044.21 420.729 1043.58 420.979 1043.28 420.779C1042.96 420.569 1043.04 419.829 1043.06 419.209C1043.08 418.639 1043.05 418.179 1042.89 417.909C1042.78 417.729 1042.62 417.629 1042.42 417.509C1042.13 417.329 1041.77 417.089 1041.42 416.609C1040.9 415.909 1040.38 414.689 1040.28 413.549C1040.08 413.519 1039.88 413.499 1039.71 413.469C1038.99 413.359 1038.56 413.269 1038.25 413.159C1037.94 413.049 1037.74 412.929 1037.6 412.819C1037.46 412.709 1037.38 412.599 1037.32 412.459C1037.26 412.329 1037.22 412.169 1037.21 411.989C1037.21 411.809 1037.24 411.619 1037.31 411.369C1037.38 411.119 1037.48 410.799 1037.59 410.539C1037.7 410.279 1037.81 410.089 1038.01 409.799C1038.21 409.509 1038.49 409.109 1038.83 408.789C1038.85 408.769 1038.86 408.759 1038.88 408.739C1038.92 408.119 1039.02 407.469 1039.19 406.929C1039.19 406.799 1039.21 406.669 1039.23 406.529C1039.29 406.119 1039.4 405.599 1039.54 405.169C1039.68 404.739 1039.84 404.419 1040.06 404.079C1040.28 403.739 1040.55 403.399 1040.88 403.049C1041.21 402.699 1041.59 402.359 1042.31 401.979C1042.48 401.819 1042.63 401.709 1042.82 401.589C1043.04 401.449 1043.29 401.299 1043.54 401.189C1043.79 401.069 1044.03 400.979 1044.26 400.919C1044.49 400.859 1044.71 400.819 1044.95 400.789C1045.19 400.759 1045.44 400.739 1045.7 400.729C1045.96 400.719 1046.23 400.729 1046.44 400.729C1046.65 400.729 1046.82 400.749 1046.97 400.769C1047.12 400.789 1047.26 400.819 1047.38 400.849C1047.5 400.879 1047.59 400.909 1047.7 400.949C1047.74 400.969 1047.78 400.989 1047.83 401.009C1047.9 401.049 1047.96 401.089 1048.04 401.159C1048.06 401.159 1048.08 401.159 1048.1 401.169C1048.23 401.199 1048.39 401.239 1048.57 401.319C1048.75 401.399 1048.95 401.509 1049.25 401.779C1049.43 401.869 1049.59 401.949 1049.84 402.119C1050.1 402.299 1050.45 402.579 1050.75 402.889C1051.05 403.199 1051.29 403.529 1051.51 403.889C1051.72 404.249 1051.91 404.629 1052.04 404.969C1052.17 405.309 1052.26 405.599 1052.34 405.839C1052.42 406.079 1052.48 406.269 1052.58 406.579C1052.65 406.799 1052.73 407.069 1052.81 407.579C1052.82 407.579 1052.83 407.589 1052.85 407.599C1053.18 407.759 1053.3 407.849 1053.38 407.919C1053.46 407.989 1053.49 408.039 1053.52 408.099C1053.55 408.159 1053.56 408.219 1053.57 408.329C1053.57 408.439 1053.57 408.589 1053.56 408.709C1053.55 408.829 1053.53 408.919 1053.49 408.999C1053.46 409.079 1053.41 409.149 1053.35 409.229C1053.31 409.289 1053.26 409.349 1053.02 409.529C1053.28 410.289 1053.41 411.009 1053.67 411.719C1053.91 412.379 1054.28 413.029 1054.22 413.309C1054.21 413.369 1054.18 413.409 1054.14 413.439C1054.8 414.299 1055.49 415.129 1056.21 415.929C1056.53 415.849 1056.82 415.839 1057.06 415.909C1057.52 416.049 1057.8 416.509 1058.07 416.909C1058.33 417.299 1058.58 417.629 1058.76 418.029C1059.32 418.289 1059.87 418.819 1060.62 419.439C1061.99 420.559 1064.04 421.979 1065.36 423.499C1066.65 424.989 1067.24 426.579 1067.81 429.009C1068.66 432.589 1069.48 437.999 1069.83 441.929C1070.08 444.709 1070.08 446.759 1070 448.489C1069.94 449.979 1069.81 451.239 1070 453.359C1070.27 456.429 1071.19 461.299 1071.75 463.419C1071.97 464.259 1072.14 464.669 1071.88 465.029C1071.59 465.419 1070.8 465.749 1069.85 465.919C1069.44 467.159 1068.99 468.299 1068.19 469.479C1067.27 470.839 1065.87 472.239 1064.75 473.459C1064.48 474.059 1064.23 474.549 1064.03 475.999C1063.75 478.059 1063.56 482.039 1063.13 484.349C1062.76 486.319 1062.21 487.079 1061.73 487.759C1061.33 488.309 1060.97 488.809 1060.97 489.459C1060.97 490.249 1061.47 491.259 1061.5 492.099C1061.52 492.809 1061.21 493.389 1061.16 493.969C1061.11 494.549 1061.33 495.119 1061.52 495.849C1061.81 496.959 1062.03 498.449 1062.28 500.179C1062.63 502.589 1063.05 505.459 1063.19 508.629C1063.34 511.979 1063.19 515.669 1063.24 518.089C1063.27 519.489 1063.36 520.469 1063.14 521.259C1062.97 521.859 1062.62 522.349 1062.59 522.989C1062.56 523.619 1062.84 524.389 1062.6 524.779C1062.58 524.809 1062.57 524.829 1062.54 524.859C1062.72 525.529 1062.72 526.229 1062.71 526.919C1062.71 527.529 1062.69 528.129 1062.3 528.479C1061.8 528.929 1060.67 528.939 1059.62 528.959C1058.54 528.979 1057.53 529.009 1056.18 528.979L1056.14 528.949Z",
    fill: "white",
    stroke: "#2E24B6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.58 335.529L556.36 306.809",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.82 452.469V504.339",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.93 453.869V502.819",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.37 504.558V451.318",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.15 152.439V23.8789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.25 168.628V40.0684",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.74 166.599V38.0391",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.41 435.729V303.129",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.88 429.659V308.709",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.03 433.788V301.188",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.84 414.128V293.188",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.38 420.198V287.598",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085 418.258V285.658",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.3 389.149V256.549",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.76 383.079V262.139",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.92 387.209V254.609",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.69 479.598V522.218",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.92 519.178L921.69 522.218",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.92 482.389V519.179",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.93 476.829L921.69 420.719",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.93 578.328V476.828",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.8 522.649V417.619",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.63 21.8477L1180.78 200.758",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.63 19.5488L1182.27 199.659",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.76 249.578V121.008",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.25 247.548V118.988",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.55 217.199V88.6289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.04 215.169V86.6094",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.99 462.279L571.45 653.519",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.41 615.199L571.45 662.749",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.61 261.539L749.07 452.789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.61 270.768L749.07 462.008",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.87 387.008L600.42 195.768",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.07 452.788L837.87 387.008",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.07 462.009L837.87 396.229",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.71 181.468V52.8984",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.09 183.408V54.8379",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.55 181.369L911.48 185.339",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.75 196.988V68.4277",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.13 198.929V70.3691",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.59 196.898L890.52 200.868",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.67 165.939V37.3789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.05 167.878V39.3184",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.51 165.848L932.44 169.808",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.9 228.789V130.529",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.28 226.679V132.469",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.74 220.599V138.049",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.86 237.228V115.008",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.7 237.489V122.529",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.63 150.418V21.8477",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.01 152.359V23.7891",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.47 150.318L953.4 154.288",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.06 507.288V386.338",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.6 513.358V380.758",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.22 511.418V378.818",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.1 522.809V401.869",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.64 528.879V396.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.26 526.938V394.338",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.8 396.498L660.26 587.738",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.07 521.969L511.61 330.719",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.45 451.258V318.658",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.91 445.178V324.238",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.07 449.309V316.719",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.49 466.778V334.178",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.95 460.708V339.758",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.11 464.838V332.238",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.93 535.708L921.69 479.598",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.69 476.869L885.36 503.769",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.92 473.828L885.36 497.938",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.07 632.268L559.74 669.858",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 460.359L837.8 454.789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 460.359L818.62 479.669",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.62 479.668V616.888",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 597.569V460.359",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.07 739.238L559.74 776.828",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.87 387.009L926.68 321.229",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.87 396.229L926.68 330.459",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.04 591.549L769.32 590.969",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.8 398.608V277.658",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.96 402.739V270.139",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.48 637.198V533.398",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 644.129L818 603.699",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 616.379V603.699",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.36 503.769V447.619",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.26 449.928V506.068",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.29 590.949L769.99 591.579",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.77 520.068L818 479.168",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 537.168L818 496.729",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.74 653.309V790.529",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 657.788V520.578",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.06 536.348V523.658",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.03 491.758V370.818",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.18 495.889V363.289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.99 476.239V355.289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.15 480.368V347.768",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.41 615.198L333.99 471.498",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.62 594.209V508.119",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.87 503.479V597.118",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.87 597.119L768.48 627.039",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.63 150.408L875.24 212.178",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.62 262.348L958.63 150.408",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.94 198.978V70.418",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.35 261.068V135.178",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.78 211.819V83.9492",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.16 209.709V85.8887",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.01 178.139V177.109",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.14 556.368L811.27 555.668",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.19 480.199L990.99 472.199",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.14 231.359V102.799",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.14 208.879L827.4 241.269",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.22 324.119L871.14 208.879",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.13 193.838L919.77 394.068",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 202.209L927.31 402.449",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 199.908L927.31 400.148",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.82 221.699V99.4785",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.2 223.638V101.418",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.65 336.498L1187.19 342.578",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.65 336.499V215.559",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.81 340.639V208.039",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.96 7.64844L739.32 170.328",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.63 19.5391L746.85 176.399",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.63 21.8477L748.34 177.598",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.06 536.348L927.31 537.358",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 337.119L927.31 537.359",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.95 557.498V600.818",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.43 636.988L816.74 602.678",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.43 635.759L816.74 601.459",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.14 599.689L811.27 598.979",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.77 394.068L837.8 454.788",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.06 416.689V399.129",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 476.948L926.06 416.688",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.26 373.629V241.029",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.72 367.559V246.609",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.88 371.688V239.088",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.23 358.098V225.498",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.69 352.028V231.088",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.85 356.159V223.559",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.36 636.438V737.938",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.72 669.747L517.36 636.438",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.72 771.248V669.748",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.36 737.939L521.29 735.029",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.74 774.798L514.38 738.268",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.84 182.789V54.2285",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.97 195.018V161.578",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.81 186.839V169.109",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.35 192.908V163.518",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.94 211.899V146.059",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.31 209.788V147.998",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.78 203.718V153.578",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.24 239.169V116.949",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.26 506.068L845.93 532.978",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.63 212.418L853.82 220.418",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.66 227.949L832.86 235.949",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.76 154.538L969.01 150.648",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.86 170.728L989.11 166.838",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.37 251.679L1089.62 247.789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.16 219.298L1049.42 215.408",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.17 214.548V185.768",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.03 208.729V192.109",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.85 313.429L1170.03 312.549",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.65 216.408V183.748",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.07 229.438V169.578",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.88 297.869L1149.93 296.359",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.55 231.299V167.559",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.93 223.608V175.918",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 479.168L818.62 479.668",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 616.379L818.62 616.889",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.38 738.268L513.07 739.238",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.76 277.769L1106.65 269.629",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.92 282.318L1129.82 280.168",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.62 247.789L1099.35 255.629",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.93 296.359L1158.69 303.419",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.03 312.549L1179.65 320.299",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.06 406.919L938.26 398.219",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.93 484.098L857.38 468.348",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.8 521.219L928.1 518.779",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.26 511.248L949.06 503.248",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.22 495.729L970.03 487.729",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 597.568L926.68 536.848",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.38 420.199L1064.03 433.789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.41 435.729L1043.07 449.309",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.45 451.258L1022.11 464.838",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.49 466.779L1001.15 480.369",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.6 513.359L938.26 526.939",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.64 528.879L927.31 535.049",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.84 414.129L1064.03 422.129",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.88 429.658L1043.07 437.658",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.91 445.178L1022.11 453.188",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.95 460.709L1001.15 468.709",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.06 507.289L938.26 515.289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.1 522.809L926.06 524.329",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 583.908L926.06 523.658",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.92 371.518L1137.72 363.518",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.37 504.549L882.26 506.069",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 596.598L926.06 536.348",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.42 215.408L1059.14 223.248",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.01 150.648L978.74 158.488",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.11 166.838L998.84 174.678",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.8 514.878L928.1 512.428",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.26 504.908L949.06 496.908",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.22 489.389L970.03 481.379",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.82 377.238L605.03 405.968",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.92 517.109L895.47 499.029",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.93 494.559L885.36 490.889",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.11 442.809L1032.91 434.809",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.07 427.279L1053.88 419.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.03 411.758L1074.84 403.758",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085 396.228L1094.77 388.988",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.84 372.938L1064.03 364.238",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.88 356.058L1043.07 347.348",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.91 339.169L1023.25 331.389",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.11 449.148L1032.91 441.148",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.07 433.619L1053.88 425.619",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.03 418.098L1074.84 410.098",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085 402.568L1094.77 395.328",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.3 389.148L1105.96 402.738",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.76 383.078L1105.96 391.078",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.93 502.818L878.82 504.338",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.49 341.089L563.27 312.369",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.48 150.318L937.67 158.318",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.51 165.848L916.71 173.848",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.55 181.369L895.75 189.369",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.59 196.898L874.78 204.898",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 581.968L924.8 522.648",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.62 247.788V127.348",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.93 530.069L880.37 504.559",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.82 504.338L845.93 528.698",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.93 502.818L845.93 525.778",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.01 150.649V30.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.11 166.838V46.3984",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.41 435.729L1064.03 433.789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.88 429.658L1061.41 435.728",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.84 414.129L1082.38 420.199",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.38 420.198L1085 418.258",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.3 389.149L1126.92 387.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.76 383.078L1124.3 389.148",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.69 420.719V476.869",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.92 423.508V473.828",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.69 522.219L845.93 578.329",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.92 519.178L845.93 572.498",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.63 19.5488V21.8488",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.49 13.7188L958.63 19.5487",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.49 13.7188L1190.13 193.839",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.42 215.409V94.9688",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.45 653.518L660.26 587.738",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.8 396.498L333.99 462.278",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.99 471.499V462.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.45 662.748V653.518",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.26 596.968V587.738",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.45 662.749L660.26 596.969",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.42 195.768L511.61 261.538",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.61 270.769V261.539",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.07 462.009V452.789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.87 396.228V387.008",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.03 312.547V222.688",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.55 181.368V60.4277",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.59 196.899V75.9492",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.51 165.848V44.8984",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.93 296.358V237.568",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.47 150.319V29.3789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.06 507.289L956.6 513.359",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.6 513.358L959.22 511.418",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.1 522.809L935.64 528.879",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.64 528.878L938.26 526.938",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.15 153.018L689.23 129.988",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.26 587.739L749.07 521.969",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.61 330.719L422.8 396.499",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.07 531.189V521.969",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.26 596.967L749.07 531.188",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.45 451.259L1043.07 449.309",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.91 445.178L1040.45 451.258",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.49 466.778L1022.11 464.838",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.95 460.709L1019.49 466.779",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.69 479.599V476.869",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.92 473.828L921.69 476.868",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.07 632.269V615.729",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.71 597.568L818.62 616.888",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.8 454.789L811.71 474.109",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.07 751.928L559.74 789.508",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.07 751.928V739.238",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.23 129.988L600.42 195.768",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.68 330.458V321.229",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.8 398.609L1103.34 404.679",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.34 404.678V272.078",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.45 662.748V799.958",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.06 523.658L924.8 522.648",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.03 491.758L977.56 497.828",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.56 497.828V365.229",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.99 476.238L998.53 482.308",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.53 482.309V349.709",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.41 752.409V615.199",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.85 340.469L1179.65 332.469",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.72 294.649L1126.92 285.949",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.06 203.109L1029.31 199.219",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.45 201.007V72.4375",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.23 453.728L801.39 423.258",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.73 388.929L888.89 358.449",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.27 235.488L1069.52 231.598",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.66 233.388V104.818",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.19 342.579V209.979",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.57 556.178V599.498",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.27 555.668V598.978",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.14 556.369V599.689",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.57 599.499L808.22 597.609",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.72 599.258L812.14 599.688",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.72 367.559L1145.26 373.629",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.69 352.029L1166.23 358.099",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.36 737.938L558.72 771.247",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.38 738.268V633.328",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.96 186.919L1009.21 183.029",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.35 184.818V56.2578",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.65 328.419L1168.85 319.719",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.69 311.538L1147.88 302.828",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.88 355.998L1158.69 347.988",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.77 395.328L1095.8 394.568",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.86 259.209V137.199",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.52 231.598L1079.25 239.438",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.9 265.738L1116.76 269.648",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.82 280.168L1137.72 286.538",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.21 183.029L1018.94 190.869",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.72 253.389V143.539",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.19 473.859L990.99 465.859",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.15 458.329L1007.27 453.799",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.99 440.678L980.18 431.979",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.03 423.798L959.22 415.098",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.57 502.229V556.178",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.27 501.709V555.669",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.14 501.059V556.369",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.72 500.639V555.949",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.27 498.748V557.998",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.95 498.248V557.498",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.15 464.679L1007.27 460.139",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 657.789L818.62 616.889",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.41 752.408L559.74 790.528",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.34 404.678L1085 418.258",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.53 482.309L980.18 495.889",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.56 497.828L959.22 511.418",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.8 398.609L1085 406.609",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.99 476.238L980.19 484.238",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.03 491.758L959.22 499.758",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.7 591.309C769.7 591.309 769.71 591.299 769.72 591.289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.13 328.738L1189.81 328.978",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.96 387.049L1116.76 379.049",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.48 619.489L802.62 594.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.48 623.878L805.45 596.488",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.32 590.969C769.54 591.169 769.77 591.369 769.99 591.569",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.99 591.578C769.55 591.868 768.99 591.968 768.48 591.898",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.99 591.578V591.568",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 642.188L768.48 638.428",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 656.819L818 616.379",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.48 590.938C768.72 591.078 769.05 591.078 769.29 590.948",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.3 587.799L774.6 588.039",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.48 588.218L773.88 587.738",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.97 590.178L771.03 589.418",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.76 588.889L772.7 589.639",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.3 587.798C774.3 587.798 774.25 587.758 774.23 587.748C774.12 587.688 773.99 587.658 773.88 587.748",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.03 589.419C771.16 589.319 771.29 589.219 771.42 589.119",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.7 589.639C772.59 589.719 772.49 589.809 772.38 589.889",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.7 590.508C772.59 590.588 772.49 590.678 772.38 590.758",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.48 588.759V588.219",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.99 591.569C769.99 591.569 770.02 591.559 770.04 591.549",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.03 589.418C770.43 589.898 769.85 590.408 769.29 590.948",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.04 591.548C770.7 591.088 771.34 590.628 771.97 590.178",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.03 591.008C771.37 591.458 770.69 591.878 770 592.268",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.7 589.639C773.33 589.159 773.93 588.679 774.48 588.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.88 587.738C773.14 588.058 772.43 588.438 771.75 588.878",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.48 588.219C774.59 588.139 774.62 588.089 774.61 588.059C774.61 588.059 774.61 588.049 774.6 588.039",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.48 588.758C773.93 589.398 773.34 589.978 772.7 590.508",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.38 589.898C772.24 589.998 772.11 590.088 771.97 590.188",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.38 590.758C772.26 590.838 772.15 590.928 772.03 591.008",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.38 590.758V589.898",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.42 589.119C771.53 589.039 771.64 588.959 771.76 588.879",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.34 404.678L1105.96 402.738",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 603.698L816.74 602.678",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.48 638.428L770.43 636.988",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.48 637.199V638.429",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.48 637.198L770.43 635.758",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.26 506.068L885.36 503.768",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 520.578L749.07 531.188",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.99 592.268C769.55 592.558 768.99 592.658 768.48 592.588",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.99 592.268V591.578",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.49 515.008L762.77 520.068",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.71 474.109L756.49 515.009",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 479.169L811.71 474.109",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 496.728V479.168",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 520.578L762.77 520.068",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 657.789L571.45 799.959",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.45 799.959L559.74 790.529",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.49 515.008L748.12 521.208",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.56 497.829L980.18 495.889",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.53 482.309L1001.15 480.369",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.31 199.219L1039.04 207.059",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.99 471.498V608.708",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.41 752.408L513.07 751.928",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.41 752.409L333.99 608.709",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.45 596.488V506.018",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.45 596.489L802.62 594.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.31 199.219V78.7793",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.63 212.419V91.4785",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.63 212.418L865.45 213.088",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.31 535.049L926.06 534.039",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.31 537.359V535.049",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 334.809L1189.81 340.639",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.72 555.949V599.259",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.27 557.998V601.318",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.43 635.758L768.48 634.188",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.08 459.849L926.06 399.129",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.06 401.438L927.31 402.448",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.96 244.319V153.389",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.45 246.189V151.369",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.82 238.499V159.729",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.27 453.799L1001.15 448.859",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.27 555.668L810.57 556.178",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.72 555.949L812.14 556.369",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.27 557.999L812.72 555.949",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.95 557.498L815.27 557.998",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.27 460.139V453.799",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.39 364.768V338.068",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.45 827.628L1196.39 364.768",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.99 636.389V608.709",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.45 827.629V799.959",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.99 636.389L571.45 827.629",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.76 201.518V199.938",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.52 231.598V111.158",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.13 328.739V207.799",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.27 453.798L1011.95 450.328",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.77 388.989L1085 381.119",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.77 395.328V388.988",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.27 460.138L1011.95 456.668",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.31 400.149L926.06 399.129",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 199.908L1190.13 193.838",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.31 402.448V400.148",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 202.208V199.908",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.23 358.098L1147.88 371.688",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.26 373.629L1126.92 387.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.69 352.029L1147.88 360.029",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.73 367.559L1126.92 375.559",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.19 342.578L1168.85 356.158",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.65 336.498L1168.85 344.508",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.66 227.948V106.998",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.66 227.949L844.49 228.609",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.82 280.169V252.459",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.19 342.579L1189.81 340.639",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.49 13.7184L958.96 7.64844",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 334.808L1190.13 328.738",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.67 337.119V334.809",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.57 556.178L808.87 554.818",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.43 636.988V635.758",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.27 598.979L810.57 599.499",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.27 601.318L812.72 599.258",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.95 600.818L815.27 601.318",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.95 600.818L816.74 601.458",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.74 601.459V602.679",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.06 399.128L919.77 394.068",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.26 373.628L1147.88 371.688",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.23 358.098L1168.85 356.158",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.29 639.609V735.029",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.29 735.029L558.72 765.169",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.21 183.028V62.5879",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.61 270.768V272.768",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.61 280.758V324.728",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.61 328.717V330.717",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.07 462.359V464.359",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.07 471.99V525.38",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.07 529.189V531.189",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.68 330.809V332.809",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.68 340.369V393.349",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.68 397.129V399.129",
    stroke: "#2E24B6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.99 476.579V355.639L980.18 363.639L980.19 484.589L990.99 476.579Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.06 507.639V386.689L938.26 394.689V515.639L949.06 507.639Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.03 492.11V371.17L959.22 379.17V500.11L970.03 492.11Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.15 152.909L739.93 169.759L958.96 7.53906L1197.67 199.799V202.099L1190.13 207.689V328.629L1197.67 334.699V337.009L1196.39 337.959V364.659L571.45 827.519L333.99 636.279V462.169L511.61 330.609L517.58 335.419L556.36 306.699L511.61 270.659V261.429L689.23 129.879L719.15 152.909Z",
    stroke: "#2E24B6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.23 130.34L926.68 321.58V330.81L749.07 462.36L511.61 271.11V261.89L689.23 130.34Z",
    stroke: "#2E24B6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.66 228.3V107.35L832.86 115.35V236.3L843.66 228.3Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.7 237.489V122.479L811.9 130.479V228.789L822.7 237.489Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.74 220.6V139.25L790.94 147.25V211.9L801.74 220.6Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.78 203.718V154.318L769.97 162.318V195.018L780.78 203.718Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.81 185.719V169.809L749.01 177.819L759.81 185.719Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.63 212.768V91.8281L853.82 99.8281V220.768L864.63 212.768Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.59 197.249V76.2988L874.78 84.2988V205.249L885.59 197.249Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.55 181.719V60.7793L895.75 68.7793V189.719L906.55 181.719Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.51 45.25L916.71 53.25V174.2L927.51 166.19V45.25Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.47 150.669V29.7188L937.67 37.7288V158.669L948.47 150.669Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.01 150.999L978.74 158.839V38.3888L969.01 30.5488V150.999Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.11 167.188L998.84 175.028V54.5783L989.11 46.7383V167.188Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.21 183.38L1018.94 191.22V70.7697L1009.21 62.9297V183.38Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.31 199.569L1039.04 207.409V86.9591L1029.31 79.1191V199.569Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.42 215.759L1059.14 223.599V103.149L1049.42 95.3086V215.759Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.25 119.34L1069.52 111.5V231.95L1079.25 239.79V119.34Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.62 248.139L1099.35 255.979V135.529L1089.62 127.689V248.139Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.76 200.289L1170.03 192.449V209.069L1179.76 201.869V200.289Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.65 216.76V184.1L1149.93 176.26V223.96L1159.65 216.76Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.55 231.648V167.908L1129.82 160.068V238.848L1139.55 231.648Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.45 151.719L1109.72 143.879V253.739L1119.45 246.529V151.719Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.76 269.998V262.488L1111.9 266.088L1116.76 269.998Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.82 280.519L1137.72 286.879V246.959L1129.82 252.809V280.519Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.93 296.71L1158.69 303.77V231.43L1149.93 237.92V296.71Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.03 312.898L1179.65 320.648V215.908L1170.03 223.028V312.898Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.65 336.848V328.768L1168.85 320.068V344.858L1179.65 336.848Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.69 352.38V311.88L1147.88 303.18V360.38L1158.69 352.38Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.72 367.899V294.999L1126.92 286.299V375.909L1137.72 367.899Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.76 383.429V278.119L1106.65 269.969L1105.96 270.489V391.429L1116.76 383.429Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.8 398.96V278.01L1085 286.01V406.96L1095.8 398.96Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.84 414.479V293.539L1064.03 301.539V422.479L1074.84 414.479Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.88 430.009V309.059L1043.07 317.059V438.009L1053.88 430.009Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.91 445.53V324.59L1022.11 332.59V453.53L1032.91 445.53Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.15 348.119V469.059L1011.95 461.059V340.109L1001.15 348.119Z",
    stroke: "#2E24B6",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.49 210.81C1221.68 210.68 1221.85 210.59 1222.05 210.5C1222.28 210.39 1222.56 210.28 1222.82 210.2C1223.08 210.12 1223.33 210.07 1223.57 210.04C1223.81 210.01 1224.03 210.01 1224.27 210.01C1224.51 210.01 1224.76 210.03 1225.02 210.06C1225.28 210.09 1225.54 210.13 1225.75 210.17C1225.96 210.21 1226.12 210.25 1226.26 210.29C1226.4 210.33 1226.54 210.38 1226.65 210.43C1226.76 210.48 1226.85 210.52 1226.95 210.57C1226.99 210.59 1227.03 210.62 1227.07 210.65C1227.13 210.7 1227.19 210.75 1227.25 210.83C1227.27 210.83 1227.29 210.84 1227.31 210.85C1227.43 210.89 1227.58 210.97 1227.75 211.07C1227.92 211.17 1228.09 211.31 1228.35 211.62C1228.52 211.73 1228.66 211.83 1228.88 212.04C1229.11 212.26 1229.42 212.59 1229.67 212.94C1229.92 213.29 1230.11 213.65 1230.27 214.04C1230.43 214.43 1230.55 214.83 1230.64 215.19C1230.72 215.54 1230.77 215.84 1230.81 216.09C1230.85 216.34 1230.89 216.54 1230.94 216.86C1230.97 217.08 1231.01 217.37 1231.02 217.89C1231.03 217.89 1231.04 217.9 1231.05 217.91C1231.36 218.11 1231.46 218.22 1231.53 218.3C1231.6 218.38 1231.62 218.43 1231.64 218.49C1231.66 218.55 1231.67 218.61 1231.66 218.72C1231.66 218.83 1231.62 218.98 1231.59 219.09C1231.56 219.21 1231.53 219.29 1231.48 219.37C1231.43 219.45 1231.38 219.51 1231.31 219.58C1231.24 219.65 1231.17 219.72 1230.63 219.98C1230.43 220.08 1230.16 220.2 1229.79 220.34C1229.05 220.63 1227.9 221.03 1226.88 221.39C1225.86 221.74 1224.99 222.05 1224.31 222.26C1223.63 222.48 1223.16 222.6 1222.75 222.67C1222.34 222.74 1222 222.76 1221.66 222.75C1221.33 222.75 1221 222.71 1220.71 222.67C1220.42 222.63 1220.15 222.58 1219.53 222.43C1218.91 222.28 1217.93 222.02 1217.24 221.81C1216.55 221.6 1216.14 221.44 1215.84 221.29C1215.54 221.14 1215.36 220.99 1215.24 220.86C1215.12 220.73 1215.06 220.61 1215.02 220.47C1214.98 220.33 1214.96 220.16 1214.98 219.99C1215 219.82 1215.06 219.63 1215.17 219.39C1215.28 219.15 1215.42 218.85 1215.57 218.61C1215.72 218.37 1215.86 218.2 1216.1 217.94C1216.34 217.68 1216.68 217.33 1217.06 217.06C1217.08 217.05 1217.1 217.03 1217.12 217.02C1217.25 216.41 1217.45 215.78 1217.69 215.28C1217.72 215.16 1217.75 215.03 1217.79 214.89C1217.9 214.49 1218.09 213.99 1218.29 213.59C1218.49 213.19 1218.7 212.89 1218.97 212.59C1219.24 212.29 1219.55 211.99 1219.93 211.69C1220.31 211.39 1220.73 211.11 1221.5 210.84L1221.49 210.81Z",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.2 317.561L1261.12 317.681",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.92 221.16C1226.92 221.16 1226.83 221.19 1226.79 221.21C1226.45 221.33 1226.11 221.45 1225.76 221.57C1225.46 221.67 1225.16 221.78 1224.86 221.88C1224.61 221.96 1224.36 222.05 1224.1 222.13C1223.9 222.19 1223.69 222.25 1223.49 222.31C1223.32 222.36 1223.16 222.4 1222.99 222.43C1222.85 222.46 1222.7 222.49 1222.56 222.51C1222.43 222.53 1222.3 222.54 1222.17 222.55C1222.05 222.55 1221.93 222.56 1221.81 222.55C1221.69 222.55 1221.58 222.55 1221.46 222.54C1221.35 222.54 1221.23 222.52 1221.12 222.51C1221.01 222.5 1220.9 222.49 1220.8 222.47C1220.74 222.47 1220.68 222.45 1220.62 222.44C1220.57 222.44 1220.51 222.42 1220.46 222.41C1220.4 222.4 1220.34 222.39 1220.28 222.38C1220.12 222.35 1219.97 222.31 1219.81 222.28C1219.67 222.25 1219.54 222.21 1219.41 222.18C1219.14 222.11 1218.87 222.04 1218.6 221.97C1218.31 221.89 1218.02 221.81 1217.73 221.73C1217.48 221.66 1217.23 221.59 1216.99 221.51C1216.8 221.45 1216.62 221.39 1216.44 221.32C1216.3 221.27 1216.17 221.21 1216.04 221.15C1215.97 221.12 1215.9 221.08 1215.83 221.04C1215.79 221.02 1215.74 220.99 1215.7 220.96C1215.63 220.92 1215.56 220.87 1215.5 220.81C1215.45 220.77 1215.4 220.72 1215.36 220.67C1215.33 220.63 1215.29 220.59 1215.26 220.55C1215.24 220.51 1215.21 220.47 1215.2 220.43C1215.2 220.41 1215.18 220.39 1215.18 220.37C1215.17 220.34 1215.16 220.3 1215.15 220.27C1215.13 220.17 1215.12 220.06 1215.13 219.96C1215.13 219.92 1215.13 219.88 1215.14 219.84C1215.14 219.81 1215.15 219.78 1215.16 219.75C1215.18 219.68 1215.2 219.62 1215.22 219.55C1215.23 219.51 1215.25 219.48 1215.26 219.44C1215.28 219.4 1215.29 219.36 1215.31 219.32C1215.35 219.23 1215.39 219.14 1215.44 219.05C1215.49 218.96 1215.53 218.86 1215.58 218.77C1215.62 218.69 1215.67 218.61 1215.71 218.54C1215.73 218.5 1215.76 218.46 1215.79 218.42C1215.82 218.38 1215.84 218.35 1215.87 218.31C1215.9 218.27 1215.93 218.24 1215.96 218.2C1216.03 218.12 1216.1 218.04 1216.17 217.96C1216.21 217.91 1216.26 217.87 1216.3 217.82C1216.35 217.77 1216.4 217.72 1216.45 217.67C1216.56 217.56 1216.67 217.45 1216.78 217.35C1216.84 217.3 1216.9 217.24 1216.96 217.19C1217.01 217.15 1217.07 217.11 1217.12 217.07",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.92 221.159C1228.75 220.429 1229.79 219.949 1230.38 219.659C1230.97 219.369 1231.11 219.269 1231.22 219.169C1231.33 219.069 1231.41 218.969 1231.46 218.849C1231.51 218.739 1231.52 218.609 1231.51 218.519C1231.51 218.429 1231.47 218.369 1231.4 218.289C1231.34 218.209 1231.24 218.109 1231.02 217.949",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.64 219.97C1230.44 220.07 1230.17 220.19 1229.8 220.33C1229.06 220.62 1227.91 221.02 1226.89 221.38C1225.87 221.73 1225 222.04 1224.32 222.25C1223.64 222.47 1223.17 222.59 1222.76 222.66C1222.35 222.73 1222.01 222.75 1221.67 222.74C1221.34 222.74 1221.01 222.7 1220.72 222.66C1220.43 222.62 1220.16 222.57 1219.54 222.42C1218.92 222.27 1217.94 222.01 1217.25 221.8C1216.56 221.59 1216.15 221.43 1215.85 221.28C1215.55 221.13 1215.37 220.98 1215.25 220.85C1215.13 220.72 1215.07 220.6 1215.03 220.46C1214.99 220.32 1214.97 220.15 1214.99 219.98C1215.01 219.81 1215.07 219.62 1215.18 219.38C1215.29 219.14 1215.43 218.84 1215.58 218.6C1215.73 218.36 1215.87 218.19 1216.11 217.93C1216.35 217.67 1216.69 217.32 1217.07 217.05C1217.09 217.04 1217.11 217.02 1217.13 217.01",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.02 217.869C1231.02 217.869 1231.04 217.879 1231.05 217.889C1231.36 218.089 1231.46 218.199 1231.53 218.279C1231.6 218.359 1231.62 218.409 1231.64 218.469C1231.66 218.529 1231.67 218.589 1231.66 218.699C1231.66 218.809 1231.62 218.959 1231.59 219.069C1231.56 219.189 1231.53 219.269 1231.48 219.349C1231.43 219.429 1231.38 219.489 1231.31 219.559C1231.24 219.629 1231.17 219.699 1230.63 219.959",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.43 218.75L1229.21 219.12",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.43 218.75C1230.71 218.82 1230.75 218.84 1230.77 218.89C1230.79 218.94 1230.78 219.02 1230.73 219.43",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.21 219.119C1229.16 219.839 1229.19 219.919 1229.25 219.989C1229.31 220.059 1229.41 220.129 1230.72 219.439",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.41 220.569C1224.58 219.919 1224.83 219.109 1225.16 218.129",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.21 220.471C1226.48 220.601 1226.12 220.611 1225.77 220.601C1225.42 220.601 1225.1 220.571 1224.42 220.571",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.28 217.65C1225.06 217.94 1224.84 218.45 1224.69 218.83C1224.54 219.21 1224.46 219.46 1224.4 219.66C1224.34 219.86 1224.3 220 1224.28 220.14C1224.26 220.28 1224.26 220.42 1224.41 220.57",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.47 217.619C1226.66 217.899 1226.85 218.599 1226.99 219.169C1227.13 219.739 1227.21 220.189 1227.21 220.469",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.36 211.61C1228.1 211.3 1227.92 211.16 1227.76 211.06C1227.59 210.96 1227.44 210.88 1227.32 210.84C1227.3 210.84 1227.28 210.83 1227.26 210.82",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.07 210.65C1226.51 210.46 1226.22 210.45 1225.94 210.49C1225.65 210.53 1225.37 210.63 1225.08 210.84C1224.79 211.04 1224.5 211.35 1224.3 211.57C1224.1 211.8 1223.99 211.94 1223.85 212.19C1223.7 212.44 1223.51 212.78 1223.32 213.22C1223.12 213.66 1222.92 214.19 1222.76 214.79C1222.6 215.39 1222.48 216.06 1222.31 217.12C1222.14 218.18 1221.93 219.64 1221.79 220.67",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.99 217.85C1217.07 217.04 1217.33 216.01 1217.69 215.26",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.49 210.811C1220.73 211.081 1220.3 211.361 1219.92 211.661C1219.54 211.961 1219.23 212.261 1218.96 212.561C1218.69 212.861 1218.48 213.161 1218.28 213.561C1218.08 213.961 1217.9 214.471 1217.78 214.861C1217.67 215.261 1217.62 215.541 1217.58 215.921C1217.54 216.301 1217.49 216.761 1217.41 217.271C1217.33 217.781 1217.2 218.331 1217 218.661",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.25 210.83C1227.14 210.7 1227.04 210.63 1226.95 210.57C1226.85 210.51 1226.76 210.47 1226.65 210.43C1226.54 210.38 1226.4 210.33 1226.26 210.29C1226.12 210.25 1225.96 210.21 1225.75 210.17C1225.54 210.13 1225.28 210.09 1225.02 210.06C1224.76 210.03 1224.51 210.02 1224.27 210.01C1224.03 210.01 1223.81 210.01 1223.57 210.04C1223.33 210.07 1223.08 210.12 1222.82 210.2C1222.56 210.28 1222.29 210.39 1222.05 210.5C1221.82 210.61 1221.62 210.72 1221.38 210.89C1221.14 211.07 1220.86 211.31 1220.56 211.66C1220.27 212.01 1219.96 212.46 1219.71 212.87C1219.46 213.28 1219.27 213.66 1219.03 214.34C1218.79 215.02 1218.51 216.01 1218.35 216.7C1218.19 217.39 1218.15 217.77 1218.07 218.16C1217.99 218.55 1217.89 218.95 1217.46 219.61",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.01 218.699C1231.05 217.609 1230.99 217.169 1230.94 216.839C1230.89 216.519 1230.85 216.319 1230.81 216.069C1230.77 215.819 1230.73 215.519 1230.64 215.169C1230.56 214.819 1230.43 214.409 1230.27 214.019C1230.11 213.629 1229.92 213.269 1229.67 212.919C1229.42 212.569 1229.11 212.239 1228.88 212.019C1228.65 211.799 1228.5 211.699 1228.33 211.579C1228.15 211.459 1227.95 211.329 1227.75 211.259C1227.55 211.189 1227.37 211.169 1227.14 211.189C1226.92 211.209 1226.66 211.259 1226.46 211.319C1226.26 211.379 1226.1 211.459 1225.82 211.649C1225.54 211.839 1225.15 212.139 1224 213.289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.15 222.74C1222.15 223.22 1222.02 223.75 1222.33 223.98C1222.55 224.15 1223 224.15 1223.24 223.98C1223.5 223.79 1223.51 223.37 1223.66 223.07C1223.81 222.74 1224.11 222.54 1224.49 222.41C1224.91 222.27 1225.42 222.21 1225.65 222.41C1225.94 222.65 1225.82 223.28 1225.82 223.82C1225.82 224.55 1226.05 225.15 1225.9 225.73C1225.81 226.1 1225.56 226.47 1225.23 226.77C1224.99 226.99 1224.71 227.18 1224.65 227.48",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.5 239.279C1198.44 239.259 1198.39 239.239 1198.33 239.219C1197.68 238.989 1196.99 238.929 1196.44 238.409C1196.2 238.179 1195.99 237.869 1195.72 237.869C1195.53 237.869 1195.3 238.039 1195.18 238.229C1194.77 238.859 1195.51 239.699 1195.36 240.389C1195.27 240.799 1194.87 241.149 1194.46 241.289C1194.02 241.439 1193.57 241.339 1193.11 241.379C1192.91 241.399 1192.7 241.439 1192.5 241.459",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.41 239.889C1210.41 239.889 1210.33 239.879 1210.3 239.869C1209.12 239.639 1207.88 239.849 1206.71 240.229C1205.66 240.569 1204.67 241.039 1203.6 241.189C1203.32 241.229 1203.04 241.239 1202.76 241.309",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.42 237.18C1215.31 237.2 1215.2 237.22 1215.09 237.24C1213.98 237.43 1212.75 237.57 1211.86 238.2C1211.09 238.74 1210.57 239.65 1210.07 240.47",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.5 279.25C1227.5 279.25 1227.46 279.28 1227.44 279.29C1225.63 280.53 1223.41 281.15 1221.77 282.62C1219.94 284.26 1218.82 286.95 1216.6 287.79C1215.88 288.06 1215.05 288.13 1214.26 288.12C1214.13 288.12 1213.99 288.12 1213.86 288.12",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.06 310.34C1218.11 310.43 1218.16 310.51 1218.21 310.6C1218.53 311.14 1218.55 312 1218.28 312.47C1217.74 313.38 1216.02 312.75 1214.61 312.61C1212.92 312.44 1211.68 312.97 1210.25 313.16C1208.97 313.33 1207.55 313.23 1206.31 313.23C1205.41 313.23 1204.61 313.28 1203.47 313.02C1203.06 312.93 1202.61 312.8 1202.57 312.54C1202.54 312.33 1202.75 312.05 1202.98 311.85C1203.33 311.55 1203.72 311.46 1204.09 311.3C1204.56 311.09 1205.01 310.75 1205.54 310.68C1205.8 310.65 1206.08 310.68 1206.3 310.54C1206.31 310.54 1206.33 310.52 1206.34 310.51",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.98 229.879C1226.12 230.779 1225.07 231.449 1224.07 232.209C1223.27 232.819 1222.51 233.469 1221.91 234.289C1221.74 234.519 1221.58 234.769 1221.49 235.039C1221.31 235.589 1221.42 236.229 1221.49 236.779C1221.56 237.279 1221.6 237.719 1221.57 238.359C1221.55 238.729 1221.52 239.169 1221.57 239.269C1221.67 239.449 1222.06 238.529 1222.4 237.859C1222.88 236.909 1223.25 236.449 1223.73 235.949C1224.3 235.349 1225.02 234.679 1225.73 234.039C1226.41 233.429 1227.07 232.849 1227.81 232.379C1228.15 232.159 1228.5 231.969 1228.89 231.799C1229.31 231.609 1229.78 231.439 1230.18 231.449C1231.39 231.479 1232.12 233.099 1232.79 234.459C1233.63 236.139 1234.39 237.439 1234.96 238.889C1235.82 241.099 1236.24 243.679 1236.54 246.199C1236.9 249.229 1237.11 252.169 1237.87 255.089C1238.17 256.249 1238.57 257.409 1238.5 258.609C1238.48 259.049 1238.39 259.499 1238.5 259.919C1238.6 260.439 1238.69 260.969 1238.79 261.489",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.99 231.619C1220.11 231.659 1220.23 231.709 1220.35 231.749C1220.76 231.899 1220.9 232.399 1221.07 232.829C1221.22 233.209 1221.38 233.529 1221.43 233.909",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.52 231.84C1220.46 231.93 1220.4 232.02 1220.35 232.11C1219.94 232.73 1219.24 233.28 1219.03 233.9C1218.76 234.74 1219.41 235.74 1218.79 236.89C1218.47 237.49 1217.81 238.13 1217.95 238.2C1218.07 238.26 1218.69 237.96 1219.03 237.6C1219.58 237.02 1219.39 236.28 1219.63 235.69C1219.83 235.19 1220.33 234.8 1220.83 234.49C1221.06 234.35 1221.3 234.22 1221.55 234.13",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.98 234.119C1218.98 234.119 1218.93 234.129 1218.91 234.139C1217.57 234.519 1216.48 235.589 1215.68 236.769C1215.18 237.519 1214.8 238.309 1214.6 239.159",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.73 233.93C1192.82 233.89 1192.92 233.86 1193.01 233.82C1193.32 233.7 1193.78 233.49 1194 233.64C1194.22 233.78 1194.21 234.27 1194.09 234.63C1193.87 235.3 1193.3 235.55 1192.74 235.89C1192.28 236.17 1191.82 236.51 1191.66 236.97C1191.54 237.3 1191.58 237.7 1191.48 238.05",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.63 237.88C1195.63 237.88 1195.63 237.88 1195.63 237.87C1195.4 237.18 1195.41 236.59 1195.36 235.71C1195.32 235.03 1195.25 234.17 1194.64 234.18C1194.33 234.18 1193.89 234.4 1193.92 234.63C1193.94 234.82 1194.31 235.02 1194.28 235.26",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.74 248.32C1198.74 248.32 1198.71 248.32 1198.7 248.31C1197.67 248.01 1196.61 247.49 1195.91 246.69C1195.25 245.94 1194.89 244.96 1194.38 244.08C1194.11 243.61 1193.79 243.17 1193.48 242.73C1193.22 242.36 1192.95 242 1192.67 241.65C1192.36 241.27 1192.02 240.9 1191.77 240.48C1191.44 239.93 1191.24 239.3 1191.05 238.68C1190.85 238.02 1190.66 237.37 1190.51 236.7C1190.38 236.14 1190.28 235.57 1190.33 234.99C1190.39 234.31 1190.65 233.61 1191.05 233.1C1191.39 232.67 1191.83 232.38 1192.49 232.2C1192.87 232.09 1193.33 232.03 1193.48 232.2C1193.65 232.4 1193.43 232.9 1193.21 233.28C1192.93 233.77 1192.65 234.06 1192.31 234.36C1191.97 234.66 1191.58 234.95 1191.32 235.35C1191.14 235.62 1191.02 235.94 1191.05 236.25",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.17 245.571C1201.93 244.681 1202.49 243.791 1202.74 242.851C1202.99 241.931 1202.95 240.951 1202.65 240.121C1202.44 239.541 1202.11 239.041 1201.71 238.461C1201.43 238.061 1201.13 237.621 1200.77 237.521C1200.26 237.391 1199.64 237.961 1199.14 238.491C1198.71 238.941 1198.36 239.361 1198.23 239.851C1198.05 240.571 1198.36 241.441 1198.44 242.251C1198.51 242.921 1198.43 243.551 1198.2 244.221C1197.98 244.881 1197.61 245.581 1197.78 246.151C1197.89 246.531 1198.25 246.861 1198.41 247.321C1198.57 247.771 1198.54 248.351 1198.95 248.491C1199 248.511 1199.05 248.531 1199.1 248.541",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.84 258.759C1237.77 259.609 1238.68 260.469 1238.89 261.589C1239.05 262.439 1238.8 263.439 1238.33 264.199C1237.18 266.059 1234.73 266.509 1232.54 267.189C1230.02 267.969 1227.84 269.059 1225.44 269.619C1223.64 270.039 1221.72 270.149 1219.83 269.619C1218.47 269.229 1217.13 268.509 1216.47 267.379C1216.05 266.669 1215.91 265.799 1215.72 264.949C1215.31 263.039 1214.72 261.239 1214.6 259.349C1214.5 257.679 1214.76 255.949 1214.41 254.309C1214.41 254.279 1214.4 254.249 1214.39 254.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.41 268.449C1217.2 268.399 1216.98 268.339 1216.77 268.289C1216.19 268.139 1216.65 269.259 1217.44 269.959C1219.02 271.349 1221.95 271.039 1220.78 271.289",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.88 269.32C1216.79 269.36 1216.7 269.41 1216.61 269.45C1213.92 270.73 1211.79 272.43 1209.1 274.28C1206.47 276.09 1203.3 278.03 1203.26 280.78C1203.26 281.52 1203.47 282.32 1203.59 283.11C1203.78 284.29 1203.76 285.45 1203.76 286.61C1203.76 292.04 1204.23 297.37 1205.43 302.94C1205.65 303.96 1205.89 305 1205.76 305.94C1205.65 306.7 1205.31 307.4 1205.09 308.27C1204.93 308.93 1204.84 309.7 1205.09 310.1C1205.56 310.87 1207.24 310.33 1208.59 310.1C1209.75 309.91 1210.68 309.95 1211.59 310.1C1212.77 310.3 1213.93 310.68 1215.43 310.77C1216.55 310.83 1217.86 310.73 1218.27 310.1C1218.7 309.44 1218.14 308.2 1217.77 307.1C1217.28 305.65 1217.12 304.42 1216.6 303.27C1216.33 302.67 1215.96 302.08 1215.55 301.5",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.97 287.279C1248.94 287.739 1249.83 288.329 1250.81 288.779C1252.17 289.409 1253.69 289.739 1254.98 290.449C1256.58 291.319 1257.85 292.759 1259.15 294.119C1260.17 295.179 1261.22 296.189 1262.15 297.289C1264 299.459 1265.41 301.989 1266.99 304.459C1267.54 305.309 1268.1 306.159 1268.32 307.129C1268.35 307.259 1268.38 307.389 1268.41 307.529",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.98 314.379C1272.12 314.409 1272.25 314.439 1272.39 314.469C1273.32 314.679 1273.47 316.549 1272.88 317.269C1272.41 317.849 1271.45 317.699 1270.68 317.879C1269.92 318.049 1269.35 318.539 1268.73 318.979C1267.83 319.609 1266.84 320.129 1265.8 320.439C1264.47 320.839 1263.05 320.909 1261.65 321.169C1260.63 321.359 1259.62 321.649 1258.6 321.289C1258.51 321.259 1258.42 321.219 1258.36 321.169C1258.11 320.949 1258.38 320.459 1258.6 320.069C1258.87 319.609 1259.07 319.299 1259.33 318.969C1259.57 318.669 1259.85 318.359 1260.18 318.119C1260.51 317.879 1260.88 317.719 1261.28 317.629C1261.85 317.509 1262.47 317.559 1262.99 317.389C1263.47 317.229 1263.86 316.889 1264.33 316.539C1264.56 316.369 1264.81 316.189 1264.82 315.929",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.13 264.49C1238.24 264.59 1238.35 264.69 1238.45 264.79C1239.28 265.55 1239.79 266.58 1240.28 267.62C1241.07 269.29 1241.79 270.98 1241.95 272.79C1241.96 272.93 1241.97 273.06 1241.99 273.2",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.13 281.949C1246.24 282.389 1246.91 283.449 1247.97 284.119C1249.23 284.909 1251.04 285.129 1251.64 286.289C1251.95 286.879 1251.93 287.729 1251.97 288.459C1251.98 288.729 1252 289.009 1252.01 289.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.29 236.17C1225.32 236.95 1223.29 237.99 1221.91 239.52C1220.99 240.54 1220.36 241.79 1219.16 242.75C1218.9 242.96 1218.61 243.16 1218.56 243.47",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.98 243.339C1220.98 243.269 1218.81 243.119 1217 243.939C1216.45 244.189 1215.93 244.529 1215.44 244.899",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.73 245.379C1215.47 245.289 1215.22 245.239 1214.97 245.249C1214.16 245.289 1213.41 245.999 1212.34 246.329C1211.59 246.559 1210.69 246.609 1210.55 247.169C1210.42 247.679 1210.92 248.609 1210.43 248.959",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.3 246.449C1209.5 246.489 1208.62 246.359 1207.91 246.689C1207.42 246.919 1207.01 247.369 1206.47 247.529C1206.19 247.609 1205.88 247.609 1205.63 247.769",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.27 246.45C1207.1 246.47 1206.05 245.94 1204.8 245.85C1203.86 245.78 1202.8 245.96 1202.29 246.69C1201.84 247.34 1201.82 248.42 1201.09 248.72",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.88 247.28C1231.28 247.12 1231.55 246.54 1231.6 246.2C1231.77 245.01 1229.27 246.72 1227.41 247.87C1224.7 249.56 1223.36 250.09 1221.67 251.1C1219.92 252.14 1217.79 253.68 1215.57 254.09C1213.84 254.41 1212.07 254.03 1210.31 253.61C1208.65 253.22 1207.01 252.78 1205.52 252.3C1203.99 251.8 1202.63 251.24 1200.73 250.51C1199.93 250.2 1199.04 249.87 1198.94 249.31C1198.86 248.86 1199.31 248.26 1199.54 247.64C1199.72 247.15 1199.76 246.65 1200.02 246.33C1200.37 245.89 1201.13 245.76 1201.81 245.73C1202.67 245.7 1203.41 245.82 1204.2 245.73",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.29 235.71C1193.54 235.54 1193.98 235.399 1194.19 235.529C1194.46 235.699 1194.35 236.319 1194.1 236.699C1193.78 237.179 1193.23 237.3 1193.02 237.69C1192.88 237.94 1192.89 238.309 1192.75 238.589",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.92 236.971C1194.01 237.141 1194.14 237.331 1194.1 237.511",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.79 271.779C1240.14 272.529 1241.8 272.879 1242.96 273.779C1244.5 274.969 1245.15 277.129 1245.96 279.109C1246.69 280.899 1247.55 282.549 1248.96 283.779C1249.5 284.249 1250.12 284.659 1250.46 285.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.15 304.949C1264.25 305.719 1265.33 306.459 1266.65 306.949C1267.9 307.409 1269.36 307.639 1270.15 308.449C1270.91 309.229 1271.07 310.549 1271.65 311.779C1271.99 312.489 1272.46 313.169 1272.32 313.779C1272.21 314.229 1271.78 314.639 1271.32 314.949C1270.15 315.739 1268.86 315.879 1267.48 315.779C1266.08 315.679 1264.6 315.329 1263.48 315.949C1262.64 316.409 1262.01 317.409 1260.98 317.619C1260.33 317.749 1259.52 317.559 1259.15 317.119C1258.65 316.529 1258.91 315.499 1258.82 314.619C1258.72 313.659 1258.2 312.869 1257.65 312.119C1256.82 310.979 1255.94 309.919 1255.15 308.789C1254.35 307.639 1253.65 306.419 1252.81 305.289C1252.49 304.859 1252.16 304.449 1251.82 304.029",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.11 270.119C1224.37 273.339 1226.08 276.909 1228.12 280.289C1229.68 282.889 1231.44 285.369 1233.46 287.619C1235.56 289.959 1237.95 292.039 1240.13 294.289C1242.15 296.369 1244.01 298.589 1245.97 300.789C1247.51 302.519 1249.12 304.239 1251.14 305.289C1252.13 305.799 1253.22 306.159 1254.14 306.789",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.77 286.459C1213.12 286.939 1213.46 287.439 1213.77 287.949C1214.95 289.879 1215.77 292.059 1216.11 294.279C1216.46 296.579 1216.28 298.929 1216.28 301.279C1216.28 301.949 1216.29 302.629 1216.45 303.279",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.41 227.22C1224.28 227.76 1224.35 228.4 1224.16 228.88C1223.84 229.72 1222.75 230.1 1221.83 230.62C1220.87 231.16 1220.09 231.84 1219 231.7C1218.52 231.64 1217.98 231.41 1217.84 231.04C1217.66 230.58 1218.09 229.88 1217.92 229.38C1217.8 229.02 1217.36 228.75 1217.25 228.38C1217.13 227.97 1217.4 227.43 1217.25 227.05C1217.15 226.82 1216.89 226.65 1216.58 226.55C1216.32 226.47 1216.03 226.44 1215.91 226.3C1215.72 226.07 1216 225.55 1216.33 225.22C1216.66 224.89 1217.03 224.76 1217.24 224.47C1217.49 224.14 1217.54 223.61 1217.49 223.14C1217.45 222.76 1217.34 222.42 1217.24 222.06C1217.21 221.96 1217.19 221.86 1217.16 221.77",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.26 220.15C1230.29 221.07 1230.02 222.04 1229.65 222.9C1229.32 223.68 1228.9 224.36 1228.57 225.14C1228.29 225.8 1228.08 226.53 1228.15 227.22C1228.22 227.82 1228.51 228.39 1228.73 228.96C1228.92 229.46 1229.07 229.98 1229.31 230.46C1229.43 230.7 1229.58 230.93 1229.65 231.2C1229.68 231.3 1229.7 231.4 1229.73 231.5",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.06 310.339C1218.11 310.429 1218.16 310.509 1218.21 310.599C1218.53 311.139 1218.55 311.999 1218.28 312.469C1217.74 313.379 1216.02 312.749 1214.61 312.609C1212.92 312.439 1211.68 312.969 1210.25 313.159C1208.97 313.329 1207.55 313.229 1206.31 313.229C1205.41 313.229 1204.61 313.279 1203.47 313.019C1203.06 312.929 1202.61 312.799 1202.57 312.539C1202.54 312.329 1202.75 312.049 1202.98 311.849C1203.33 311.549 1203.72 311.459 1204.09 311.299C1204.56 311.089 1205.01 310.749 1205.54 310.679C1205.8 310.649 1206.08 310.679 1206.3 310.539C1206.31 310.539 1206.33 310.519 1206.34 310.509C1205.76 310.549 1205.29 310.479 1205.08 310.119C1204.83 309.719 1204.92 308.949 1205.08 308.289C1205.29 307.409 1205.64 306.709 1205.75 305.959C1205.88 305.019 1205.64 303.989 1205.42 302.959C1204.22 297.389 1203.76 292.059 1203.75 286.629C1203.75 285.469 1203.77 284.309 1203.58 283.129C1203.45 282.339 1203.24 281.539 1203.25 280.799C1203.29 278.049 1206.46 276.109 1209.09 274.299C1211.78 272.449 1213.91 270.749 1216.6 269.469C1216.69 269.429 1216.78 269.379 1216.87 269.339C1216.47 268.759 1216.34 268.199 1216.76 268.299C1216.97 268.349 1217.19 268.409 1217.4 268.459C1217.01 268.149 1216.69 267.799 1216.45 267.389C1216.03 266.679 1215.89 265.809 1215.7 264.959C1215.29 263.049 1214.7 261.249 1214.58 259.359C1214.48 257.689 1214.74 255.959 1214.39 254.319C1214.39 254.289 1214.38 254.259 1214.37 254.219C1213.02 254.249 1211.65 253.949 1210.28 253.629C1208.62 253.239 1206.98 252.799 1205.49 252.319C1203.96 251.819 1202.6 251.259 1200.7 250.529C1199.9 250.219 1199.01 249.889 1198.91 249.329C1198.87 249.099 1198.96 248.839 1199.09 248.559L1198.94 248.509C1198.84 248.479 1198.77 248.429 1198.71 248.339C1198.7 248.339 1198.68 248.339 1198.67 248.329C1197.64 248.029 1196.58 247.509 1195.88 246.709C1195.22 245.959 1194.86 244.979 1194.35 244.099C1194.08 243.629 1193.76 243.189 1193.45 242.749C1193.19 242.379 1192.92 242.019 1192.64 241.669C1192.59 241.599 1192.53 241.539 1192.48 241.479C1192.22 241.159 1191.95 240.849 1191.74 240.499C1191.4 239.949 1191.21 239.319 1191.02 238.699C1190.82 238.039 1190.63 237.389 1190.48 236.719C1190.35 236.159 1190.25 235.589 1190.3 235.009C1190.36 234.329 1190.62 233.629 1191.02 233.119C1191.36 232.689 1191.8 232.399 1192.46 232.219C1192.84 232.109 1193.3 232.049 1193.45 232.219C1193.62 232.419 1193.4 232.919 1193.18 233.299C1193.03 233.559 1192.88 233.769 1192.72 233.949C1192.81 233.909 1192.91 233.879 1193 233.839C1193.31 233.719 1193.77 233.509 1193.99 233.659C1194.15 233.759 1194.19 234.049 1194.15 234.329C1194.29 234.249 1194.47 234.199 1194.62 234.199C1195.23 234.199 1195.3 235.049 1195.34 235.729C1195.39 236.609 1195.38 237.199 1195.61 237.889C1195.61 237.889 1195.61 237.889 1195.61 237.899C1195.64 237.899 1195.67 237.889 1195.7 237.889C1195.97 237.889 1196.18 238.199 1196.42 238.429C1196.97 238.949 1197.67 239.009 1198.31 239.239C1198.37 239.259 1198.42 239.279 1198.48 239.299C1198.65 239.039 1198.87 238.779 1199.13 238.509C1199.63 237.979 1200.25 237.409 1200.76 237.539C1201.12 237.629 1201.42 238.069 1201.7 238.479C1202.1 239.059 1202.43 239.559 1202.64 240.139C1202.77 240.499 1202.85 240.889 1202.88 241.299C1203.11 241.259 1203.35 241.239 1203.58 241.209C1204.65 241.069 1205.64 240.589 1206.69 240.249C1207.85 239.869 1209.1 239.659 1210.28 239.889C1210.32 239.889 1210.36 239.899 1210.39 239.909C1210.79 239.259 1211.24 238.629 1211.83 238.209C1212.72 237.579 1213.95 237.449 1215.06 237.249C1215.17 237.229 1215.28 237.209 1215.39 237.189C1215.47 237.049 1215.56 236.909 1215.66 236.769C1216.46 235.589 1217.56 234.519 1218.89 234.139C1218.91 234.139 1218.94 234.129 1218.96 234.119C1218.97 234.049 1218.99 233.969 1219.01 233.899C1219.21 233.269 1219.92 232.729 1220.33 232.109C1220.39 232.019 1220.45 231.929 1220.5 231.839C1220.45 231.799 1220.39 231.769 1220.33 231.749C1220.21 231.709 1220.09 231.659 1219.97 231.619C1219.66 231.719 1219.34 231.759 1218.98 231.709C1218.5 231.649 1217.96 231.419 1217.82 231.049C1217.64 230.589 1218.07 229.889 1217.9 229.389C1217.78 229.029 1217.34 228.759 1217.23 228.389C1217.11 227.979 1217.38 227.439 1217.23 227.059C1217.13 226.829 1216.87 226.659 1216.56 226.559C1216.3 226.479 1216.01 226.449 1215.89 226.309C1215.7 226.079 1215.98 225.559 1216.31 225.229C1216.64 224.899 1217.01 224.769 1217.22 224.479C1217.47 224.149 1217.52 223.619 1217.47 223.149C1217.43 222.769 1217.32 222.429 1217.22 222.069C1217.19 221.969 1217.17 221.869 1217.14 221.779C1216.49 221.579 1216.1 221.429 1215.81 221.279C1215.51 221.129 1215.33 220.979 1215.21 220.849C1215.09 220.719 1215.03 220.599 1214.99 220.459C1214.95 220.319 1214.93 220.149 1214.95 219.979C1214.97 219.809 1215.03 219.619 1215.14 219.379C1215.25 219.139 1215.39 218.839 1215.54 218.599C1215.69 218.359 1215.83 218.189 1216.07 217.929C1216.31 217.669 1216.65 217.319 1217.03 217.049C1217.05 217.039 1217.07 217.019 1217.08 217.009C1217.21 216.399 1217.41 215.769 1217.65 215.269C1217.68 215.149 1217.71 215.019 1217.75 214.879C1217.86 214.479 1218.05 213.979 1218.25 213.579C1218.45 213.179 1218.66 212.879 1218.93 212.579C1219.2 212.279 1219.51 211.979 1219.89 211.679C1220.26 211.379 1220.69 211.099 1221.46 210.829C1221.65 210.699 1221.82 210.609 1222.02 210.519C1222.25 210.409 1222.53 210.299 1222.79 210.219C1223.05 210.139 1223.3 210.089 1223.54 210.059C1223.78 210.029 1224 210.029 1224.24 210.029C1224.48 210.029 1224.73 210.049 1224.99 210.079C1225.25 210.109 1225.51 210.149 1225.72 210.189C1225.93 210.229 1226.09 210.269 1226.23 210.309C1226.37 210.349 1226.51 210.399 1226.62 210.449C1226.73 210.499 1226.82 210.539 1226.92 210.589C1226.96 210.609 1227 210.639 1227.04 210.669C1227.1 210.719 1227.16 210.769 1227.22 210.849C1227.24 210.849 1227.26 210.859 1227.28 210.869C1227.4 210.909 1227.55 210.989 1227.72 211.089C1227.89 211.189 1228.06 211.329 1228.32 211.639C1228.49 211.749 1228.63 211.849 1228.85 212.059C1229.08 212.279 1229.39 212.609 1229.64 212.959C1229.89 213.309 1230.08 213.669 1230.24 214.059C1230.4 214.449 1230.52 214.849 1230.61 215.209C1230.69 215.559 1230.74 215.859 1230.78 216.109C1230.82 216.359 1230.86 216.559 1230.91 216.879C1230.94 217.099 1230.98 217.389 1230.99 217.909C1231 217.909 1231.01 217.919 1231.02 217.929C1231.33 218.129 1231.43 218.239 1231.5 218.319C1231.57 218.399 1231.59 218.449 1231.61 218.509C1231.63 218.569 1231.64 218.629 1231.63 218.739C1231.63 218.849 1231.59 218.999 1231.56 219.109C1231.53 219.229 1231.5 219.309 1231.45 219.389C1231.4 219.469 1231.35 219.529 1231.28 219.599C1231.21 219.669 1231.14 219.739 1230.6 219.999C1230.47 220.059 1230.34 220.119 1230.21 220.179C1230.24 221.099 1229.97 222.069 1229.6 222.929C1229.27 223.709 1228.85 224.389 1228.52 225.169C1228.24 225.829 1228.03 226.559 1228.1 227.249C1228.17 227.849 1228.46 228.419 1228.68 228.989C1228.87 229.489 1229.02 230.009 1229.26 230.489C1229.38 230.729 1229.53 230.959 1229.6 231.229C1229.63 231.329 1229.65 231.429 1229.68 231.529C1229.84 231.489 1230 231.469 1230.14 231.479C1231.35 231.509 1232.08 233.129 1232.75 234.489C1233.59 236.169 1234.35 237.469 1234.92 238.919C1235.78 241.129 1236.2 243.709 1236.5 246.229C1236.86 249.259 1237.07 252.199 1237.83 255.119C1238.13 256.279 1238.53 257.439 1238.46 258.639C1238.44 259.079 1238.35 259.529 1238.46 259.949C1238.53 260.319 1238.59 260.689 1238.66 261.059C1238.74 261.239 1238.79 261.429 1238.83 261.629C1238.99 262.479 1238.74 263.479 1238.27 264.239C1238.21 264.339 1238.15 264.429 1238.08 264.519C1238.19 264.619 1238.3 264.719 1238.4 264.819C1239.23 265.579 1239.74 266.609 1240.23 267.649C1241.02 269.319 1241.74 271.009 1241.9 272.819C1241.91 272.959 1241.92 273.089 1241.94 273.229C1242.28 273.399 1242.61 273.599 1242.9 273.819C1244.44 275.009 1245.09 277.169 1245.9 279.149C1246.63 280.939 1247.49 282.589 1248.9 283.819C1249.43 284.279 1250.04 284.689 1250.38 285.289C1250.89 285.549 1251.33 285.859 1251.57 286.319C1251.88 286.909 1251.86 287.759 1251.9 288.489C1251.91 288.759 1251.93 289.039 1251.94 289.309C1252.95 289.669 1253.98 289.989 1254.9 290.489C1256.5 291.359 1257.77 292.799 1259.07 294.159C1260.09 295.219 1261.14 296.229 1262.07 297.329C1263.92 299.499 1265.33 302.029 1266.91 304.499C1267.46 305.349 1268.02 306.199 1268.24 307.169C1268.27 307.299 1268.3 307.429 1268.33 307.569C1269.01 307.799 1269.64 308.069 1270.07 308.509C1270.83 309.289 1270.99 310.609 1271.57 311.839C1271.91 312.549 1272.38 313.229 1272.24 313.839C1272.19 314.049 1272.07 314.249 1271.9 314.439C1272.04 314.469 1272.17 314.499 1272.31 314.529C1273.24 314.739 1273.39 316.609 1272.8 317.329C1272.33 317.909 1271.37 317.759 1270.6 317.939C1269.84 318.109 1269.27 318.599 1268.65 319.039C1267.75 319.669 1266.76 320.189 1265.72 320.499C1264.39 320.899 1262.97 320.969 1261.57 321.229C1260.55 321.419 1259.54 321.709 1258.52 321.349C1258.43 321.319 1258.34 321.279 1258.28 321.229C1258.03 321.009 1258.3 320.519 1258.52 320.129C1258.79 319.669 1258.99 319.359 1259.25 319.029C1259.49 318.729 1259.77 318.419 1260.1 318.179C1260.38 317.979 1260.69 317.829 1261.02 317.739C1261.05 317.699 1261.07 317.659 1261.1 317.609C1261.03 317.629 1260.95 317.649 1260.88 317.669C1260.23 317.799 1259.42 317.609 1259.05 317.169C1258.55 316.579 1258.81 315.549 1258.72 314.669C1258.62 313.709 1258.1 312.919 1257.55 312.169C1256.72 311.029 1255.84 309.969 1255.05 308.839C1254.52 308.079 1254.04 307.299 1253.53 306.519C1252.73 306.069 1251.86 305.759 1251.04 305.339C1249.02 304.289 1247.41 302.569 1245.87 300.839C1243.91 298.639 1242.06 296.419 1240.03 294.339C1237.84 292.099 1235.46 290.009 1233.36 287.669C1231.34 285.419 1229.58 282.929 1228.02 280.339C1227.81 279.999 1227.61 279.649 1227.41 279.299C1227.39 279.309 1227.37 279.329 1227.35 279.339C1225.54 280.579 1223.32 281.199 1221.68 282.669C1219.85 284.309 1218.73 286.999 1216.51 287.839C1215.79 288.109 1214.96 288.179 1214.17 288.169C1214.04 288.169 1213.9 288.169 1213.77 288.169C1214.9 290.059 1215.68 292.179 1216.01 294.339C1216.36 296.639 1216.18 298.989 1216.18 301.339C1216.18 301.829 1216.18 302.329 1216.25 302.809C1216.35 302.989 1216.43 303.159 1216.51 303.339C1217.03 304.489 1217.19 305.719 1217.68 307.169C1218.05 308.269 1218.61 309.509 1218.18 310.169C1218.12 310.259 1218.05 310.329 1217.97 310.399L1218.06 310.339Z",
    stroke: "#2E24B6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.14 528.949C1055.84 528.949 1055.5 528.949 1055.1 528.959C1052.21 528.969 1046.35 528.939 1042.98 528.959C1041.23 528.959 1040.15 528.989 1039.78 528.329C1039.49 527.809 1039.63 526.869 1039.92 526.329C1040.16 525.879 1040.5 525.699 1041.08 525.539C1042.1 525.259 1043.85 525.039 1045.4 524.599C1047.03 524.129 1048.44 523.419 1049.84 522.589C1049.62 522.389 1049.5 522.179 1049.52 521.949C1049.57 521.439 1050.28 520.809 1050.51 520.069C1050.76 519.289 1050.46 518.399 1050.62 517.679C1050.76 517.019 1051.28 516.499 1051.54 515.909C1051.79 515.339 1051.8 514.699 1051.76 514.029C1051.71 513.269 1051.6 512.469 1051.49 511.549C1051.34 510.349 1051.18 508.929 1051.09 507.379C1050.99 505.699 1050.98 503.869 1050.68 502.499C1050.47 501.529 1050.11 500.779 1050.06 500.149C1050.02 499.689 1050.15 499.289 1050 498.859C1049.83 498.389 1049.3 497.879 1049.09 497.519C1048.97 497.299 1048.96 497.139 1048.87 496.979C1048.74 496.759 1048.44 496.539 1048.17 496.169C1047.73 495.539 1047.38 494.469 1047.07 493.389C1046.74 492.219 1046.44 491.029 1046.35 490.019C1046.27 489.099 1046.38 488.339 1046.56 487.189C1046.82 485.489 1047.25 482.949 1047.24 481.019C1047.24 479.539 1046.97 478.409 1047.03 477.379C1047.09 476.469 1047.4 475.649 1047.6 474.609C1047.86 473.289 1047.95 471.619 1048.14 470.009C1048.34 468.339 1048.67 466.729 1049 465.099C1048.56 465.289 1048.23 465.399 1048.11 465.339C1047.93 465.249 1048.16 464.809 1048.32 464.259C1048.59 463.279 1048.6 461.959 1048.8 460.859C1048.97 459.889 1049.28 459.099 1049.29 458.249C1049.31 457.319 1048.98 456.339 1048.84 455.099C1048.66 453.479 1048.81 451.429 1049.12 449.629C1048.6 450.429 1047.97 451.169 1047.05 451.579C1046.1 451.999 1044.85 452.069 1043.98 451.829C1042.72 452.479 1041.69 453.129 1040.69 453.999C1039.83 454.739 1038.99 455.659 1038.23 456.379C1037.73 456.859 1037.26 457.249 1036.86 457.709C1036.39 458.249 1036.03 458.879 1035.8 459.499C1035.59 460.069 1035.51 460.639 1035.24 460.999C1035.19 461.059 1035.14 461.119 1035.08 461.169H1042.31V463.729H1022.34V461.169H1028.75C1028.39 460.349 1029.34 459.039 1029.79 458.199C1030.11 457.599 1030.18 457.249 1030.52 456.859C1030.93 456.399 1031.73 455.909 1032.17 455.569C1032.45 455.349 1032.59 455.189 1032.78 455.049C1033.08 454.829 1033.53 454.639 1033.98 454.369C1034.52 454.039 1035.07 453.599 1035.82 452.759C1036.65 451.829 1037.74 450.409 1038.53 449.479C1038.9 449.049 1039.21 448.729 1039.5 448.419C1039.3 447.929 1039.52 447.479 1039.87 446.969C1040.29 446.339 1040.9 445.629 1041.63 445.109C1042.35 444.599 1043.18 444.279 1043.36 443.789C1043.5 443.399 1043.25 442.899 1043.39 442.529C1043.54 442.149 1044.12 441.909 1044.38 441.599C1044.59 441.349 1044.58 441.049 1044.61 440.739C1044.64 440.379 1044.72 439.989 1044.91 439.549C1045.16 438.959 1045.6 438.259 1045.67 437.559C1045.74 436.899 1045.47 436.259 1045.54 435.669C1045.61 435.119 1045.98 434.629 1046.1 434.129C1046.2 433.709 1046.13 433.289 1046.21 432.979C1046.27 432.729 1046.43 432.559 1046.5 432.299C1046.59 431.909 1046.47 431.309 1046.44 430.629C1046.4 429.759 1046.52 428.739 1046.61 427.889C1046.69 427.149 1046.76 426.529 1047.15 425.889C1047.58 425.179 1048.41 424.429 1049.16 423.729C1049.25 423.469 1049.35 423.209 1049.46 422.959C1049.02 423.119 1048.43 423.139 1047.97 423.049C1047.51 422.959 1047.16 422.769 1047.01 422.509C1046.9 422.319 1046.9 422.089 1046.78 421.939C1046.66 421.779 1046.42 421.699 1046.3 421.539C1046.2 421.409 1046.17 421.239 1046.08 421.209C1045.97 421.169 1045.79 421.289 1045.61 421.319C1045.41 421.349 1045.22 421.279 1045.03 421.119C1044.82 420.949 1044.6 420.689 1044.61 420.509C1044.21 420.729 1043.58 420.979 1043.28 420.779C1042.96 420.569 1043.04 419.829 1043.06 419.209C1043.08 418.639 1043.05 418.179 1042.89 417.909C1042.78 417.729 1042.62 417.629 1042.42 417.509C1042.13 417.329 1041.77 417.089 1041.42 416.609C1040.9 415.909 1040.38 414.689 1040.28 413.549C1040.08 413.519 1039.88 413.499 1039.71 413.469C1038.99 413.359 1038.56 413.269 1038.25 413.159C1037.94 413.049 1037.74 412.929 1037.6 412.819C1037.46 412.709 1037.38 412.599 1037.32 412.459C1037.26 412.329 1037.22 412.169 1037.21 411.989C1037.21 411.809 1037.24 411.619 1037.31 411.369C1037.38 411.119 1037.48 410.799 1037.59 410.539C1037.7 410.279 1037.81 410.089 1038.01 409.799C1038.21 409.509 1038.49 409.109 1038.83 408.789C1038.85 408.769 1038.86 408.759 1038.88 408.739C1038.92 408.119 1039.02 407.469 1039.19 406.929C1039.19 406.799 1039.21 406.669 1039.23 406.529C1039.29 406.119 1039.4 405.599 1039.54 405.169C1039.68 404.739 1039.84 404.419 1040.06 404.079C1040.28 403.739 1040.55 403.399 1040.88 403.049C1041.21 402.699 1041.59 402.359 1042.31 401.979C1042.48 401.819 1042.63 401.709 1042.82 401.589C1043.04 401.449 1043.29 401.299 1043.54 401.189C1043.79 401.069 1044.03 400.979 1044.26 400.919C1044.49 400.859 1044.71 400.819 1044.95 400.789C1045.19 400.759 1045.44 400.739 1045.7 400.729C1045.96 400.719 1046.23 400.729 1046.44 400.729C1046.65 400.729 1046.82 400.749 1046.97 400.769C1047.12 400.789 1047.26 400.819 1047.38 400.849C1047.5 400.879 1047.59 400.909 1047.7 400.949C1047.74 400.969 1047.78 400.989 1047.83 401.009C1047.9 401.049 1047.96 401.089 1048.04 401.159C1048.06 401.159 1048.08 401.159 1048.1 401.169C1048.23 401.199 1048.39 401.239 1048.57 401.319C1048.75 401.399 1048.95 401.509 1049.25 401.779C1049.43 401.869 1049.59 401.949 1049.84 402.119C1050.1 402.299 1050.45 402.579 1050.75 402.889C1051.05 403.199 1051.29 403.529 1051.51 403.889C1051.72 404.249 1051.91 404.629 1052.04 404.969C1052.17 405.309 1052.26 405.599 1052.34 405.839C1052.42 406.079 1052.48 406.269 1052.58 406.579C1052.65 406.799 1052.73 407.069 1052.81 407.579C1052.82 407.579 1052.83 407.589 1052.85 407.599C1053.18 407.759 1053.3 407.849 1053.38 407.919C1053.46 407.989 1053.49 408.039 1053.52 408.099C1053.55 408.159 1053.56 408.219 1053.57 408.329C1053.57 408.439 1053.57 408.589 1053.56 408.709C1053.55 408.829 1053.53 408.919 1053.49 408.999C1053.46 409.079 1053.41 409.149 1053.35 409.229C1053.31 409.289 1053.26 409.349 1053.02 409.529C1053.28 410.289 1053.41 411.009 1053.67 411.719C1053.91 412.379 1054.28 413.029 1054.22 413.309C1054.21 413.369 1054.18 413.409 1054.14 413.439C1054.8 414.299 1055.49 415.129 1056.21 415.929C1056.53 415.849 1056.82 415.839 1057.06 415.909C1057.52 416.049 1057.8 416.509 1058.07 416.909C1058.33 417.299 1058.58 417.629 1058.76 418.029C1059.32 418.289 1059.87 418.819 1060.62 419.439C1061.99 420.559 1064.04 421.979 1065.36 423.499C1066.65 424.989 1067.24 426.579 1067.81 429.009C1068.66 432.589 1069.48 437.999 1069.83 441.929C1070.08 444.709 1070.08 446.759 1070 448.489C1069.94 449.979 1069.81 451.239 1070 453.359C1070.27 456.429 1071.19 461.299 1071.75 463.419C1071.97 464.259 1072.14 464.669 1071.88 465.029C1071.59 465.419 1070.8 465.749 1069.85 465.919C1069.44 467.159 1068.99 468.299 1068.19 469.479C1067.27 470.839 1065.87 472.239 1064.75 473.459C1064.48 474.059 1064.23 474.549 1064.03 475.999C1063.75 478.059 1063.56 482.039 1063.13 484.349C1062.76 486.319 1062.21 487.079 1061.73 487.759C1061.33 488.309 1060.97 488.809 1060.97 489.459C1060.97 490.249 1061.47 491.259 1061.5 492.099C1061.52 492.809 1061.21 493.389 1061.16 493.969C1061.11 494.549 1061.33 495.119 1061.52 495.849C1061.81 496.959 1062.03 498.449 1062.28 500.179C1062.63 502.589 1063.05 505.459 1063.19 508.629C1063.34 511.979 1063.19 515.669 1063.24 518.089C1063.27 519.489 1063.36 520.469 1063.14 521.259C1062.97 521.859 1062.62 522.349 1062.59 522.989C1062.56 523.619 1062.84 524.389 1062.6 524.779C1062.58 524.809 1062.57 524.829 1062.54 524.859C1062.72 525.529 1062.72 526.229 1062.71 526.919C1062.71 527.529 1062.69 528.129 1062.3 528.479C1061.8 528.929 1060.67 528.939 1059.62 528.959C1058.54 528.979 1057.53 529.009 1056.18 528.979L1056.14 528.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.69 409.719C1052.5 409.849 1052.25 410.009 1051.91 410.199C1051.22 410.599 1050.14 411.159 1049.18 411.649C1048.23 412.149 1047.4 412.579 1046.76 412.889C1046.12 413.199 1045.67 413.399 1045.28 413.529C1044.89 413.659 1044.55 413.729 1044.21 413.759C1043.87 413.789 1043.55 413.809 1043.26 413.809C1042.96 413.809 1042.69 413.809 1042.06 413.739C1041.43 413.669 1040.42 413.559 1039.7 413.449C1038.98 413.339 1038.55 413.249 1038.24 413.139C1037.93 413.029 1037.73 412.909 1037.59 412.799C1037.45 412.689 1037.37 412.579 1037.31 412.439C1037.25 412.309 1037.21 412.149 1037.2 411.969C1037.2 411.789 1037.23 411.599 1037.3 411.349C1037.37 411.099 1037.47 410.779 1037.58 410.519C1037.69 410.259 1037.8 410.069 1038 409.779C1038.2 409.489 1038.48 409.089 1038.82 408.769C1038.84 408.749 1038.85 408.739 1038.87 408.719",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.18 411.43C1050.88 410.44 1051.85 409.82 1052.39 409.45C1052.93 409.08 1053.06 408.96 1053.15 408.84C1053.24 408.72 1053.31 408.61 1053.34 408.49C1053.37 408.37 1053.36 408.25 1053.34 408.16C1053.32 408.07 1053.28 408.02 1053.2 407.95C1053.13 407.88 1053.02 407.8 1052.77 407.67",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.18 411.43C1049.18 411.43 1049.1 411.47 1049.06 411.49C1048.74 411.66 1048.42 411.82 1048.1 411.99C1047.82 412.14 1047.54 412.28 1047.25 412.42C1047.01 412.54 1046.78 412.66 1046.54 412.77C1046.35 412.86 1046.16 412.95 1045.96 413.04C1045.8 413.11 1045.64 413.17 1045.48 413.24C1045.34 413.29 1045.2 413.34 1045.06 413.38C1044.93 413.42 1044.81 413.45 1044.68 413.47C1044.56 413.49 1044.44 413.51 1044.32 413.53C1044.2 413.55 1044.09 413.56 1043.97 413.57C1043.86 413.57 1043.74 413.59 1043.63 413.59C1043.52 413.59 1043.41 413.59 1043.3 413.59C1043.24 413.59 1043.18 413.59 1043.12 413.59C1043.07 413.59 1043.01 413.59 1042.96 413.59C1042.9 413.59 1042.84 413.59 1042.78 413.59C1042.62 413.59 1042.46 413.57 1042.3 413.55C1042.16 413.54 1042.02 413.52 1041.88 413.51C1041.6 413.48 1041.32 413.45 1041.05 413.42C1040.75 413.39 1040.46 413.35 1040.16 413.31C1039.9 413.28 1039.65 413.24 1039.39 413.2C1039.2 413.17 1039.01 413.13 1038.82 413.09C1038.68 413.06 1038.54 413.02 1038.4 412.98C1038.33 412.96 1038.25 412.93 1038.18 412.9C1038.13 412.88 1038.09 412.86 1038.04 412.84C1037.96 412.81 1037.89 412.77 1037.82 412.72C1037.76 412.69 1037.71 412.65 1037.66 412.61C1037.62 412.58 1037.58 412.54 1037.55 412.5C1037.52 412.47 1037.49 412.43 1037.47 412.39C1037.46 412.37 1037.45 412.35 1037.44 412.33C1037.42 412.3 1037.41 412.27 1037.4 412.24C1037.36 412.14 1037.34 412.04 1037.33 411.93C1037.33 411.89 1037.33 411.85 1037.33 411.81C1037.33 411.78 1037.33 411.75 1037.33 411.72C1037.33 411.65 1037.35 411.58 1037.36 411.52C1037.36 411.48 1037.38 411.44 1037.39 411.4C1037.4 411.36 1037.41 411.31 1037.42 411.27C1037.45 411.17 1037.47 411.08 1037.51 410.98C1037.54 410.88 1037.58 410.78 1037.61 410.68C1037.64 410.6 1037.67 410.51 1037.71 410.43C1037.73 410.39 1037.75 410.35 1037.77 410.3C1037.79 410.26 1037.81 410.22 1037.83 410.18C1037.85 410.14 1037.88 410.1 1037.9 410.06C1037.95 409.97 1038.01 409.88 1038.07 409.79C1038.11 409.74 1038.14 409.68 1038.18 409.63C1038.22 409.57 1038.26 409.51 1038.3 409.46C1038.39 409.33 1038.48 409.21 1038.58 409.09C1038.63 409.03 1038.69 408.97 1038.74 408.91C1038.79 408.86 1038.83 408.81 1038.88 408.77",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.32 461.158H1022.35V463.718H1042.32V461.158Z",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.89 408.729C1038.89 408.729 1038.86 408.759 1038.84 408.779C1038.5 409.099 1038.22 409.489 1038.02 409.789C1037.82 410.089 1037.71 410.279 1037.6 410.529C1037.49 410.779 1037.39 411.099 1037.32 411.359C1037.25 411.609 1037.22 411.809 1037.22 411.979C1037.22 412.159 1037.27 412.319 1037.33 412.449C1037.39 412.579 1037.47 412.689 1037.61 412.809C1037.75 412.919 1037.95 413.049 1038.26 413.149C1038.57 413.259 1039 413.359 1039.72 413.459C1040.44 413.569 1041.44 413.679 1042.08 413.749C1042.72 413.819 1042.99 413.819 1043.28 413.819C1043.58 413.819 1043.9 413.809 1044.23 413.769C1044.56 413.729 1044.9 413.669 1045.3 413.539C1045.69 413.409 1046.15 413.219 1046.78 412.899C1047.41 412.579 1048.24 412.159 1049.2 411.659C1050.15 411.159 1051.23 410.599 1051.93 410.209C1052.27 410.009 1052.52 409.859 1052.71 409.729C1053.2 409.389 1053.27 409.309 1053.32 409.229C1053.37 409.149 1053.42 409.079 1053.46 408.999C1053.49 408.919 1053.51 408.829 1053.53 408.709C1053.54 408.589 1053.55 408.439 1053.54 408.329C1053.54 408.219 1053.52 408.159 1053.49 408.099C1053.46 408.039 1053.43 407.989 1053.35 407.919C1053.27 407.849 1053.15 407.759 1052.82 407.599C1052.81 407.599 1052.8 407.589 1052.78 407.579C1052.7 407.069 1052.62 406.789 1052.55 406.579C1052.46 406.269 1052.39 406.079 1052.31 405.839C1052.23 405.599 1052.15 405.309 1052.01 404.969C1051.88 404.629 1051.69 404.249 1051.48 403.889C1051.27 403.529 1051.02 403.199 1050.72 402.889C1050.42 402.579 1050.07 402.299 1049.81 402.119C1049.56 401.949 1049.4 401.869 1049.22 401.779C1048.92 401.509 1048.72 401.399 1048.54 401.319C1048.36 401.239 1048.2 401.189 1048.07 401.169C1048.05 401.169 1048.03 401.169 1048.01 401.159C1047.94 401.089 1047.87 401.049 1047.8 401.009C1047.76 400.979 1047.71 400.959 1047.67 400.949C1047.57 400.909 1047.47 400.879 1047.35 400.849C1047.23 400.819 1047.09 400.789 1046.94 400.769C1046.79 400.749 1046.63 400.729 1046.41 400.729C1046.19 400.729 1045.93 400.719 1045.67 400.729C1045.41 400.739 1045.16 400.759 1044.92 400.789C1044.68 400.819 1044.46 400.859 1044.23 400.919C1044 400.979 1043.76 401.069 1043.51 401.189C1043.26 401.309 1043.01 401.449 1042.79 401.589C1042.61 401.709 1042.45 401.819 1042.28 401.979C1041.57 402.349 1041.18 402.699 1040.85 403.049C1040.52 403.399 1040.25 403.739 1040.03 404.079C1039.81 404.419 1039.65 404.739 1039.51 405.169C1039.37 405.599 1039.26 406.119 1039.2 406.529C1039.18 406.679 1039.17 406.809 1039.16 406.929C1038.99 407.459 1038.89 408.119 1038.85 408.739L1038.89 408.729Z",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.87 408.409C1052.75 407.329 1052.63 406.889 1052.54 406.579C1052.45 406.269 1052.38 406.079 1052.3 405.839C1052.22 405.599 1052.14 405.309 1052 404.969C1051.87 404.629 1051.68 404.249 1051.47 403.889C1051.26 403.529 1051.01 403.199 1050.71 402.889C1050.41 402.579 1050.06 402.299 1049.8 402.119C1049.54 401.939 1049.38 401.859 1049.19 401.769C1049 401.679 1048.78 401.579 1048.57 401.529C1048.37 401.489 1048.18 401.499 1047.96 401.549C1047.74 401.599 1047.5 401.689 1047.3 401.779C1047.1 401.869 1046.96 401.969 1046.71 402.189C1046.46 402.419 1046.11 402.779 1045.15 404.069",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.02 401.159C1047.9 401.049 1047.79 400.989 1047.68 400.949C1047.58 400.909 1047.48 400.879 1047.36 400.849C1047.24 400.819 1047.1 400.789 1046.95 400.769C1046.8 400.749 1046.64 400.729 1046.42 400.729C1046.2 400.729 1045.94 400.719 1045.68 400.729C1045.42 400.739 1045.17 400.759 1044.93 400.789C1044.69 400.819 1044.47 400.859 1044.24 400.919C1044.01 400.979 1043.77 401.069 1043.52 401.189C1043.27 401.309 1043.02 401.449 1042.8 401.589C1042.58 401.729 1042.4 401.869 1042.19 402.069C1041.98 402.269 1041.73 402.559 1041.49 402.949C1041.25 403.339 1041.01 403.829 1040.83 404.269C1040.64 404.709 1040.5 405.109 1040.37 405.819C1040.23 406.529 1040.1 407.549 1040.04 408.249C1039.98 408.949 1039.99 409.339 1039.98 409.729C1039.96 410.129 1039.92 410.529 1039.59 411.249",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.31 401.969C1041.6 402.339 1041.21 402.689 1040.88 403.039C1040.55 403.389 1040.28 403.729 1040.06 404.069C1039.84 404.409 1039.68 404.729 1039.54 405.159C1039.4 405.589 1039.29 406.109 1039.23 406.519C1039.17 406.929 1039.17 407.219 1039.19 407.589C1039.2 407.969 1039.23 408.429 1039.22 408.949C1039.21 409.459 1039.16 410.029 1039.02 410.389",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.88 409.59C1038.84 408.77 1038.95 407.72 1039.2 406.92",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.81 401.009C1047.23 400.909 1046.94 400.929 1046.67 401.009C1046.39 401.089 1046.12 401.239 1045.86 401.479C1045.6 401.719 1045.36 402.069 1045.19 402.319C1045.03 402.569 1044.94 402.729 1044.83 402.999C1044.72 403.269 1044.58 403.629 1044.45 404.099C1044.32 404.559 1044.2 405.119 1044.13 405.729C1044.06 406.339 1044.03 407.029 1044.02 408.099C1044.01 409.169 1044.02 410.639 1044.02 411.689",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.22 401.778C1048.92 401.508 1048.72 401.398 1048.54 401.318C1048.36 401.238 1048.2 401.188 1048.07 401.168C1048.05 401.168 1048.03 401.168 1048.01 401.158",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.22 408C1048.44 408.25 1048.74 408.91 1048.96 409.46C1049.18 410.01 1049.33 410.44 1049.36 410.71",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.05 408.199C1046.88 408.509 1046.73 409.049 1046.64 409.449C1046.55 409.849 1046.51 410.109 1046.48 410.309C1046.45 410.509 1046.43 410.659 1046.43 410.799C1046.43 410.939 1046.45 411.079 1046.62 411.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.36 410.709C1048.66 410.949 1048.3 411.009 1047.95 411.049C1047.61 411.089 1047.28 411.119 1046.61 411.209",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.62 411.209C1046.7 410.539 1046.83 409.699 1047.01 408.689",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.15 409.078C1051.21 409.798 1051.25 409.868 1051.32 409.938C1051.39 409.998 1051.5 410.048 1052.7 409.178",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 408.549C1052.59 408.579 1052.63 408.589 1052.65 408.639C1052.68 408.689 1052.68 408.769 1052.69 409.179",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 408.549L1051.15 409.079",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.76 407.59C1052.76 407.59 1052.78 407.6 1052.8 407.61C1053.13 407.77 1053.25 407.86 1053.33 407.93C1053.41 408 1053.44 408.05 1053.47 408.11C1053.5 408.17 1053.51 408.23 1053.52 408.34C1053.52 408.45 1053.52 408.6 1053.51 408.72C1053.5 408.84 1053.48 408.93 1053.44 409.01C1053.41 409.09 1053.36 409.16 1053.3 409.24C1053.24 409.32 1053.18 409.4 1052.69 409.74",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.46 422.939C1049.02 423.099 1048.43 423.119 1047.97 423.029C1047.51 422.939 1047.16 422.749 1047.01 422.489C1046.9 422.299 1046.9 422.069 1046.78 421.919C1046.66 421.759 1046.42 421.679 1046.3 421.519C1046.2 421.389 1046.17 421.219 1046.08 421.189C1045.97 421.149 1045.79 421.269 1045.61 421.299C1045.41 421.329 1045.22 421.259 1045.03 421.099C1044.82 420.929 1044.6 420.669 1044.61 420.489C1044.61 420.349 1044.75 420.269 1044.87 420.109C1045.05 419.859 1045.16 419.419 1045.26 418.959C1045.38 418.389 1045.49 417.789 1045.43 417.109C1045.36 416.319 1045.06 415.439 1044.61 414.849C1044.35 414.519 1044.12 414.039 1043.83 413.779",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.86 413.309C1046.07 413.919 1046.27 414.409 1046.46 414.819C1046.61 415.139 1046.74 415.419 1046.98 415.669C1047.25 415.949 1047.65 416.199 1048.1 416.409C1048.61 416.649 1049.18 416.839 1049.57 417.439C1050.15 418.319 1050.34 420.099 1050.32 421.259",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.72 418.039C1058.53 417.639 1058.29 417.309 1058.03 416.919C1057.76 416.519 1057.47 416.059 1057.02 415.919C1056.44 415.739 1055.59 416.069 1054.82 416.499C1053.86 417.029 1053.02 417.709 1052.15 418.719C1051.02 420.029 1049.82 421.889 1049.17 423.719",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.16 415.929C1055.74 415.459 1055.3 414.939 1054.93 414.499C1054.62 414.119 1054.36 413.799 1054.09 413.439",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.81 465.9C1069.4 467.14 1068.95 468.28 1068.15 469.46C1067.22 470.83 1065.81 472.24 1064.68 473.46C1063.81 474.41 1063.11 475.24 1062.84 476.05C1062.63 476.68 1062.69 477.3 1062.43 477.94C1062.09 478.79 1061.2 479.7 1060.51 480.75C1059.77 481.89 1059.27 483.21 1058.84 484.34C1058.45 485.37 1058.11 486.24 1057.89 487.47C1057.64 488.88 1057.54 490.75 1057.62 491.71C1057.66 492.17 1057.74 492.42 1057.67 492.68C1057.6 492.91 1057.41 493.16 1057.4 493.39C1057.39 493.64 1057.59 493.88 1057.72 494.19C1057.92 494.67 1057.98 495.31 1058.12 496.15C1058.39 497.81 1058.98 500.23 1059.29 503.79C1059.72 508.74 1059.62 515.88 1058.93 518.68C1058.65 519.81 1058.28 520.23 1058.13 520.97C1057.98 521.76 1058.09 522.9 1058.15 523.71C1058.19 524.22 1058.2 524.6 1057.96 524.81C1057.61 525.11 1056.71 525.05 1055.62 524.83C1053.98 524.49 1051.92 523.77 1050.64 523.11C1049.93 522.74 1049.47 522.39 1049.51 521.95C1049.56 521.44 1050.27 520.81 1050.5 520.07C1050.75 519.29 1050.45 518.4 1050.61 517.68C1050.75 517.02 1051.27 516.5 1051.53 515.91C1051.78 515.34 1051.79 514.7 1051.75 514.03C1051.7 513.27 1051.59 512.47 1051.48 511.55C1051.33 510.35 1051.17 508.93 1051.08 507.38C1050.98 505.7 1050.97 503.87 1050.67 502.5C1050.46 501.53 1050.1 500.78 1050.05 500.15C1050.01 499.69 1050.14 499.29 1049.99 498.86C1049.82 498.39 1049.29 497.88 1049.08 497.52C1048.96 497.3 1048.95 497.14 1048.86 496.98C1048.73 496.76 1048.43 496.54 1048.16 496.17C1047.72 495.54 1047.37 494.47 1047.06 493.39C1046.73 492.22 1046.43 491.03 1046.34 490.02C1046.26 489.1 1046.37 488.34 1046.55 487.19C1046.81 485.49 1047.24 482.95 1047.23 481.02C1047.23 479.54 1046.96 478.41 1047.02 477.38C1047.08 476.47 1047.39 475.65 1047.59 474.61C1047.85 473.29 1047.93 471.62 1048.13 470.01C1048.33 468.34 1048.66 466.73 1048.99 465.1",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.81 524.91C1057.95 525.36 1058.03 525.73 1058.11 526.29C1058.2 526.98 1058.29 527.96 1058.11 528.41C1058.01 528.66 1057.83 528.75 1057.59 528.82C1057.12 528.94 1056.42 528.96 1055.1 528.96C1052.21 528.97 1046.35 528.94 1042.98 528.96C1041.23 528.96 1040.15 528.99 1039.78 528.33C1039.49 527.81 1039.63 526.87 1039.92 526.33C1040.16 525.88 1040.5 525.7 1041.08 525.54C1042.1 525.26 1043.85 525.04 1045.4 524.6C1047.03 524.13 1048.44 523.42 1049.84 522.59",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.71 473.43C1064.44 474.03 1064.19 474.52 1063.99 475.97C1063.71 478.03 1063.52 482.01 1063.09 484.32C1062.72 486.29 1062.17 487.05 1061.69 487.73C1061.29 488.28 1060.93 488.78 1060.93 489.43C1060.93 490.22 1061.43 491.23 1061.46 492.07C1061.48 492.78 1061.17 493.36 1061.12 493.94C1061.07 494.52 1061.29 495.09 1061.48 495.82C1061.77 496.93 1061.99 498.42 1062.24 500.15C1062.59 502.56 1063.01 505.43 1063.15 508.6C1063.3 511.95 1063.15 515.64 1063.2 518.06C1063.23 519.46 1063.32 520.44 1063.1 521.23C1062.93 521.83 1062.58 522.32 1062.55 522.96C1062.52 523.59 1062.8 524.36 1062.56 524.75C1062.33 525.13 1061.62 525.17 1060.96 525.19C1060.23 525.21 1059.56 525.21 1058.01 524.76",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.51 524.828C1062.69 525.498 1062.69 526.198 1062.68 526.888C1062.68 527.498 1062.66 528.098 1062.27 528.448C1061.77 528.898 1060.64 528.908 1059.59 528.928C1058.51 528.948 1057.5 528.978 1056.15 528.948",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 451.809C1042.74 452.459 1041.72 453.109 1040.71 453.979C1039.85 454.719 1039.01 455.639 1038.25 456.359C1037.75 456.839 1037.28 457.229 1036.88 457.689C1036.41 458.229 1036.05 458.859 1035.82 459.479C1035.61 460.049 1035.53 460.619 1035.26 460.979C1035.21 461.039 1035.16 461.099 1035.1 461.149",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.04 432.639C1056.56 433.389 1056.03 434.349 1055.75 434.979C1055.55 435.439 1055.48 435.719 1055.21 436.269C1054.71 437.269 1053.53 439.169 1053.14 440.429C1052.89 441.239 1052.96 441.789 1052.84 442.319C1052.72 442.839 1052.41 443.329 1052.06 443.969C1051.58 444.829 1051.03 445.949 1050.53 446.959C1050.06 447.919 1049.65 448.799 1049.12 449.619C1048.6 450.419 1047.97 451.159 1047.05 451.569C1046.09 451.999 1044.81 452.059 1043.94 451.809C1043.21 451.599 1042.75 451.159 1042.01 450.619C1041.13 449.979 1039.85 449.189 1039.51 448.469C1039.27 447.959 1039.5 447.499 1039.85 446.969C1040.27 446.339 1040.88 445.629 1041.61 445.109C1042.33 444.599 1043.16 444.279 1043.34 443.789C1043.48 443.399 1043.23 442.899 1043.37 442.529C1043.52 442.149 1044.1 441.909 1044.36 441.599C1044.57 441.349 1044.56 441.049 1044.59 440.739C1044.62 440.379 1044.7 439.989 1044.89 439.549C1045.14 438.959 1045.58 438.259 1045.65 437.559C1045.72 436.899 1045.45 436.259 1045.52 435.669C1045.59 435.119 1045.96 434.629 1046.08 434.129C1046.18 433.709 1046.11 433.289 1046.19 432.979C1046.25 432.729 1046.41 432.559 1046.48 432.299C1046.57 431.909 1046.45 431.309 1046.42 430.629C1046.38 429.759 1046.5 428.739 1046.6 427.889C1046.68 427.149 1046.75 426.529 1047.14 425.889C1047.65 425.049 1048.7 424.159 1049.53 423.379C1050.32 422.619 1050.89 421.959 1051.84 421.179C1053.04 420.189 1054.85 418.999 1056.2 418.359C1057.08 417.939 1057.77 417.759 1058.4 417.929C1059.08 418.119 1059.68 418.719 1060.58 419.459C1061.95 420.579 1064 421.999 1065.32 423.519C1066.61 425.009 1067.2 426.599 1067.77 429.029C1068.62 432.609 1069.44 438.019 1069.79 441.949C1070.04 444.729 1070.04 446.779 1069.97 448.509C1069.91 449.999 1069.78 451.259 1069.97 453.379C1070.24 456.449 1071.16 461.319 1071.72 463.439C1071.94 464.279 1072.11 464.689 1071.85 465.049C1071.5 465.519 1070.39 465.909 1069.18 466.019C1067.42 466.179 1065.43 465.769 1063.26 465.099C1060.87 464.359 1058.27 463.309 1056.28 463.019C1054.73 462.789 1053.54 463.019 1051.95 463.719C1050.4 464.409 1048.48 465.549 1048.13 465.369C1047.95 465.279 1048.18 464.839 1048.34 464.289C1048.61 463.309 1048.62 461.989 1048.82 460.889C1048.99 459.919 1049.3 459.129 1049.31 458.279C1049.33 457.349 1049 456.369 1048.86 455.129C1048.68 453.509 1048.83 451.459 1049.14 449.659",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.76 461.158C1028.4 460.338 1029.35 459.028 1029.8 458.188C1030.12 457.588 1030.19 457.238 1030.53 456.848C1030.94 456.388 1031.74 455.898 1032.18 455.558C1032.46 455.338 1032.6 455.178 1032.79 455.038C1033.09 454.818 1033.54 454.628 1033.99 454.358C1034.53 454.028 1035.08 453.588 1035.83 452.748C1036.66 451.818 1037.75 450.398 1038.54 449.468C1038.91 449.038 1039.22 448.718 1039.51 448.408",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.72 415.62C1048.07 415.57 1048.47 415.56 1048.72 415.24C1049.13 414.72 1049.14 413.34 1048.83 412.35C1048.78 412.2 1048.73 412.05 1048.67 411.92",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.06 411.72C1049.06 411.72 1049.11 411.75 1049.14 411.76C1049.7 412.08 1050.72 413.06 1051.46 413.6C1051.95 413.97 1052.31 414.13 1052.71 414.07C1053.09 414 1053.5 413.73 1053.8 413.58C1053.99 413.49 1054.14 413.45 1054.17 413.3C1054.23 413.02 1053.86 412.37 1053.62 411.71C1053.36 411 1053.23 410.28 1052.97 409.52",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.28 413.539C1040.38 414.679 1040.9 415.889 1041.42 416.599C1041.77 417.079 1042.13 417.319 1042.42 417.499C1042.62 417.619 1042.78 417.709 1042.89 417.899C1043.05 418.169 1043.08 418.639 1043.06 419.199C1043.04 419.819 1042.96 420.549 1043.28 420.769C1043.57 420.969 1044.21 420.719 1044.61 420.499",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.14 528.949C1055.84 528.949 1055.5 528.949 1055.1 528.959C1052.21 528.969 1046.35 528.939 1042.98 528.959C1041.23 528.959 1040.15 528.989 1039.78 528.329C1039.49 527.809 1039.63 526.869 1039.92 526.329C1040.16 525.879 1040.5 525.699 1041.08 525.539C1042.1 525.259 1043.85 525.039 1045.4 524.599C1047.03 524.129 1048.44 523.419 1049.84 522.589C1049.62 522.389 1049.5 522.179 1049.52 521.949C1049.57 521.439 1050.28 520.809 1050.51 520.069C1050.76 519.289 1050.46 518.399 1050.62 517.679C1050.76 517.019 1051.28 516.499 1051.54 515.909C1051.79 515.339 1051.8 514.699 1051.76 514.029C1051.71 513.269 1051.6 512.469 1051.49 511.549C1051.34 510.349 1051.18 508.929 1051.09 507.379C1050.99 505.699 1050.98 503.869 1050.68 502.499C1050.47 501.529 1050.11 500.779 1050.06 500.149C1050.02 499.689 1050.15 499.289 1050 498.859C1049.83 498.389 1049.3 497.879 1049.09 497.519C1048.97 497.299 1048.96 497.139 1048.87 496.979C1048.74 496.759 1048.44 496.539 1048.17 496.169C1047.73 495.539 1047.38 494.469 1047.07 493.389C1046.74 492.219 1046.44 491.029 1046.35 490.019C1046.27 489.099 1046.38 488.339 1046.56 487.189C1046.82 485.489 1047.25 482.949 1047.24 481.019C1047.24 479.539 1046.97 478.409 1047.03 477.379C1047.09 476.469 1047.4 475.649 1047.6 474.609C1047.86 473.289 1047.95 471.619 1048.14 470.009C1048.34 468.339 1048.67 466.729 1049 465.099C1048.56 465.289 1048.23 465.399 1048.11 465.339C1047.93 465.249 1048.16 464.809 1048.32 464.259C1048.59 463.279 1048.6 461.959 1048.8 460.859C1048.97 459.889 1049.28 459.099 1049.29 458.249C1049.31 457.319 1048.98 456.339 1048.84 455.099C1048.66 453.479 1048.81 451.429 1049.12 449.629C1048.6 450.429 1047.97 451.169 1047.05 451.579C1046.1 451.999 1044.85 452.069 1043.98 451.829C1042.72 452.479 1041.69 453.129 1040.69 453.999C1039.83 454.739 1038.99 455.659 1038.23 456.379C1037.73 456.859 1037.26 457.249 1036.86 457.709C1036.39 458.249 1036.03 458.879 1035.8 459.499C1035.59 460.069 1035.51 460.639 1035.24 460.999C1035.19 461.059 1035.14 461.119 1035.08 461.169H1042.31V463.729H1022.34V461.169H1028.75C1028.39 460.349 1029.34 459.039 1029.79 458.199C1030.11 457.599 1030.18 457.249 1030.52 456.859C1030.93 456.399 1031.73 455.909 1032.17 455.569C1032.45 455.349 1032.59 455.189 1032.78 455.049C1033.08 454.829 1033.53 454.639 1033.98 454.369C1034.52 454.039 1035.07 453.599 1035.82 452.759C1036.65 451.829 1037.74 450.409 1038.53 449.479C1038.9 449.049 1039.21 448.729 1039.5 448.419C1039.3 447.929 1039.52 447.479 1039.87 446.969C1040.29 446.339 1040.9 445.629 1041.63 445.109C1042.35 444.599 1043.18 444.279 1043.36 443.789C1043.5 443.399 1043.25 442.899 1043.39 442.529C1043.54 442.149 1044.12 441.909 1044.38 441.599C1044.59 441.349 1044.58 441.049 1044.61 440.739C1044.64 440.379 1044.72 439.989 1044.91 439.549C1045.16 438.959 1045.6 438.259 1045.67 437.559C1045.74 436.899 1045.47 436.259 1045.54 435.669C1045.61 435.119 1045.98 434.629 1046.1 434.129C1046.2 433.709 1046.13 433.289 1046.21 432.979C1046.27 432.729 1046.43 432.559 1046.5 432.299C1046.59 431.909 1046.47 431.309 1046.44 430.629C1046.4 429.759 1046.52 428.739 1046.61 427.889C1046.69 427.149 1046.76 426.529 1047.15 425.889C1047.58 425.179 1048.41 424.429 1049.16 423.729C1049.25 423.469 1049.35 423.209 1049.46 422.959C1049.02 423.119 1048.43 423.139 1047.97 423.049C1047.51 422.959 1047.16 422.769 1047.01 422.509C1046.9 422.319 1046.9 422.089 1046.78 421.939C1046.66 421.779 1046.42 421.699 1046.3 421.539C1046.2 421.409 1046.17 421.239 1046.08 421.209C1045.97 421.169 1045.79 421.289 1045.61 421.319C1045.41 421.349 1045.22 421.279 1045.03 421.119C1044.82 420.949 1044.6 420.689 1044.61 420.509C1044.21 420.729 1043.58 420.979 1043.28 420.779C1042.96 420.569 1043.04 419.829 1043.06 419.209C1043.08 418.639 1043.05 418.179 1042.89 417.909C1042.78 417.729 1042.62 417.629 1042.42 417.509C1042.13 417.329 1041.77 417.089 1041.42 416.609C1040.9 415.909 1040.38 414.689 1040.28 413.549C1040.08 413.519 1039.88 413.499 1039.71 413.469C1038.99 413.359 1038.56 413.269 1038.25 413.159C1037.94 413.049 1037.74 412.929 1037.6 412.819C1037.46 412.709 1037.38 412.599 1037.32 412.459C1037.26 412.329 1037.22 412.169 1037.21 411.989C1037.21 411.809 1037.24 411.619 1037.31 411.369C1037.38 411.119 1037.48 410.799 1037.59 410.539C1037.7 410.279 1037.81 410.089 1038.01 409.799C1038.21 409.509 1038.49 409.109 1038.83 408.789C1038.85 408.769 1038.86 408.759 1038.88 408.739C1038.92 408.119 1039.02 407.469 1039.19 406.929C1039.19 406.799 1039.21 406.669 1039.23 406.529C1039.29 406.119 1039.4 405.599 1039.54 405.169C1039.68 404.739 1039.84 404.419 1040.06 404.079C1040.28 403.739 1040.55 403.399 1040.88 403.049C1041.21 402.699 1041.59 402.359 1042.31 401.979C1042.48 401.819 1042.63 401.709 1042.82 401.589C1043.04 401.449 1043.29 401.299 1043.54 401.189C1043.79 401.069 1044.03 400.979 1044.26 400.919C1044.49 400.859 1044.71 400.819 1044.95 400.789C1045.19 400.759 1045.44 400.739 1045.7 400.729C1045.96 400.719 1046.23 400.729 1046.44 400.729C1046.65 400.729 1046.82 400.749 1046.97 400.769C1047.12 400.789 1047.26 400.819 1047.38 400.849C1047.5 400.879 1047.59 400.909 1047.7 400.949C1047.74 400.969 1047.78 400.989 1047.83 401.009C1047.9 401.049 1047.96 401.089 1048.04 401.159C1048.06 401.159 1048.08 401.159 1048.1 401.169C1048.23 401.199 1048.39 401.239 1048.57 401.319C1048.75 401.399 1048.95 401.509 1049.25 401.779C1049.43 401.869 1049.59 401.949 1049.84 402.119C1050.1 402.299 1050.45 402.579 1050.75 402.889C1051.05 403.199 1051.29 403.529 1051.51 403.889C1051.72 404.249 1051.91 404.629 1052.04 404.969C1052.17 405.309 1052.26 405.599 1052.34 405.839C1052.42 406.079 1052.48 406.269 1052.58 406.579C1052.65 406.799 1052.73 407.069 1052.81 407.579C1052.82 407.579 1052.83 407.589 1052.85 407.599C1053.18 407.759 1053.3 407.849 1053.38 407.919C1053.46 407.989 1053.49 408.039 1053.52 408.099C1053.55 408.159 1053.56 408.219 1053.57 408.329C1053.57 408.439 1053.57 408.589 1053.56 408.709C1053.55 408.829 1053.53 408.919 1053.49 408.999C1053.46 409.079 1053.41 409.149 1053.35 409.229C1053.31 409.289 1053.26 409.349 1053.02 409.529C1053.28 410.289 1053.41 411.009 1053.67 411.719C1053.91 412.379 1054.28 413.029 1054.22 413.309C1054.21 413.369 1054.18 413.409 1054.14 413.439C1054.8 414.299 1055.49 415.129 1056.21 415.929C1056.53 415.849 1056.82 415.839 1057.06 415.909C1057.52 416.049 1057.8 416.509 1058.07 416.909C1058.33 417.299 1058.58 417.629 1058.76 418.029C1059.32 418.289 1059.87 418.819 1060.62 419.439C1061.99 420.559 1064.04 421.979 1065.36 423.499C1066.65 424.989 1067.24 426.579 1067.81 429.009C1068.66 432.589 1069.48 437.999 1069.83 441.929C1070.08 444.709 1070.08 446.759 1070 448.489C1069.94 449.979 1069.81 451.239 1070 453.359C1070.27 456.429 1071.19 461.299 1071.75 463.419C1071.97 464.259 1072.14 464.669 1071.88 465.029C1071.59 465.419 1070.8 465.749 1069.85 465.919C1069.44 467.159 1068.99 468.299 1068.19 469.479C1067.27 470.839 1065.87 472.239 1064.75 473.459C1064.48 474.059 1064.23 474.549 1064.03 475.999C1063.75 478.059 1063.56 482.039 1063.13 484.349C1062.76 486.319 1062.21 487.079 1061.73 487.759C1061.33 488.309 1060.97 488.809 1060.97 489.459C1060.97 490.249 1061.47 491.259 1061.5 492.099C1061.52 492.809 1061.21 493.389 1061.16 493.969C1061.11 494.549 1061.33 495.119 1061.52 495.849C1061.81 496.959 1062.03 498.449 1062.28 500.179C1062.63 502.589 1063.05 505.459 1063.19 508.629C1063.34 511.979 1063.19 515.669 1063.24 518.089C1063.27 519.489 1063.36 520.469 1063.14 521.259C1062.97 521.859 1062.62 522.349 1062.59 522.989C1062.56 523.619 1062.84 524.389 1062.6 524.779C1062.58 524.809 1062.57 524.829 1062.54 524.859C1062.72 525.529 1062.72 526.229 1062.71 526.919C1062.71 527.529 1062.69 528.129 1062.3 528.479C1061.8 528.929 1060.67 528.939 1059.62 528.959C1058.54 528.979 1057.53 529.009 1056.18 528.979L1056.14 528.949Z",
    stroke: "#2E24B6",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_1627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1485.52,
    height: 1058.22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteBuilt);
export default __webpack_public_path__ + "static/media/siteBuilt.1ffc5c17567bae748b660508ab046112.svg";
export { ForwardRef as ReactComponent };